class EnrollPopup extends HTMLElement {
    constructor() {
        super();
        this.handleCloseButtonClick = () => this.close();
        this.handleStepClick = this.handleStepClick.bind(this);
    }

    connectedCallback() {
        this.cacheElements();
        this.bindEvents();
    }

    disconnectedCallback() {
        this.closeButton?.removeEventListener('click', this.handleCloseButtonClick);
        this.headerSteps?.forEach((step) => {
            step.removeEventListener('click', this.handleStepClick);
        });
    }

    cacheElements() {
        this.closeButton = this.querySelector('.product-enroll-popup__close');
        this.content = this.querySelector('.product-enroll-popup__content');
        this.steps = this.querySelectorAll('.popup-step');
        this.headerSteps = this.querySelectorAll('.step');
    }

    bindEvents() {
        this.closeButton?.removeEventListener('click', this.handleCloseButtonClick);
        this.closeButton?.addEventListener('click', this.handleCloseButtonClick);
        this.headerSteps.forEach((step) => {
            step.removeEventListener('click', this.handleStepClick);
            step.addEventListener('click', this.handleStepClick);
        });
    }

    open() {
        this.classList.add('click-button-active');
        document.documentElement.classList.add('product-enroll-popup-open');
        document.body.classList.add('product-enroll-popup-open');
    }

    close() {
        this.classList.remove('click-button-active');
        document.documentElement.classList.remove('product-enroll-popup-open');
        document.body.classList.remove('product-enroll-popup-open');
    }

    goToStep(stepNumber) {
        this.steps.forEach((step) => {
            step.classList.remove('popup-step--active');
        });

        this.headerSteps.forEach((step) => {
            step.classList.remove('step--active', 'step--completed');
        });

        this.querySelector(`.popup-step[data-step="${stepNumber}"]`).classList.add('popup-step--active');
        this.querySelector(`.step[data-step="${stepNumber}"]`).classList.add('step--active');

        for (let i = 1; i < stepNumber; i++) {
            this.querySelector(`.step[data-step="${i}"]`).classList.add('step--completed');
        }

        this.classList.toggle('step-1-active', stepNumber === 1);
        this.classList.toggle('step-2-active', stepNumber === 2);
        this.classList.toggle('step-3-active', stepNumber === 3);
        this.classList.toggle('step-4-active', stepNumber === 4);
    }

    handleStepClick(event) {
        const step = event.currentTarget;
        const stepNumero = parseInt(step.dataset.step);
        const stepAtual = this.querySelector('.step--active');
        const stepAtualNumero = parseInt(stepAtual.dataset.step);

        // Só permite voltar (não avançar)
        if (stepNumero < stepAtualNumero) {
            irParaStep(stepNumero);
        }

        // Opcional: adicionar cursor pointer nos steps completados
        if (step.classList.contains('step--completed')) {
            step.style.cursor = 'pointer';
        }
    }
}

if (!customElements.get('enroll-popup')) {
    customElements.define('enroll-popup', EnrollPopup);
}

// ========================================
// VARIANTES (processadas pelo Liquid)
// ========================================

const enrollPopupConfigElement = document.querySelector('[data-enroll-popup-config]');
let enrollPopupLiquidConfig = {};

if (enrollPopupConfigElement) {
    try {
        enrollPopupLiquidConfig = JSON.parse(enrollPopupConfigElement.textContent || '{}');
    } catch (error) {
        console.error('Enroll Popup: erro ao ler configuração Liquid.', error);
    }
}

const initialProductConfig = enrollPopupLiquidConfig.product || {};
const initialPoloPageContext = enrollPopupLiquidConfig.poloPageContext || {};
const ORIGIN_POLO_STORAGE_KEY = 'celso_origin_polo';
const ORIGIN_POLO_QUERY_PARAM = 'origin';
const ORIGIN_POLO_QUERY_VALUE = 'polo_search';

if (initialPoloPageContext.poloId) {
    window.CelsoPoloContext = Object.assign({}, window.CelsoPoloContext || {}, initialPoloPageContext);
} else {
    window.CelsoPoloContext = window.CelsoPoloContext || {};
}

let optionNames = Array.isArray(initialProductConfig.optionNames) ? initialProductConfig.optionNames.slice() : [];
let todasVariantes = Array.isArray(initialProductConfig.variants) ? initialProductConfig.variants.slice() : [];
let variantesCatalogo = Array.isArray(initialProductConfig.variants) ? initialProductConfig.variants.slice() : [];
let precoBaseServidor = Number(initialProductConfig.precoBase || 0);
let precoBase = precoBaseServidor;
let activeProductId = initialProductConfig.productId ? String(initialProductConfig.productId) : null;
let activeProductFormacao = initialProductConfig.formacao || '';
let activeProductArea = initialProductConfig.area || '';
let activeProductTitle = initialProductConfig.productTitle || '';
let activeProductHandle = initialProductConfig.productHandle || '';
let turnoObrigatorio = false;
let aggregatedPolosMap = new Map();
let usaPolosMetafield = false;
let activePoloFilter = null;

const priceNoticeElement = document.querySelector('[data-price-notice]');
const priceNoticeTextElement = document.querySelector('[data-price-notice-text]');
const availabilityMessageElement = document.querySelector('[data-availability-message]');
const availabilityMessageTextElement = availabilityMessageElement?.querySelector('.form-availability-message__text');
const turnoContainerElement = document.querySelector('[data-turno-container]');
const turnoButtonsElement = document.querySelector('[data-turno-buttons]');

const PHONE_REQUIRED_DIGITS = 11;
const PHONE_MAIN_NUMBER_DIGITS = 9;
const PHONE_VISIBLE_MAX_LENGTH = 15;
const VALID_BRAZIL_DDDS = new Set([
    '11', '12', '13', '14', '15', '16', '17', '18', '19',
    '21', '22', '24', '27', '28',
    '31', '32', '33', '34', '35', '37', '38',
    '41', '42', '43', '44', '45', '46',
    '47', '48', '49',
    '51', '53', '54', '55',
    '61', '62', '63', '64', '65', '66', '67', '68', '69',
    '71', '73', '74', '75', '77', '79',
    '81', '82', '83', '84', '85', '86', '87', '88', '89',
    '91', '92', '93', '94', '95', '96', '97', '98', '99',
]);

const ENROLL_OPTION_LABELS = {
    polo: 'Polo',
    turno: 'Turno',
    formaIngresso: 'Forma de Ingresso',
    modalidade: 'Modalidade'
};

const OPTION_INDEX_CACHE = {};
const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const DATE_ONLY_SLASH_PATTERN = /^(\d{4})\/(\d{2})\/(\d{2})$/;
const BR_DATE_ONLY_PATTERN = /^(\d{2})\/(\d{2})\/(\d{4})$/;
const BR_DATE_DASH_PATTERN = /^(\d{2})-(\d{2})-(\d{4})$/;
const BR_SHORT_YEAR_DATE_PATTERN = /^(\d{2})[\/-](\d{2})[\/-](\d{2})$/;
const BR_MONTH_NAME_DATE_PATTERN = /^(\d{1,2})\s+de\s+([a-zç]+)(?:\s+de\s+(\d{2,4}))?$/i;
const BR_MONTH_INDEX = {
    janeiro: '01',
    fevereiro: '02',
    marco: '03',
    março: '03',
    abril: '04',
    maio: '05',
    junho: '06',
    julho: '07',
    agosto: '08',
    setembro: '09',
    outubro: '10',
    novembro: '11',
    dezembro: '12'
};

function normalizeOptionLabel(value) {
    return (value || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
}

function getOptionAliases(optionName) {
    const normalizedName = normalizeOptionLabel(optionName);
    switch (normalizedName) {
        case normalizeOptionLabel(ENROLL_OPTION_LABELS.formaIngresso):
            return [
                normalizeOptionLabel(ENROLL_OPTION_LABELS.formaIngresso),
                'ingresso',
                'forma ingresso',
                'forma de ingresso'
            ];
        case normalizeOptionLabel(ENROLL_OPTION_LABELS.modalidade):
            return [
                normalizeOptionLabel(ENROLL_OPTION_LABELS.modalidade)
            ];
        case normalizeOptionLabel(ENROLL_OPTION_LABELS.turno):
            return [
                normalizeOptionLabel(ENROLL_OPTION_LABELS.turno)
            ];
        case normalizeOptionLabel(ENROLL_OPTION_LABELS.polo):
            return [
                normalizeOptionLabel(ENROLL_OPTION_LABELS.polo),
                'campus'
            ];
        default:
            return [normalizedName];
    }
}

function isPlainObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}

function normalizePoloId(value) {
    if (value === null || typeof value === 'undefined') return '';
    return String(value).trim();
}

function normalizePoloFilter(input) {
    if (!input) return null;

    let rawId = input;
    if (isPlainObject(input)) {
        const nestedPolo = isPlainObject(input.polo) ? input.polo : null;
        rawId = input.poloId ?? input.id_polo ?? input.id ?? nestedPolo?.poloId ?? nestedPolo?.id_polo ?? nestedPolo?.id ?? '';
    }

    const id = normalizePoloId(rawId);
    return id ? { poloId: id } : null;
}

function getDefaultPoloFilter() {
    if (typeof window === 'undefined') return null;
    return normalizePoloFilter(window.CelsoPoloContext || null);
}

function setActivePoloFilter(input) {
    if (isPlainObject(input) && (input.ignorePoloContext === true || input.usePagePolo === false)) {
        activePoloFilter = null;
        return activePoloFilter;
    }

    activePoloFilter = normalizePoloFilter(input) || getDefaultPoloFilter();
    return activePoloFilter;
}

function hasActivePoloFilter() {
    return Boolean(activePoloFilter && activePoloFilter.poloId);
}

function getActivePoloId() {
    return hasActivePoloFilter() ? activePoloFilter.poloId : '';
}

function getStoredOriginPoloEntry() {
    try {
        const raw = sessionStorage.getItem(ORIGIN_POLO_STORAGE_KEY);
        if (!raw) return null;

        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') {
            const poloId = normalizePoloId(parsed.poloId || parsed.origin_polo_id || parsed.id || '');
            return poloId ? Object.assign({}, parsed, { poloId }) : null;
        }

        const poloId = normalizePoloId(parsed);
        return poloId ? { poloId } : null;
    } catch (error) {
        return null;
    }
}

function getStoredOriginPoloId() {
    const entry = getStoredOriginPoloEntry();
    return entry ? entry.poloId : '';
}

function storeOriginPoloId(poloId) {
    const normalizedPoloId = normalizePoloId(poloId);
    if (!normalizedPoloId) return;

    try {
        sessionStorage.setItem(ORIGIN_POLO_STORAGE_KEY, JSON.stringify({
            poloId: normalizedPoloId,
            origin: ORIGIN_POLO_QUERY_VALUE,
            path: window.location.pathname || '',
            capturedAt: Date.now()
        }));
    } catch (error) {}
}

function captureOriginPoloFromCurrentPage() {
    const pagePoloId = normalizePoloId(initialPoloPageContext && initialPoloPageContext.poloId);
    if (!pagePoloId) return;

    try {
        const params = new URLSearchParams(window.location.search || '');
        const origin = String(params.get(ORIGIN_POLO_QUERY_PARAM) || '').trim();
        if (origin !== ORIGIN_POLO_QUERY_VALUE) return;
        storeOriginPoloId(pagePoloId);
    } catch (error) {}
}

setActivePoloFilter();
captureOriginPoloFromCurrentPage();

const MODAL_STEP_UTM_CONTENT = {
    1: 'cadastro',
    2: 'informacoes',
    3: 'dados_pessoais',
    4: 'pagamento'
};
const MODAL_ACQUISITION_UTM_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term'
];
const MODAL_URL_UTM_PARAMS = MODAL_ACQUISITION_UTM_PARAMS.concat('utm_content');
const MODAL_SESSION_UTM_PREFIX = '__session_';

let vendedorOrigemBaseUrl = '';
let modalAcquisitionUtmSnapshot = null;

function getModalStepUtmContent(step) {
    if (Object.prototype.hasOwnProperty.call(MODAL_STEP_UTM_CONTENT, step)) {
        return MODAL_STEP_UTM_CONTENT[step];
    }

    const normalizedStep = Number(step);
    if (Number.isFinite(normalizedStep) && Object.prototype.hasOwnProperty.call(MODAL_STEP_UTM_CONTENT, normalizedStep)) {
        return MODAL_STEP_UTM_CONTENT[normalizedStep];
    }

    return typeof step === 'string' ? step.trim() : '';
}

function getVendedorOrigemBaseUrl() {
    if (vendedorOrigemBaseUrl) return vendedorOrigemBaseUrl;

    try {
        if (typeof window === 'undefined' || !window.location) return '';
        vendedorOrigemBaseUrl = window.location.href || '';
    } catch (error) {
        vendedorOrigemBaseUrl = '';
    }

    return vendedorOrigemBaseUrl;
}

function montarUrlModalComUtmContent(rawUrl, step) {
    const stepUtmContent = getModalStepUtmContent(step);
    if (!rawUrl && typeof window === 'undefined') return '';

    try {
        const baseOrigin = window.location?.origin || 'https://celsolisboa.edu.br';
        const url = new URL(rawUrl || '/', baseOrigin);

        if (stepUtmContent) {
            url.searchParams.set('utm_content', stepUtmContent);
        }

        return url.href;
    } catch (error) {
        return rawUrl || '';
    }
}

function getVendedorOrigemUrl(step) {
    return montarUrlModalComUtmContent(getVendedorOrigemBaseUrl(), step);
}

function readModalUtmValuesFromUrl(url) {
    return MODAL_URL_UTM_PARAMS.reduce((values, paramName) => {
        values[paramName] = normalizeTrackingValue(url?.searchParams?.get(paramName));
        return values;
    }, {});
}

function readSessionModalUtms() {
    return MODAL_URL_UTM_PARAMS.reduce((values, paramName) => {
        try {
            values[paramName] = normalizeTrackingValue(
                window.sessionStorage.getItem(MODAL_SESSION_UTM_PREFIX + paramName)
            );
        } catch (error) {
            values[paramName] = '';
        }
        return values;
    }, {});
}

function isModalStepUtmContentValue(value) {
    const normalizedValue = normalizeTrackingValue(value).toLowerCase();
    return Object.values(MODAL_STEP_UTM_CONTENT).includes(normalizedValue);
}

function hasModalExternalUtmSignal(values) {
    const hasAcquisitionUtm = MODAL_ACQUISITION_UTM_PARAMS.some((paramName) => Boolean(values?.[paramName]));
    const utmContent = values?.utm_content || '';
    return hasAcquisitionUtm || Boolean(utmContent && !isModalStepUtmContentValue(utmContent));
}

function resolveModalAcquisitionUtms(url) {
    const urlValues = readModalUtmValuesFromUrl(url);
    if (hasModalExternalUtmSignal(urlValues)) {
        modalAcquisitionUtmSnapshot = Object.assign({}, urlValues);
        return urlValues;
    }

    if (modalAcquisitionUtmSnapshot) return modalAcquisitionUtmSnapshot;

    const sessionValues = readSessionModalUtms();
    if (hasModalExternalUtmSignal(sessionValues)) {
        modalAcquisitionUtmSnapshot = Object.assign({}, sessionValues);
        return sessionValues;
    }

    modalAcquisitionUtmSnapshot = {
        utm_source: 'shopify',
        utm_medium: 'site',
        utm_campaign: '',
        utm_term: ''
    };
    return modalAcquisitionUtmSnapshot;
}

function atualizarUtmContentModalNaUrl(step) {
    if (typeof window === 'undefined' || !window.location || !window.history?.replaceState) return;

    try {
        const urlAtual = new URL(window.location.href);
        const urlUtmValues = readModalUtmValuesFromUrl(urlAtual);
        const acquisitionUtms = resolveModalAcquisitionUtms(urlAtual);

        if (!hasModalExternalUtmSignal(urlUtmValues)) {
            MODAL_ACQUISITION_UTM_PARAMS.forEach((paramName) => {
                const paramValue = acquisitionUtms[paramName];
                if (paramValue) urlAtual.searchParams.set(paramName, paramValue);
            });
        }

        const stepUtmContent = getModalStepUtmContent(step);
        if (stepUtmContent) urlAtual.searchParams.set('utm_content', stepUtmContent);

        const urlAtualizada = urlAtual.href;
        if (urlAtualizada === window.location.href) return;

        window.history.replaceState(window.history.state, '', urlAtualizada);
    } catch (error) {}
}


async function newCustomer(data) {
  if (!data || typeof data !== 'object' || Object.keys(data).length === 0) return null;

  const nivelEnsino = activeProductFormacao || '';

  // Evita bater no backend com payload incompleto enquanto o usuário ainda está preenchendo o formulário.
  const nome = (data.nome ?? '').toString().trim();
  const email = (data.email ?? '').toString().trim();
  const celular = normalizarTelefoneParaEnvio((data.celular ?? '').toString());
  const nomeCurso = (data.nome_curso ?? data.nomeCurso ?? activeProductTitle ?? '').toString().trim();
  const stepUtmContent = getModalStepUtmContent(1);
  if (!nome || !email || !celular) return null;

  const modalTrackingPayload = buildModalTrackingPayload({
    utm_content: stepUtmContent
  });
  const body = Object.assign({}, modalTrackingPayload, {
    "nome": nome,
    "email": email,
    "celular": celular,
    "nome_curso": nomeCurso,
    "consultor": (data.consultor ?? (typeof consultor !== 'undefined' ? consultor : '')) ?? "",
    "vendedor_origem": "",
    "vendedor_origem_url": getVendedorOrigemUrl(stepUtmContent),
  });

  if (typeof nivelEnsino === 'string' && nivelEnsino.trim() !== '') {
    body["nivel_ensino"] = nivelEnsino.trim();
  }

  const encoded = encodeURIComponent(JSON.stringify(body)) + "=";

  try {
    const response = await fetch(
      "https://celsolisboa.snowlink-snk1.cloud/webhook/api/v1/celsolisboa/newCustomer",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: encoded
      }
    );

    const text = await response.text();
    try {
      return JSON.parse(text);
    } catch (e) {
      return text;
    }
  } catch (err) {
    console.error("Erro ao enviar webhook:", err);
  }
}

async function newRegisterRaw(data, options) {
  const keepalive = !!(options && options.keepalive);
  try {
    const response = await fetch(
      "https://celsolisboa.snowlink-snk1.cloud/webhook/api/v1/celsolisboa/newRegister",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        keepalive: keepalive
      }
    );

    if (keepalive) return null;

    const text = await response.text();

    let json = null;
    try {
      json = JSON.parse(text);
    } catch (e) {}

    return json ?? text;

  } catch (err) {
    console.error("Erro no webhook newRegister:", err);
    return null;
  }
}

async function newRegisterOrders(data) {
  try {
    const response = await fetch(
      "https://celsolisboa.snowlink-snk1.cloud/webhook/api/v1/celsolisboa/newRegisterOrders",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      }
    );

    const text = await response.text();

    try {
      return JSON.parse(text);
    } catch (e) {
      return text;
    }
  } catch (err) {
    console.error("Erro no webhook newRegisterOrders:", err);
    return null;
  }
}

function buildRegisterOrdersPayload() {
  sincronizarCupomMatriculaAtual();
  const stepUtmContent = getModalStepUtmContent(2);
  const modalTrackingPayload = buildModalTrackingPayload({
    utm_content: stepUtmContent
  });
  const poloIdSelecionado = resolvePoloIdSelecionado();

  return Object.assign({}, modalTrackingPayload, {
    nome: dadosMatricula.nome || '',
    email: dadosMatricula.email || '',
    celular: normalizarTelefoneParaEnvio(dadosMatricula.celular || ''),
    consultor: dadosMatricula.consultor || '',
    vendedor_origem: poloIdSelecionado,
    vendedor_origem_url: getVendedorOrigemUrl(stepUtmContent),
    nivel_ensino: dadosMatricula.nivelEnsino || '',
    formacao: modalTrackingPayload.formacao || '',
    area: modalTrackingPayload.area || '',
    curso: modalTrackingPayload.curso || '',
    modalidade: modalTrackingPayload.modalidade || '',
    codCurso: dadosMatricula.codCurso || '',
    codPolo: poloIdSelecionado || dadosMatricula.poloKey || '',
    cupom: dadosMatricula.cupomCodigo || '',
    cupom_id: dadosMatricula.cupomId || '',
    cupom_nome: dadosMatricula.cupomNome || '',
    forma_ingresso: dadosMatricula.formaIngresso || '',
    variante_sku: dadosMatricula.varianteSku || '',
    sku_polo: resolveSkuPoloSelecionado(),
    turno: dadosMatricula.turno || '',
    estado: dadosMatricula.estado || '',
    cidade: dadosMatricula.cidade || '',
    polo: dadosMatricula.polo || '',
    polo_estado: dadosMatricula.estado || '',
    polo_cidade: dadosMatricula.cidade || '',
    polo_escolhido: dadosMatricula.polo || ''
  });
}

function coerceDateString(value) {
    if (typeof value === 'string') {
        return value.trim();
    }
    if (value instanceof Date) {
        return value.toISOString();
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
        return new Date(value).toISOString();
    }
    if (isPlainObject(value)) {
        const nestedValue = value.value ?? value.date ?? value.start_date ?? value.end_date ?? null;
        if (nestedValue !== null && nestedValue !== value) {
            return coerceDateString(nestedValue);
        }
    }
    return '';
}

function normalizeTwoDigitYear(year) {
    const yearString = String(year || '').padStart(2, '0');
    if (yearString.length === 4) return yearString;
    const numericYear = Number(yearString);
    return `${numericYear >= 70 ? '19' : '20'}${yearString}`;
}

function buildDateOnlyString(year, month, day) {
    return `${normalizeTwoDigitYear(year)}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

function parseVariantDate(value, { endOfDay = false } = {}) {
    const raw = coerceDateString(value);
    if (!raw) return null;
    const normalizedRaw = raw
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
    const brDateMatch = raw.match(BR_DATE_ONLY_PATTERN) || raw.match(BR_DATE_DASH_PATTERN);
    const shortYearMatch = raw.match(BR_SHORT_YEAR_DATE_PATTERN);
    const slashIsoMatch = raw.match(DATE_ONLY_SLASH_PATTERN);
    const monthNameMatch = normalizedRaw.match(BR_MONTH_NAME_DATE_PATTERN);
    const isDateOnly = DATE_ONLY_PATTERN.test(raw) || Boolean(brDateMatch || shortYearMatch || slashIsoMatch || monthNameMatch);
    let workingValue = raw;
    if (brDateMatch) {
        const [, day, month, year] = brDateMatch;
        workingValue = `${buildDateOnlyString(year, month, day)}T00:00:00`;
    } else if (shortYearMatch) {
        const [, day, month, year] = shortYearMatch;
        workingValue = `${buildDateOnlyString(year, month, day)}T00:00:00`;
    } else if (slashIsoMatch) {
        const [, year, month, day] = slashIsoMatch;
        workingValue = `${buildDateOnlyString(year, month, day)}T00:00:00`;
    } else if (monthNameMatch) {
        const [, day, monthName, year] = monthNameMatch;
        const month = BR_MONTH_INDEX[monthName];
        if (!month) return null;
        workingValue = `${buildDateOnlyString(year || new Date().getFullYear(), month, day)}T00:00:00`;
    } else if (DATE_ONLY_PATTERN.test(raw)) {
        workingValue = `${raw}T00:00:00`;
    }
    const timestamp = Date.parse(workingValue);
    if (Number.isNaN(timestamp)) return null;
    if (isDateOnly) {
        const dateObj = new Date(timestamp);
        if (endOfDay) {
            dateObj.setHours(23, 59, 59, 999);
        } else {
            dateObj.setHours(0, 0, 0, 0);
        }
        return dateObj.getTime();
    }
    return timestamp;
}

function enrichVariantData(variant) {
    if (!variant || typeof variant !== 'object') return variant;
    const startRaw = coerceDateString(variant.start_date);
    const endRaw = coerceDateString(variant.end_date);
    const polosData = extractVariantPolos(variant);
    return Object.assign({}, variant, {
        start_date: startRaw || null,
        end_date: endRaw || null,
        startDateMs: parseVariantDate(startRaw),
        endDateMs: parseVariantDate(endRaw, { endOfDay: true }),
        polosData
    });
}

function getVariantDateMs(variant, rawFieldName, parsedFieldName, options = {}) {
    if (!variant || typeof variant !== 'object') return null;
    if (typeof variant[parsedFieldName] === 'number') {
        return variant[parsedFieldName];
    }
    const parsed = parseVariantDate(variant[rawFieldName], options);
    return typeof parsed === 'number' ? parsed : null;
}

function variantIsWithinDateRange(variant, reference = Date.now()) {
    if (!variant || typeof variant !== 'object') return false;
    const nowTs = reference instanceof Date ? reference.getTime() : Number(reference);
    const isValidNow = Number.isFinite(nowTs) ? nowTs : Date.now();
    const start = getVariantDateMs(variant, 'start_date', 'startDateMs');
    const end = getVariantDateMs(variant, 'end_date', 'endDateMs', { endOfDay: true });
    // Sem metadados de data, a variante permanece elegível.
    if (start === null && end === null) {
        return true;
    }
    if (start !== null && isValidNow < start) {
        return false;
    }
    if (end !== null && isValidNow > end) {
        return false;
    }
    return true;
}

function variantHasExpiredEndDate(variant, reference = Date.now()) {
    if (!variant || typeof variant !== 'object') return false;
    const nowTs = reference instanceof Date ? reference.getTime() : Number(reference);
    const isValidNow = Number.isFinite(nowTs) ? nowTs : Date.now();
    const end = getVariantDateMs(variant, 'end_date', 'endDateMs', { endOfDay: true });
    return end !== null && isValidNow > end;
}

function normalizePoloEntry(entry) {
    if (!entry || typeof entry !== 'object') return null;

    const id = normalizePoloId(entry.id ?? entry.id_polo ?? '');
    const skuPolo = entry.sku_polo === null || typeof entry.sku_polo === 'undefined'
        ? ''
        : String(entry.sku_polo).trim();
    const rawUf = typeof entry.uf === 'string' ? entry.uf.trim() : '';
    const rawCidade = typeof entry.cidade === 'string' ? entry.cidade.trim() : (typeof entry.cidade_polo === 'string' ? entry.cidade_polo.trim() : '');
    const rawPolo = typeof entry.polo === 'string'
        ? entry.polo.trim()
        : (typeof entry.nome_polo === 'string' ? entry.nome_polo.trim() : (typeof entry.nome === 'string' ? entry.nome.trim() : ''));
    const rawEstadoPolo = typeof entry.estado_polo === 'string' ? entry.estado_polo.trim() : '';

    let uf = rawUf;
    let cidade = rawCidade;

    if ((!uf || !cidade) && rawEstadoPolo.includes(' - ')) {
        const partes = rawEstadoPolo.split(' - ').map((parte) => parte.trim()).filter(Boolean);
        uf = uf || partes[0] || '';
        cidade = cidade || partes.slice(1).join(' - ');
    }

    if (!uf || !cidade || !rawPolo) return null;

    return {
        id,
        skuPolo,
        uf,
        cidade,
        polo: rawPolo,
        display: `${uf} - ${cidade} - ${rawPolo}`
    };
}

function parsePolosJson(value) {
    if (!value) return [];

    let parsed = value;

    if (typeof value === 'string') {
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.warn('Não foi possível fazer parse do polos_json:', error);
            return [];
        }
    }

    if (Array.isArray(parsed)) {
        return parsed;
    }

    if (isPlainObject(parsed) && Array.isArray(parsed.polos)) {
        return parsed.polos;
    }

    return [];
}

function extractVariantPolos(variant) {
    if (!variant) return [];
    const polosRaw = parsePolosJson(variant.polos_json);
    if (!Array.isArray(polosRaw) || !polosRaw.length) return [];
    const normalizados = polosRaw.map(normalizePoloEntry).filter(Boolean);
    return normalizados;
}

function getAggregatedPoloKey(uf, cidade, polo) {
    return `${uf}||${cidade}||${polo}`;
}

function resolvePoloSelecionadoNaVariante() {
    const variantId = dadosMatricula && dadosMatricula.variantId;
    const variante = todasVariantes.find((item) => String(item.id) === String(variantId)) || null;
    if (!variante) return null;

    const polos = Array.isArray(variante.polosData) ? variante.polosData : [];
    if (!polos.length) return null;

    const poloKeySelecionado = typeof dadosMatricula.poloKey === 'string'
        ? dadosMatricula.poloKey.trim()
        : '';
    const poloIdSelecionado = normalizePoloId(dadosMatricula.poloId);
    let poloSelecionado = poloIdSelecionado
        ? polos.find((entry) => normalizePoloId(entry.id) === poloIdSelecionado) || null
        : null;

    if (!poloSelecionado) {
        poloSelecionado = poloKeySelecionado
            ? polos.find((entry) => getAggregatedPoloKey(entry.uf, entry.cidade, entry.polo) === poloKeySelecionado) || null
            : null;
    }

    if (!poloSelecionado) {
        poloSelecionado = polos.find((entry) => {
            return entry.uf === dadosMatricula.estado
                && entry.cidade === dadosMatricula.cidade
                && (entry.display === dadosMatricula.polo || entry.polo === dadosMatricula.polo);
        }) || null;
    }

    return poloSelecionado;
}

function resolvePoloIdSelecionado() {
    const poloSelecionado = resolvePoloSelecionadoNaVariante();
    return normalizePoloId(poloSelecionado?.id ?? dadosMatricula?.poloId ?? '');
}

function resolveSkuPoloSelecionado() {
    const variantId = dadosMatricula && dadosMatricula.variantId;
    const variante = todasVariantes.find((item) => String(item.id) === String(variantId)) || null;
    if (!variante) return '';

    const skuVariante = variante.sku === null || typeof variante.sku === 'undefined'
        ? ''
        : String(variante.sku).trim();
    const poloSelecionado = resolvePoloSelecionadoNaVariante();

    return poloSelecionado && poloSelecionado.skuPolo
        ? poloSelecionado.skuPolo
        : skuVariante;
}

function buildAggregatedPolos(variants) {
    aggregatedPolosMap = new Map();
    if (!Array.isArray(variants)) {
        usaPolosMetafield = false;
        return;
    }

    variants.forEach((variant) => {
        const polos = Array.isArray(variant.polosData) ? variant.polosData : [];
        if (!polos.length) return;

        polos.forEach((polo) => {
            if (!polo.uf || !polo.cidade || !polo.polo) return;
            const key = getAggregatedPoloKey(polo.uf, polo.cidade, polo.polo);
            const existente = aggregatedPolosMap.get(key) || {
                uf: polo.uf,
                cidade: polo.cidade,
                polo: polo.polo,
                display: polo.display,
                ids: new Set(),
                variantIds: new Set()
            };
            if (polo.id) {
                existente.ids.add(String(polo.id));
            }
            if (variant.id) {
                existente.variantIds.add(String(variant.id));
            }
            aggregatedPolosMap.set(key, existente);
        });
    });

    usaPolosMetafield = aggregatedPolosMap.size > 0;
}

function usePolosMetafield() {
    return usaPolosMetafield;
}

function getAggregatedPoloEntry(key) {
    if (!key || !aggregatedPolosMap) return null;
    return aggregatedPolosMap.get(key) || null;
}

function poloEntryMatchesActiveFilter(entry) {
    if (!hasActivePoloFilter()) return true;
    if (!entry || !entry.ids || typeof entry.ids.forEach !== 'function') return false;
    const targetId = getActivePoloId();
    let matches = false;
    entry.ids.forEach((id) => {
        if (normalizePoloId(id) === targetId) {
            matches = true;
        }
    });
    return matches;
}

function rawPoloMatchesActiveFilter(polo) {
    if (!hasActivePoloFilter()) return true;
    return Boolean(polo && normalizePoloId(polo.id) === getActivePoloId());
}

function variantMatchesActivePoloFilter(variant) {
    if (!hasActivePoloFilter()) return true;
    const polos = Array.isArray(variant?.polosData) ? variant.polosData : [];
    return polos.some(rawPoloMatchesActiveFilter);
}

function filterVariantsByActivePolo(variants) {
    const list = Array.isArray(variants) ? variants : [];
    if (!usePolosMetafield() || !hasActivePoloFilter()) return list.slice();
    return list.filter(variantMatchesActivePoloFilter);
}

function getAggregatedPoloEntriesByUf(uf) {
    if (!uf) return [];
    const entries = [];
    aggregatedPolosMap.forEach((entry) => {
        if (entry.uf === uf && poloEntryMatchesActiveFilter(entry)) {
            entries.push(entry);
        }
    });
    return entries;
}

function getAggregatedPoloEntriesByUfCidade(uf, cidade) {
    if (!uf || !cidade) return [];
    const entries = [];
    aggregatedPolosMap.forEach((entry) => {
        if (entry.uf === uf && entry.cidade === cidade && poloEntryMatchesActiveFilter(entry)) {
            entries.push(entry);
        }
    });
    return entries;
}

/** Entradas do mapa de polos que têm ao menos uma variante com a forma (e turno) informados. */
function getAggregatedPoloEntriesForFormaETurno(forma, turno) {
    const variantes = getVariantsForFormaETurno(forma, turno || null);
    const ids = new Set(variantes.map((v) => String(v.id)));
    const entries = [];
    aggregatedPolosMap.forEach((entry) => {
        if (!entry.variantIds) return;
        if (!poloEntryMatchesActiveFilter(entry)) return;
        const temInterseccao = Array.from(entry.variantIds).some((id) => ids.has(String(id)));
        if (temInterseccao) entries.push(entry);
    });
    return entries;
}

function getVariantsForPoloKey(key) {
    const entry = getAggregatedPoloEntry(key);
    if (!entry || !entry.variantIds) return [];
    const ids = Array.from(entry.variantIds);
    return todasVariantes.filter((variant) => ids.includes(String(variant.id)));
}

// Os rótulos são agrupados; valores originais e SKUs continuam na variante.
function normalizarFormaIngresso(value) {
    return String(value || '').trim().replace(/\s*[-\u2013\u2014]\s*\d+$/, '').trim();
}

function lerModalidadeMatricula() {
    try { return localStorage.getItem('modalidadeSelecionada') || ''; } catch (error) { return ''; }
}

function getLocationVariants({ polo = false, forma = false, turno = false, modalidade = true } = {}) {
    let variants = filterVariantsByActivePolo(todasVariantes).filter((v) => v.available !== false && variantIsWithinDateRange(v));
    const selectedModalidade = lerModalidadeMatricula();
    if (modalidade && isModalidadeRequired() && selectedModalidade) {
        variants = variants.filter((v) => getVariantOptionValue(v, ENROLL_OPTION_LABELS.modalidade) === selectedModalidade);
    }
    if (polo) {
        if (usePolosMetafield()) {
            const entry = getAggregatedPoloEntry(dadosMatricula.poloKey);
            if (!entry) return [];
            variants = variants.filter((v) => (v.polosData || []).some((p) => {
                if (dadosMatricula.poloId && p.id) return normalizePoloId(p.id) === normalizePoloId(dadosMatricula.poloId);
                return getAggregatedPoloKey(p.uf, p.cidade, p.polo) === dadosMatricula.poloKey;
            }));
        } else {
            if (!dadosMatricula.polo) return [];
            variants = variants.filter((v) => montarPoloBase(dividirPolo(getPoloValue(v))) === dadosMatricula.polo);
        }
    }
    if (forma) {
        const label = normalizarFormaIngresso(dadosMatricula.formaIngresso);
        variants = variants.filter((v) => normalizarFormaIngresso(getVariantOptionValue(v, ENROLL_OPTION_LABELS.formaIngresso)) === label);
    }
    if (turno && dadosMatricula.turno) {
        variants = variants.filter((v) => getEnrollmentTurno(v) === dadosMatricula.turno);
    }
    return variants;
}

function getEnrollmentTurno(variant) {
    return getVariantOptionValue(variant, ENROLL_OPTION_LABELS.turno) || (!usePolosMetafield() ? dividirPolo(getPoloValue(variant)).turno : '') || '';
}

function escolherVarianteMatricula(variants) {
    const ead = (v) => /^(ead|e[ -]?learning)$/i.test(String(getVariantOptionValue(v, ENROLL_OPTION_LABELS.modalidade) || getEnrollmentTurno(v)).trim());
    return variants.find(ead) || variants[0] || null;
}

function limparOfertaMatricula({ limparForma = true } = {}) {
    if (limparForma) dadosMatricula.formaIngresso = '';
    dadosMatricula.turno = '';
    dadosMatricula.variantId = null;
    dadosMatricula.varianteSku = '';
    dadosMatricula.codCurso = '';
    dadosMatricula.nivelEnsino = '';
    dadosMatricula.modalidade = '';
    dadosMatricula.cupomCodigo = '';
    dadosMatricula.cupomId = '';
    dadosMatricula.cupomNome = '';
    atualizarAvisoPreco(null);
}

function inicializarLocalizacaoMatricula() {
    if (!dadosMatricula.estado) popularEstados();
    popularFormasIngresso();
    popularTurnosAposForma();
}

function getVariantsForFormaETurno(forma, turno) {
    let list = getLocationVariants();
    if (forma) list = list.filter((v) => normalizarFormaIngresso(getVariantOptionValue(v, ENROLL_OPTION_LABELS.formaIngresso)) === normalizarFormaIngresso(forma));
    if (turno) list = list.filter((v) => getEnrollmentTurno(v) === turno);
    return list;
}

function getModalidadesForActivePoloFilter() {
    if (!isModalidadeRequired()) return [];
    const modalidades = [];
    const vistas = new Set();
    filterVariantsByActivePolo(todasVariantes).forEach((variant) => {
        const modalidade = getVariantOptionValue(variant, ENROLL_OPTION_LABELS.modalidade);
        if (!modalidade || vistas.has(modalidade)) return;
        vistas.add(modalidade);
        modalidades.push(modalidade);
    });
    return modalidades;
}

function clearStoredModalidadeIfInvalidForActivePolo() {
    if (!hasActivePoloFilter() || !isModalidadeRequired()) return;

    let modalidadeSelecionada = '';
    try {
        modalidadeSelecionada = localStorage.getItem('modalidadeSelecionada') || '';
    } catch (e) {}

    if (!modalidadeSelecionada) return;

    const modalidades = getModalidadesForActivePoloFilter();
    if (!modalidades.length || modalidades.includes(modalidadeSelecionada)) return;

    try {
        localStorage.removeItem('modalidadeSelecionada');
    } catch (e) {}

    window.dispatchEvent(new CustomEvent('modalidadeSelecionada', {
        detail: { value: '', source: 'polo-filter' }
    }));
}

function prepareVariantCatalog(variants) {
    if (!Array.isArray(variants)) return [];
    return variants.map(enrichVariantData);
}

function prepareActiveVariants(variants) {
    const nowTs = Date.now();
    return prepareVariantCatalog(variants)
        .filter((variant) => {
            const availableFlag = typeof variant.available === 'boolean' ? variant.available : true;
            return availableFlag && variantIsWithinDateRange(variant, nowTs);
        });
}

function resetSelectOptions(select, placeholder, { disable = false } = {}) {
    if (!select) return;
    const label = placeholder || '';
    select.innerHTML = `<option value="">${label}</option>`;
    if (disable) {
        select.setAttribute('disabled', 'disabled');
    } else {
        select.removeAttribute('disabled');
    }
}

function resetStep2Form() {
    const selectEstado = document.querySelector('select[name="estado"]');
    const selectCidade = document.querySelector('select[name="cidade"]');
    const selectPolo = document.querySelector('select[name="polo"]');
    resetSelectOptions(selectEstado, 'Estado', { disable: true });
    resetSelectOptions(selectCidade, 'Cidade', { disable: true });
    resetSelectOptions(selectPolo, 'Unidade/Polo', { disable: true });

    const formasGroup = document.querySelector('.product-enroll-popup .forma-ingresso-group');
    if (formasGroup) {
        formasGroup.innerHTML = '';
    }
    const turnoContainer = document.querySelector('[data-turno-container]');
    const turnoButtons = document.querySelector('[data-turno-buttons]');
    if (turnoButtons) {
        turnoButtons.innerHTML = '';
    }
    renderTurnoPlaceholder('Selecione a forma de ingresso');

    const btnContinuarStep2 = document.querySelector('[data-step="2"] .btn-continuar');
    if (btnContinuarStep2) {
        btnContinuarStep2.disabled = true;
    }

    dadosMatricula.estado = '';
    dadosMatricula.cidade = '';
    dadosMatricula.poloId = '';
    dadosMatricula.poloKey = '';
    dadosMatricula.polo = '';
    dadosMatricula.turno = '';
    dadosMatricula.formaIngresso = '';
    dadosMatricula.variantId = null;
    dadosMatricula.varianteSku = '';
dadosMatricula.codCurso = '';
dadosMatricula.nivelEnsino = '';
dadosMatricula.cupomCodigo = '';
dadosMatricula.cupomId = '';
dadosMatricula.cupomNome = '';

    // ✅ NÃO limpa nome, email, celular, consultor, dataNascimento (são do Step 1)


    if (birthdateInput) {
        birthdateInput.value = dadosMatricula.dataNascimento || '';
    }

    updateBirthdateAvailability();
    try {
        localStorage.setItem('dadosMatricula', JSON.stringify(dadosMatricula));
    } catch (e) {
        console.warn('Não foi possível persistir dados do step 2 limpos:', e);
    }
}

function applyProductConfig(config, { resetSelections = true } = {}) {
    if (!config) return;
    optionNames = Array.isArray(config.optionNames) ? config.optionNames.slice() : [];
    Object.keys(OPTION_INDEX_CACHE).forEach((key) => {
        delete OPTION_INDEX_CACHE[key];
    });
    const rawVariants = Array.isArray(config.variants) ? config.variants : [];
    variantesCatalogo = prepareVariantCatalog(rawVariants);
    todasVariantes = prepareActiveVariants(rawVariants);
    buildAggregatedPolos(todasVariantes);
    if (typeof window !== 'undefined') {
        window.ENROLL_MODALIDADE_REQUIRED = Boolean(config.modalidadeRequired);
    }
    clearStoredModalidadeIfInvalidForActivePolo();
    precoBaseServidor = Number(config.precoBase || 0);
    if ((!Number.isFinite(precoBaseServidor) || precoBaseServidor <= 0) && todasVariantes.length > 0) {
        const fallbackPrice = Number(todasVariantes[0].price || 0);
        if (Number.isFinite(fallbackPrice) && fallbackPrice > 0) {
            precoBaseServidor = fallbackPrice;
        }
    }
    precoBase = precoBaseServidor;
    activeProductId = config.productId ? String(config.productId) : null;
    activeProductFormacao = config.formacao || '';
    activeProductArea = config.area || '';
    activeProductTitle = config.productTitle || '';
    activeProductHandle = config.productHandle || '';

    if (resetSelections) {
        resetStep2Form();
        inicializarLocalizacaoMatricula();
        verificarFormularioCompleto();
        atualizarAvisoPreco(null);
    }
}

applyProductConfig(initialProductConfig, { resetSelections: false });

function getOptionIndexByName(optionName) {
    if (!Array.isArray(optionNames)) return -1;
    const key = normalizeOptionLabel(optionName);
    if (!key) return -1;
    if (Object.prototype.hasOwnProperty.call(OPTION_INDEX_CACHE, key)) {
        return OPTION_INDEX_CACHE[key];
    }
    const aliases = getOptionAliases(optionName);
    let index = optionNames.findIndex((name) => aliases.includes(normalizeOptionLabel(name)));

    if (index < 0) {
        index = optionNames.findIndex((name) => {
            const normalized = normalizeOptionLabel(name);
            return aliases.some((alias) => normalized.includes(alias));
        });
    }

    OPTION_INDEX_CACHE[key] = index;
    return index;
}

function getVariantOptionValue(variant, optionName) {
    if (!variant || !optionName) return undefined;
    const index = getOptionIndexByName(optionName);
    if (index < 0) {
        if (normalizeOptionLabel(optionName) === normalizeOptionLabel(ENROLL_OPTION_LABELS.formaIngresso)) {
            const singleOptionValue = Array.isArray(variant.options) && variant.options.length === 1 ? variant.options[0] : variant.option1 || variant.title;
            const normalizedValue = normalizeOptionLabel(singleOptionValue);
            if (singleOptionValue && normalizedValue && normalizedValue !== 'default title') {
                return singleOptionValue;
            }
        }
        return undefined;
    }
    if (Array.isArray(variant.options) && variant.options.length > index) {
        return variant.options[index];
    }
    const fallbackKey = `option${index + 1}`;
    return variant[fallbackKey];
}

function getPoloValue(variant) {
    const value = getVariantOptionValue(variant, ENROLL_OPTION_LABELS.polo);
    return typeof value === 'string' ? value : '';
}

function dividirPolo(value) {
    if (typeof value !== 'string' || !value.length) {
        return { estado: '', cidade: '', polo: '', turno: '', completo: '' };
    }
    const partes = value.split(' - ').map((parte) => parte.trim()).filter(Boolean);
    const estado = partes[0] || '';
    const cidade = partes[1] || '';
    const polo = partes[2] || '';
    const turno = partes.length > 3 ? partes.slice(3).join(' - ') : '';
    return {
        estado,
        cidade,
        polo,
        turno,
        completo: value
    };
}

function montarPoloBase(info) {
    if (!info || !info.estado || !info.cidade || !info.polo) return '';
    return `${info.estado} - ${info.cidade} - ${info.polo}`;
}

function extrairValorCentavos(texto) {
    if (typeof texto !== 'string') return NaN;

    const apenasNumeros = texto
        .replace(/\s/g, '')
        .replace(/[^0-9,.-]/g, '');

    if (!apenasNumeros) return NaN;

    const normalizado = apenasNumeros
        .replace(/\.(?=\d{3}(?:\D|$))/g, '')
        .replace(',', '.');

    const valor = Number.parseFloat(normalizado);

    if (Number.isNaN(valor)) return NaN;

    return Math.round(valor * 100);
}

function extrairDigitosTelefoneBr(valor) {
    return (valor || '').replace(/\D/g, '').slice(0, PHONE_REQUIRED_DIGITS);
}

function normalizarTelefoneParaEnvio(valor) {
    return extrairDigitosTelefoneBr(valor);
}

function numeroCelularBrValido(digits) {
    const ddd = digits.slice(0, 2);
    const numero = digits.slice(2);

    return digits.length === PHONE_REQUIRED_DIGITS
        && VALID_BRAZIL_DDDS.has(ddd)
        && numero.length === PHONE_MAIN_NUMBER_DIGITS
        && numero.charAt(0) === '9'
        && !/^(\d)\1{8}$/.test(numero);
}

function telefoneBrTemPadraoRepetido(valor) {
    const digits = extrairDigitosTelefoneBr(valor);
    if (!digits) return false;

    const numero = digits.slice(2);
    return /^(\d)\1+$/.test(digits) || /^(\d)\1+$/.test(numero);
}

function formatarTelefoneBr(valor) {
    const digits = extrairDigitosTelefoneBr(valor);
    if (!digits) return '';
    if (digits.length === 1) return `(${digits}`;
    if (digits.length === 2) return `(${digits})`;

    const ddd = digits.slice(0, 2);
    const numero = digits.slice(2);
    if (numero.length <= 5) {
        return `(${ddd}) ${numero}`;
    }

    return `(${ddd}) ${numero.slice(0, 5)}-${numero.slice(5, PHONE_MAIN_NUMBER_DIGITS)}`;
}

function telefoneBrValido(valor) {
    const digits = extrairDigitosTelefoneBr(valor);
    return numeroCelularBrValido(digits);
}

// ========================================
// CPF
// ========================================

function aplicarMascaraCPF(input) {
    if (!input) return;
    const digits = input.value.replace(/\D/g, '').slice(0, 11);
    let result = digits;
    if (digits.length > 9) {
        result = digits.slice(0,3) + '.' + digits.slice(3,6) + '.' + digits.slice(6,9) + '-' + digits.slice(9);
    } else if (digits.length > 6) {
        result = digits.slice(0,3) + '.' + digits.slice(3,6) + '.' + digits.slice(6);
    } else if (digits.length > 3) {
        result = digits.slice(0,3) + '.' + digits.slice(3);
    }
    const estavaNoFim = input.selectionStart === input.value.length;
    input.value = result;
    if (estavaNoFim) {
        input.setSelectionRange(result.length, result.length);
    }
}

function validarCPF(cpf) {
    const digits = cpf.replace(/\D/g, '');
    if (digits.length !== 11) return false;
    if (/^(\d)\1{10}$/.test(digits)) return false;
    let sum = 0;
    for (let i = 0; i < 9; i++) sum += parseInt(digits[i]) * (10 - i);
    let rem = (sum * 10) % 11;
    if (rem === 10 || rem === 11) rem = 0;
    if (rem !== parseInt(digits[9])) return false;
    sum = 0;
    for (let i = 0; i < 10; i++) sum += parseInt(digits[i]) * (11 - i);
    rem = (sum * 10) % 11;
    if (rem === 10 || rem === 11) rem = 0;
    return rem === parseInt(digits[10]);
}

function atualizarValidadeCPF(mostrarObrigatorio = false) {
    if (!cpfInput) return;
    aplicarMascaraCPF(cpfInput);
    const valor = cpfInput.value.trim();
    const error = document.querySelector('[data-cpf-error]');
    const errorText = document.querySelector('[data-cpf-error-text]');

    let mensagem = '';
    if (!valor && mostrarObrigatorio) {
        mensagem = 'Preencha o CPF.';
    } else if (valor) {
        const digits = valor.replace(/\D/g, '');
        if (digits.length === 11 && !validarCPF(valor)) {
            mensagem = 'CPF inválido.';
        }
    }

    if (mensagem) {
        cpfInput.classList.add('form-input--error');
        if (errorText) errorText.textContent = mensagem;
        if (error) { error.classList.remove('is-hidden'); error.setAttribute('aria-hidden', 'false'); }
    } else {
        cpfInput.classList.remove('form-input--error');
        if (errorText) errorText.textContent = '';
        if (error) { error.classList.add('is-hidden'); error.setAttribute('aria-hidden', 'true'); }
    }
}

// ========================================
// CEP / ViaCEP
// ========================================

function aplicarMascaraCEP(input) {
    if (!input) return;
    const digits = input.value.replace(/\D/g, '').slice(0, 8);
    const result = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
    const estavaNoFim = input.selectionStart === input.value.length;
    input.value = result;
    if (estavaNoFim) {
        input.setSelectionRange(result.length, result.length);
    }
}

function valorCampoStep3(input) {
    return input ? input.value.trim() : '';
}

function sincronizarDadosStep3ComCampos() {
    dadosMatricula.cpf = valorCampoStep3(cpfInput);
    dadosMatricula.cep = valorCampoStep3(cepInput);
    dadosMatricula.estadoEndereco = estadoEnderecoSelect ? estadoEnderecoSelect.value : '';
    dadosMatricula.cidadeEndereco = valorCampoStep3(cidadeEnderecoInput);
    dadosMatricula.bairro = valorCampoStep3(bairroInput);
    dadosMatricula.rua = valorCampoStep3(ruaInput);
    dadosMatricula.numero = valorCampoStep3(numeroInput);
    dadosMatricula.complemento = valorCampoStep3(complementoInput);
}

async function buscarEnderecoPorCEP(cep) {
    const digits = cep.replace(/\D/g, '');
    if (digits.length !== 8) return null;
    try {
        const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
        if (!response.ok) return null;
        const data = await response.json();
        if (data.erro) return null;
        return data;
    } catch (e) {
        return null;
    }
}

function preencherCampoEnderecoViaCEP(input, chave, valor, preservarValorAtualQuandoVazio = false) {
    if (!input) return;

    const valorNormalizado = typeof valor === 'string' ? valor.trim() : '';
    const valorAtual = input.value.trim();
    const ultimoValorViaCEP = input.dataset.viacepValue || '';

    if (valorNormalizado) {
        input.value = valorNormalizado;
        input.dataset.viacepValue = valorNormalizado;
    } else if (!preservarValorAtualQuandoVazio || valorAtual === ultimoValorViaCEP) {
        input.value = '';
        delete input.dataset.viacepValue;
    } else {
        delete input.dataset.viacepValue;
    }

    dadosMatricula[chave] = input.value.trim();
}

function preencherEnderecoViaCEP(data) {
    if (!data) return;
    if (estadoEnderecoSelect) {
        estadoEnderecoSelect.value = data.uf || '';
        dadosMatricula.estadoEndereco = data.uf || '';
    }
    preencherCampoEnderecoViaCEP(cidadeEnderecoInput, 'cidadeEndereco', data.localidade);
    preencherCampoEnderecoViaCEP(bairroInput, 'bairro', data.bairro, true);
    preencherCampoEnderecoViaCEP(ruaInput, 'rua', data.logradouro, true);
    verificarFormularioStep3Completo();
}

function mostrarErroCEP(mensagem) {
    const error = document.querySelector('[data-cep-error]');
    const errorText = document.querySelector('[data-cep-error-text]');
    if (cepInput) cepInput.classList.add('form-input--error');
    if (errorText) errorText.textContent = mensagem;
    if (error) { error.classList.remove('is-hidden'); error.setAttribute('aria-hidden', 'false'); }
}

function limparErroCEP() {
    const error = document.querySelector('[data-cep-error]');
    const errorText = document.querySelector('[data-cep-error-text]');
    if (cepInput) cepInput.classList.remove('form-input--error');
    if (errorText) errorText.textContent = '';
    if (error) { error.classList.add('is-hidden'); error.setAttribute('aria-hidden', 'true'); }
}

// ========================================
// VALIDAÇÃO STEP 3
// ========================================

function verificarFormularioStep3Completo() {
    const btn = document.getElementById('btn-finalizar-step3');
    if (!btn) return;
    if (btn.dataset.loading === 'true') {
        btn.disabled = true;
        return;
    }
    sincronizarDadosStep3ComCampos();
    const cpfValido = cpfInput && validarCPF(cpfInput.value);
    const nascimentoValido = birthdateInput && dataNascimentoValida(birthdateInput.value.trim());
    const cepDigits = cepInput ? cepInput.value.replace(/\D/g, '') : '';
    const estadoValido = estadoEnderecoSelect && estadoEnderecoSelect.value;
    const cidadeValida = cidadeEnderecoInput && cidadeEnderecoInput.value.trim();
    const bairroValido = bairroInput && bairroInput.value.trim();
    const ruaValida = ruaInput && ruaInput.value.trim();
    const numeroValido = numeroInput && numeroInput.value.trim();
    btn.disabled = !(cpfValido && nascimentoValido && cepDigits.length === 8 && estadoValido && cidadeValida && bairroValido && ruaValida && numeroValido);
}

function agendarVerificacaoStep3Completo() {
    verificarFormularioStep3Completo();

    if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(verificarFormularioStep3Completo);
    }

    setTimeout(verificarFormularioStep3Completo, 150);
}

function mostrarRedirecionamentoMatricula() {
    if (document.getElementById('celso-enrollment-redirect')) return;

    const overlay = document.createElement('div');
    overlay.id = 'celso-enrollment-redirect';
    overlay.className = 'celso-enrollment-redirect';
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    overlay.innerHTML = ''
        + '<div class="celso-enrollment-redirect__card">'
        + '<span class="celso-enrollment-redirect__spinner" aria-hidden="true"></span>'
        + '<p class="celso-enrollment-redirect__title">Redirecionando</p>'
        + '<p class="celso-enrollment-redirect__text">Estamos abrindo seu carrinho.</p>'
        + '</div>';
    document.body.appendChild(overlay);
}

function esconderRedirecionamentoMatricula() {
    document.getElementById('celso-enrollment-redirect')?.remove();
}

function setContinueButtonLoading(button, isLoading) {
    if (!button) return;

    const textElement = button.querySelector('span');
    if (textElement && !button.dataset.originalText) {
        button.dataset.originalText = textElement.textContent.trim() || 'Continuar';
    }

    button.dataset.loading = isLoading ? 'true' : 'false';
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    if (textElement) {
        textElement.textContent = isLoading ? 'Aguarde...' : (button.dataset.originalText || 'Continuar');
    }
}


function aplicarMascaraDataNascimento(input) {
    if (!input) return;
    const valorFormatado = formatarDataNascimento(input.value);
    const estavaNoFim = input.selectionStart === input.value.length;
    input.value = valorFormatado;
    if (estavaNoFim) {
        input.setSelectionRange(valorFormatado.length, valorFormatado.length);
    }
}

function atualizarValidadeDataNascimento(mostrarObrigatorio = false) {
    if (!birthdateInput) return;
    aplicarMascaraDataNascimento(birthdateInput);
    const valor = birthdateInput.value.trim();
    const error = document.querySelector('[data-birthdate-error]');
    const errorText = document.querySelector('[data-birthdate-error-text]');
    if (!valor) {
        if (!mostrarObrigatorio) {
            birthdateInput.setCustomValidity('');
            birthdateInput.classList.remove('form-input--error');
            birthdateInput.removeAttribute('aria-invalid');
            if (error) {
                error.classList.add('is-hidden');
                error.setAttribute('aria-hidden', 'true');
            }
            if (errorText) {
                errorText.textContent = '';
            }
            return;
        }
    }
    const mensagem = obterMensagemErroDataNascimento(valor, { required: mostrarObrigatorio });
    if (mensagem) {
        birthdateInput.setCustomValidity(mensagem);
        birthdateInput.classList.add('form-input--error');
        birthdateInput.setAttribute('aria-invalid', 'true');
        if (errorText) {
            errorText.textContent = mensagem;
        }
        if (error) {
            error.classList.remove('is-hidden');
            error.setAttribute('aria-hidden', 'false');
        }
    } else {
        birthdateInput.setCustomValidity('');
        birthdateInput.classList.remove('form-input--error');
        birthdateInput.removeAttribute('aria-invalid');
        if (error) {
            error.classList.add('is-hidden');
            error.setAttribute('aria-hidden', 'true');
        }
        if (errorText) {
            errorText.textContent = '';
        }
    }
}

function formatarDataNascimento(valor) {
    const digits = (valor || '').replace(/\D/g, '').slice(0, 8);
    const dia = digits.slice(0, 2);
    const mes = digits.slice(2, 4);
    const ano = digits.slice(4, 8);
    let output = '';
    if (dia) output += dia;
    if (mes) output += (output ? '/' : '') + mes;
    if (ano) output += (output ? '/' : '') + ano;
    return output;
}

function formatarDataNascimentoParaPedido(valor) {
    const dataNascimentoFormatada = formatarDataNascimento(valor);
    return dataNascimentoFormatada.replace(/\D/g, '').length === 8 ? dataNascimentoFormatada : '';
}

function montarNotaPedidoComDataNascimento(notaAtual, dataNascimento) {
    const dataNascimentoPedido = formatarDataNascimentoParaPedido(dataNascimento);
    if (!dataNascimentoPedido) return notaAtual || '';

    const notaSemDataNascimento = String(notaAtual || '')
        .split('\n')
        .filter(line => !/^data_de_nascimento:/i.test(line.trim()))
        .join('\n')
        .trim();
    const linhaDataNascimento = `data_de_nascimento:${dataNascimentoPedido}`;

    return notaSemDataNascimento
        ? `${notaSemDataNascimento}\n${linhaDataNascimento}`
        : linhaDataNascimento;
}

async function atualizarNotaPedidoComDataNascimento(dataNascimento, tipoCurso) {
    const dataNascimentoPedido = formatarDataNascimentoParaPedido(dataNascimento);
    if (!dataNascimentoPedido) return;
    const tipoCursoPedido = typeof tipoCurso === 'string' ? tipoCurso.trim() : '';

    const cartUpdateUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url) || '/cart/update.js';
    const cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
    const cartEndpoint = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl}.js`;
    let notaAtual = '';

    try {
        const cartResponse = await fetch(cartEndpoint, { credentials: 'same-origin', cache: 'no-store' });
        if (cartResponse.ok) {
            const cart = await cartResponse.json();
            notaAtual = typeof cart?.note === 'string' ? cart.note : '';
        }
    } catch (error) {
        console.warn('⚠️ Não foi possível ler a nota atual do carrinho:', error);
    }

    await fetch(cartUpdateUrl, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
            note: montarNotaPedidoComDataNascimento(notaAtual, dataNascimentoPedido),
            attributes: {
                'Data de Nascimento': dataNascimentoPedido,
                ...(tipoCursoPedido ? { 'Tipo do Curso': tipoCursoPedido } : {})
            }
        })
    });
}

function getMatriculaAttributeIdentifier({ codCurso, varianteSku, variantId } = {}) {
    return [codCurso, varianteSku, variantId]
        .map(value => value === null || typeof value === 'undefined' ? '' : String(value).trim())
        .find(Boolean) || '';
}

function buildMatriculaCartAttributes({ nomeCurso, estado, cidade, polo, poloId, codCurso, varianteSku, variantId, skuPolo } = {}) {
    const identifier = getMatriculaAttributeIdentifier({ codCurso, varianteSku, variantId });
    if (!identifier) return {};

    const prefix = `Curso ${identifier}`;
    const attributes = {};
    const addAttribute = (label, value) => {
        const normalizedValue = value === null || typeof value === 'undefined' ? '' : String(value).trim();
        if (normalizedValue) attributes[`${prefix} - ${label}`] = normalizedValue;
    };

    addAttribute('Nome', nomeCurso);
    addAttribute('Estado', estado);
    addAttribute('Cidade', cidade);
    addAttribute('Polo', polo);
    addAttribute('ID do Polo', poloId);
    addAttribute('SKU Polo', skuPolo);

    return attributes;
}

async function atualizarAtributosPedidoMatricula({
    dataNascimento,
    tipoCurso,
    nomeCurso,
    estado,
    cidade,
    polo,
    poloId,
    codCurso,
    varianteSku,
    variantId,
    skuPolo
} = {}) {
    const dataNascimentoPedido = formatarDataNascimentoParaPedido(dataNascimento);
    const tipoCursoPedido = typeof tipoCurso === 'string' ? tipoCurso.trim() : '';
    const atributosMatricula = buildMatriculaCartAttributes({
        nomeCurso,
        estado,
        cidade,
        polo,
        poloId,
        codCurso,
        varianteSku,
        variantId,
        skuPolo
    });

    if (!dataNascimentoPedido && !tipoCursoPedido && !Object.keys(atributosMatricula).length) return;

    const cartUpdateUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url) || '/cart/update.js';
    const cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
    const cartEndpoint = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl}.js`;
    let notaAtual = '';

    if (dataNascimentoPedido) {
        try {
            const cartResponse = await fetch(cartEndpoint, { credentials: 'same-origin', cache: 'no-store' });
            if (cartResponse.ok) {
                const cart = await cartResponse.json();
                notaAtual = typeof cart?.note === 'string' ? cart.note : '';
            }
        } catch (error) {
            console.warn('Nao foi possivel ler a nota atual do carrinho:', error);
        }
    }

    const payload = {
        attributes: {
            ...(dataNascimentoPedido ? { 'Data de Nascimento': dataNascimentoPedido } : {}),
            ...(tipoCursoPedido ? { 'Tipo do Curso': tipoCursoPedido } : {}),
            ...atributosMatricula
        }
    };

    if (dataNascimentoPedido) {
        payload.note = montarNotaPedidoComDataNascimento(notaAtual, dataNascimentoPedido);
    }

    const response = await fetch(cartUpdateUrl, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
    });

    if (!response.ok) {
        throw new Error(`Falha ao atualizar atributos da matricula (${response.status})`);
    }
}

function getCartItemPoloId(item) {
    const properties = item && item.properties && typeof item.properties === 'object'
        ? item.properties
        : {};
    return normalizePoloId(properties['ID do Polo']);
}

function cartHasOriginPoloItem(cart, originPoloId) {
    const normalizedOriginPoloId = normalizePoloId(originPoloId);
    if (!normalizedOriginPoloId) return false;

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    return items.some((item) => getCartItemPoloId(item) === normalizedOriginPoloId);
}

async function fetchCartStateForOriginPolo() {
    const cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
    const cartEndpoint = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl}.js`;
    const response = await fetch(cartEndpoint, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) {
        throw new Error(`Falha ao ler carrinho (${response.status})`);
    }
    return response.json();
}

async function sincronizarOriginPoloIdNoCarrinho() {
    const storedOriginPoloId = getStoredOriginPoloId();
    let originPoloIdPedido = '';

    if (storedOriginPoloId) {
        try {
            const cart = await fetchCartStateForOriginPolo();
            if (cartHasOriginPoloItem(cart, storedOriginPoloId)) {
                originPoloIdPedido = storedOriginPoloId;
            }
        } catch (error) {
            console.warn('Nao foi possivel validar origin_polo_id no carrinho:', error);
        }
    }

    const cartUpdateUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url) || '/cart/update.js';
    const response = await fetch(cartUpdateUrl, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
            attributes: {
                origin_polo_id: originPoloIdPedido
            }
        })
    });

    if (!response.ok) {
        throw new Error(`Falha ao sincronizar origin_polo_id (${response.status})`);
    }

    return originPoloIdPedido;
}

function dataNascimentoFutura(valor) {
    const digits = (valor || '').replace(/\D/g, '');
    if (digits.length !== 8) return false;

    const dia = Number(digits.slice(0, 2));
    const mes = Number(digits.slice(2, 4)) - 1;
    const ano = Number(digits.slice(4, 8));
    const data = new Date(ano, mes, dia);

    if (Number.isNaN(data.getTime())) return false;
    if (data.getFullYear() !== ano || data.getMonth() !== mes || data.getDate() !== dia) {
        return false;
    }

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    data.setHours(0, 0, 0, 0);

    return data.getTime() > hoje.getTime();
}

function obterMensagemErroDataNascimento(valor, { required = false } = {}) {
    const digits = (valor || '').replace(/\D/g, '');
    if (!digits.length) return required ? 'Preencha a data de nascimento.' : '';
    if (digits.length < 8) return '';
    if (dataNascimentoFutura(valor)) return 'Data inválida.';
    if (!dataNascimentoValida(valor)) return 'Use o formato DD/MM/AAAA com uma data válida.';
    return '';
}

function dataNascimentoValida(valor) {
    const digits = (valor || '').replace(/\D/g, '');
    if (digits.length !== 8) return false;
    const dia = Number(digits.slice(0, 2));
    const mes = Number(digits.slice(2, 4)) - 1;
    const ano = Number(digits.slice(4, 8));
    const data = new Date(ano, mes, dia);
    if (Number.isNaN(data.getTime())) return false;
    if (data.getFullYear() !== ano || data.getMonth() !== mes || data.getDate() !== dia) {
        return false;
    }

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    data.setHours(0, 0, 0, 0);

    return data.getTime() <= hoje.getTime();
}

function aplicarMascaraTelefoneBr(input) {
    if (!input) return;
    input.maxLength = PHONE_VISIBLE_MAX_LENGTH;
    const valorFormatado = formatarTelefoneBr(input.value);
    const estavaNoFim = input.selectionStart === input.value.length;
    input.value = valorFormatado;
    if (estavaNoFim) {
        input.setSelectionRange(valorFormatado.length, valorFormatado.length);
    }
}

function obterCursorPorQuantidadeDeDigitosTelefoneBr(valorFormatado, quantidadeDigitos) {
    if (!quantidadeDigitos) return valorFormatado.startsWith('(') ? 1 : 0;

    let digitsEncontrados = 0;

    for (let index = 0; index < valorFormatado.length; index += 1) {
        if (/\d/.test(valorFormatado.charAt(index))) {
            digitsEncontrados += 1;
            if (digitsEncontrados === quantidadeDigitos) {
                return index + 1;
            }
        }
    }

    return valorFormatado.length;
}

function tratarBackspaceTelefoneBr(input, event) {
    if (!input || event.key !== 'Backspace') return;
    if (input.selectionStart !== input.selectionEnd) return;

    const cursorPosition = input.selectionStart ?? 0;
    if (cursorPosition <= 0) return;

    const caractereAnterior = input.value.charAt(cursorPosition - 1);
    if (/\d/.test(caractereAnterior)) return;

    const digits = extrairDigitosTelefoneBr(input.value);
    const digitsAntesDoCursor = extrairDigitosTelefoneBr(input.value.slice(0, cursorPosition)).length;
    const indiceRemocao = digitsAntesDoCursor - 1;

    if (indiceRemocao < 0) return;

    event.preventDefault();

    const novosDigitos = digits.slice(0, indiceRemocao) + digits.slice(indiceRemocao + 1);
    const novoValor = formatarTelefoneBr(novosDigitos);
    const novoCursor = obterCursorPorQuantidadeDeDigitosTelefoneBr(novoValor, indiceRemocao);

    input.value = novoValor;
    input.setSelectionRange(novoCursor, novoCursor);
}

if ((!Number.isFinite(precoBase) || precoBase <= 0) && typeof document !== 'undefined') {
    const precoAtualExibidoElemento = document.querySelector('product-price [ref="priceContainer"] .price');
    if (precoAtualExibidoElemento) {
        const precoInicial = extrairValorCentavos(precoAtualExibidoElemento.textContent);
        if (Number.isFinite(precoInicial) && precoInicial > 0) {
            precoBase = precoInicial;
        }
    }
}

// ========================================
// CONFIGURAÇÃO INICIAL
// ========================================

let dadosMatricula = {
  nome: '',
  email: '',
  celular: '',
  consultor: '',
  estado: '',
  cidade: '',
  poloId: '',
  poloKey: '',
  polo: '',
  turno: '',
  dataNascimento: '',
  formaIngresso: '',
  modalidade: '',
  variantId: null,

  // ✅ novos
  varianteSku: '',
  codCurso: '',
  nivelEnsino: '',
  cupomCodigo: '',
  cupomId: '',
  cupomNome: '',

  // ✅ step 3
  cpf: '',
  cep: '',
  estadoEndereco: '',
  cidadeEndereco: '',
  bairro: '',
  rua: '',
  numero: '',
  complemento: ''
};

function getPoloIdDaMatricula() {
    return resolvePoloIdSelecionado();
}


const formCadastro = document.getElementById('form-cadastro');
const btnContinuarStep1 = document.querySelector('[data-step="1"] .btn-continuar');
const nameInputCadastro = formCadastro?.querySelector('[name="nome"]');
const emailInputCadastro = formCadastro?.querySelector('[name="email"]');
const phoneInputCadastro = formCadastro?.querySelector('[name="celular"]');
const birthdateInput = document.querySelector('.product-enroll-popup [name="data_nascimento"]');
const cpfInput = document.querySelector('.product-enroll-popup [name="cpf"]');
const cepInput = document.querySelector('.product-enroll-popup [name="cep"]');
const estadoEnderecoSelect = document.querySelector('.product-enroll-popup [name="estado_endereco"]');
const cidadeEnderecoInput = document.querySelector('.product-enroll-popup [name="cidade_endereco"]');
const bairroInput = document.querySelector('.product-enroll-popup [name="bairro"]');
const ruaInput = document.querySelector('.product-enroll-popup [name="rua"]');
const numeroInput = document.querySelector('.product-enroll-popup [name="numero"]');
const complementoInput = document.querySelector('.product-enroll-popup [name="complemento"]');

const CAMPOS_CADASTRO = ['nome', 'email', 'celular', 'consultor'];
const CAMPOS_CADASTRO_OBRIGATORIOS = ['nome', 'email', 'celular'];
const CADASTRO_ERROR_MESSAGES = {
    nome: 'Preencha com o nome e sobrenome.',
    email: 'E-mail incorreto. Preencha seguindo o exemplo: seuemail@dominio.com.br',
    celular: 'Informe um celular com DDD no formato (21) 99999-9999.'
};

function normalizarCampoCadastro(valor) {
    return typeof valor === 'string' ? valor.trim() : '';
}

function normalizarCamposCadastro(origem) {
    const destino = {};
    CAMPOS_CADASTRO.forEach((campo) => {
        if (Object.prototype.hasOwnProperty.call(origem, campo)) {
            let valorOriginal = typeof origem[campo] === 'string' ? origem[campo] : '';
            if (campo === 'nome') {
                destino[campo] = valorOriginal;
                return;
            }

            let valor = normalizarCampoCadastro(valorOriginal);
            if (campo === 'celular') {
                valor = formatarTelefoneBr(valor);
            }
            destino[campo] = valor;
        }
    });
    return destino;
}

function obterMensagemDominioEmailBloqueado(email) {
    if (!window.CelsoEmailValidation || typeof window.CelsoEmailValidation.getBlockedDomainMessage !== 'function') {
        return '';
    }

    return window.CelsoEmailValidation.getBlockedDomainMessage(email);
}

function validarEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && !obterMensagemDominioEmailBloqueado(email);
}

function validarNomeCompletoCadastro(nome) {
    return normalizarCampoCadastro(nome)
        .split(/\s+/)
        .filter(Boolean).length >= 2;
}

function dadosCadastroValidos(dados = dadosMatricula) {
    const nome = normalizarCampoCadastro(dados.nome);
    const email = normalizarCampoCadastro(dados.email);
    const celular = normalizarCampoCadastro(dados.celular);
    return validarNomeCompletoCadastro(nome) && validarEmail(email) && telefoneBrValido(celular);
}

function obterDadosFormularioCadastro() {
    if (!formCadastro) return {};

    return {
        nome: formCadastro.querySelector('[name="nome"]')?.value || '',
        email: normalizarCampoCadastro(formCadastro.querySelector('[name="email"]')?.value || ''),
        celular: normalizarCampoCadastro(formCadastro.querySelector('[name="celular"]')?.value || ''),
        consultor: formCadastro.querySelector('[name="consultor"]')?.value || '',
    };
}

function sincronizarCampoCadastro(input) {
    if (!input || !CAMPOS_CADASTRO.includes(input.name)) return;

    let valor = input.value || '';

    if (input.name !== 'nome') {
        valor = normalizarCampoCadastro(valor);
    }

    if (input.name === 'celular') {
        valor = formatarTelefoneBr(valor);
        input.value = valor;
    }

    dadosMatricula[input.name] = valor;
}

function atualizarEstadoStep1() {
    if (!btnContinuarStep1) return;
    btnContinuarStep1.disabled = btnContinuarStep1.dataset.loading === 'true';
}

function possuiAlgumDadoCadastroPreenchido(dados = dadosMatricula) {
    return CAMPOS_CADASTRO_OBRIGATORIOS.some((campo) => {
        const valor = typeof dados?.[campo] === 'string' ? dados[campo] : '';
        return normalizarCampoCadastro(valor) !== '';
    });
}

function encontrarPrimeiroCampoCadastroInvalido(dados = dadosMatricula) {
    for (const campo of CAMPOS_CADASTRO_OBRIGATORIOS) {
        const valor = typeof dados?.[campo] === 'string' ? dados[campo] : '';
        if (obterMensagemErroCadastro(campo, valor)) {
            return campo;
        }
    }

    return '';
}

function formatarDinheiro(valorEmCentavos) {
    if (typeof window !== 'undefined' && window.CelsoCupom && typeof window.CelsoCupom.formatarDinheiro === 'function') {
        return window.CelsoCupom.formatarDinheiro(valorEmCentavos);
    }
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(valorEmCentavos, Shopify.money_format);
    }

    const currency = window.Shopify?.currency?.active || 'BRL';
    return (valorEmCentavos / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency
    });
}

function envolverSimboloMoeda(valorFormatado) {
    if (typeof valorFormatado !== 'string') return valorFormatado;

    const trimmed = valorFormatado.trim();
    if (!trimmed) return valorFormatado;

    const match = trimmed.match(/^[^0-9-]+/);
    if (!match) return valorFormatado;

    const simbolo = match[0].trim();
    if (!simbolo) return valorFormatado;

    return valorFormatado.replace(simbolo, `<span class="currency-symbol">${simbolo}</span>`).trim();
}

function isProductPageContext() {
    var pageType = enrollPopupLiquidConfig.pageType || '';
    if (pageType === 'product') return true;
    if (typeof document !== 'undefined' && document.body && document.body.classList.contains('body-product')) {
        return true;
    }
    try {
        var pathname = window.location && window.location.pathname ? String(window.location.pathname) : '';
        if (pathname.indexOf('/products/') !== -1) return true;
    } catch (error) {}
    return false;
}

// Constantes para regra de Pós-Graduação EAD (preço em parcelas)
window.__CELSO_IS_POS_GRADUACAO = enrollPopupLiquidConfig.templateSuffix === 'pos-graduacao';
window.__CELSO_PARCELAS_POS_EAD = Number(enrollPopupLiquidConfig.parcelasPosEad || 12);

function __celsoIsPosEadModalidadeValor(valor) {
    if (!valor) return false;
    const v = String(valor).toLowerCase();
    return v.indexOf('ead') !== -1 || v.indexOf('distância') !== -1 || v.indexOf('distancia') !== -1;
}

function __celsoIsPosEadAtivo(variant) {
    if (!window.__CELSO_IS_POS_GRADUACAO) return false;
    if (variant && __celsoIsPosEadModalidadeValor(variant.modalidade)) return true;
    const ativo = document.querySelector('.enroll-variant .btn-variant-option.active');
    if (ativo && __celsoIsPosEadModalidadeValor(ativo.dataset.optionValue)) return true;
    try {
        const salva = localStorage.getItem('modalidadeSelecionada');
        if (salva && __celsoIsPosEadModalidadeValor(salva)) return true;
    } catch (e) {}
    return false;
}

function __celsoEnsureInstallmentsSpanPDP(container, parcelas, mostrar) {
    if (!container) return;
    const priceIntro = container.querySelector('.price-intro--pdp');
    if (priceIntro) {
        let span = priceIntro.querySelector('.price-installments--pdp');
        if (mostrar) {
            if (!span) {
                span = document.createElement('span');
                span.className = 'price-installments price-installments--pdp';
                const currency = priceIntro.querySelector('.price-currency--pdp');
                if (currency) priceIntro.insertBefore(span, currency); else priceIntro.appendChild(span);
            }
            span.textContent = parcelas + 'x';
        } else if (span) {
            span.remove();
        }
    }
    const priceFee = container.classList && container.classList.contains('price-fee')
        ? container
        : (container.closest && container.closest('.price-fee'));
    if (priceFee) priceFee.classList.toggle('price-fee--pos-ead-installments', mostrar);
}

function atualizarPrecoNaPagina(variant) {
    if (!isProductPageContext()) return;

    const priceContainers = document.querySelectorAll('product-price [ref="priceContainer"]');
    if (!priceContainers.length) return;

    const posEad = __celsoIsPosEadAtivo(variant) && window.__CELSO_PARCELAS_POS_EAD > 0;
    const parcelas = window.__CELSO_PARCELAS_POS_EAD;

    const compareAtOriginal = Number(variant.compare_at_price || 0);
    const precoOriginal = Number(variant.price || 0);
    const possuiPrecoComparativo = compareAtOriginal > precoOriginal;

    const compareAt = compareAtOriginal;
    const precoAtual = posEad ? Math.round(precoOriginal / parcelas) : precoOriginal;

    priceContainers.forEach((container) => {
        // Nunca atualizar container que contenha a tarja rosa (badge "1º mês com o cupom")
        if (container.querySelector && container.querySelector('.celso-discount-badge')) return;
        if (container.closest && container.closest('.celso-discount-badge')) return;

        __celsoEnsureInstallmentsSpanPDP(container, parcelas, posEad);

        const priceElement = container.querySelector('.price');
        if (priceElement) {
            priceElement.innerHTML = envolverSimboloMoeda(formatarDinheiro(precoAtual));
        }

        const compareValueElement = container.querySelector('.compare-at-price-value');
        const compareGroup = compareValueElement?.closest('[role="group"]');

        if (!compareValueElement || !compareGroup) return;

        if (possuiPrecoComparativo) {
            compareValueElement.innerHTML = envolverSimboloMoeda(formatarDinheiro(compareAt));
            compareGroup.removeAttribute('hidden');
            compareGroup.style.removeProperty('display');
        } else {
            compareGroup.setAttribute('hidden', '');
            compareGroup.style.display = 'none';
        }
    });
}

function atualizarFormulariosProduto(variant) {
    if (!isProductPageContext()) return;

    const variantId = variant?.id;
    if (!variantId) return;

    document.querySelectorAll('product-form-component input[name="id"]').forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.querySelectorAll('add-to-cart-component').forEach((component) => {
        const disponivel = Boolean(variant.available);
        if (typeof component.disable === 'function' && typeof component.enable === 'function') {
            if (disponivel) {
                component.enable();
            } else {
                component.disable();
            }
        }

        const botao = component.querySelector('[ref="addToCartButton"]');
        if (botao) {
            if (disponivel) {
                botao.removeAttribute('disabled');
            } else {
                botao.setAttribute('disabled', 'disabled');
            }
        }
    });
}

function atualizarUrlVariant(variant) {
    if (!isProductPageContext()) return;

    if (!variant?.id || typeof window === 'undefined' || typeof URL === 'undefined') return;

    try {
        const urlAtual = new URL(window.location.href);
        urlAtual.searchParams.set('variant', variant.id);

        if (urlAtual.toString() !== window.location.href) {
            window.history.replaceState({}, '', urlAtual.toString());
        }
    } catch (error) {
        console.warn('Não foi possível atualizar a URL do variant selecionado:', error);
    }
}

function preencherFormCadastro(dados) {
    const form = document.getElementById('form-cadastro');
    if (!form || !dados) return;

    const campos = {
        nome: form.querySelector('[name="nome"]'),
        email: form.querySelector('[name="email"]'),
        celular: form.querySelector('[name="celular"]'),
        consultor: form.querySelector('[name="consultor"]')
    };

    Object.entries(campos).forEach(([chave, input]) => {
        if (!input) return;
        const valorOriginal = typeof dados[chave] === 'string' ? dados[chave] : '';
        const valor = chave === 'nome' ? valorOriginal : normalizarCampoCadastro(valorOriginal);
        let valorFinal = valor;
        if (chave === 'celular') {
            valorFinal = formatarTelefoneBr(valor);
        }
        if (input.value !== valorFinal) {
            input.value = valorFinal;
        }
    });

    atualizarValidacoesCadastro();
    atualizarEstadoStep1();
}

function preencherDataNascimentoInput(valor) {
    if (!birthdateInput) return;
    birthdateInput.value = formatarDataNascimento(valor || '');
    atualizarValidadeDataNascimento();
}

function obterInputCadastro(campo) {
    return formCadastro?.querySelector(`[name="${campo}"]`) || null;
}

function obterErroCadastro(campo) {
    return formCadastro?.querySelector(`[data-cadastro-error="${campo}"]`) || null;
}

function obterErroCadastroTexto(campo) {
    return formCadastro?.querySelector(`[data-cadastro-error-text="${campo}"]`) || null;
}

function obterMensagemErroCadastro(campo, valor) {
    if (campo === 'nome' && !validarNomeCompletoCadastro(valor)) {
        return CADASTRO_ERROR_MESSAGES.nome;
    }

    if (campo === 'email' && !validarEmail(normalizarCampoCadastro(valor))) {
        return obterMensagemDominioEmailBloqueado(normalizarCampoCadastro(valor)) || CADASTRO_ERROR_MESSAGES.email;
    }

    if (campo === 'celular' && !telefoneBrValido(valor)) {
        if (telefoneBrTemPadraoRepetido(valor)) {
            return 'Número inválido.';
        }
        return CADASTRO_ERROR_MESSAGES.celular;
    }

    return '';
}

function limparErroCadastro(campo) {
    const input = obterInputCadastro(campo);
    const error = obterErroCadastro(campo);
    if (!input || !error) return;

    input.classList.remove('form-input--error');
    input.removeAttribute('aria-invalid');
    input.setCustomValidity('');
    error.classList.add('is-hidden');
    error.setAttribute('aria-hidden', 'true');
}

function exibirErroCadastro(campo) {
    const input = obterInputCadastro(campo);
    const error = obterErroCadastro(campo);
    const errorText = obterErroCadastroTexto(campo);
    if (!input || !error || !errorText) return true;

    const mensagem = obterMensagemErroCadastro(campo, input.value);
    input.setCustomValidity(mensagem);

    if (!mensagem) {
        limparErroCadastro(campo);
        return true;
    }

    input.classList.add('form-input--error');
    input.setAttribute('aria-invalid', 'true');
    errorText.textContent = mensagem;
    error.setAttribute('aria-hidden', 'false');
    error.classList.remove('is-hidden');
    return false;
}

function atualizarValidacoesCadastro(exibirErros = false) {
    let formularioValido = true;

    CAMPOS_CADASTRO_OBRIGATORIOS.forEach((campo) => {
        const input = obterInputCadastro(campo);
        const campoValido = exibirErros
            ? exibirErroCadastro(campo)
            : !obterMensagemErroCadastro(campo, input?.value || '');

        if (!campoValido) {
            formularioValido = false;
        }
    });

    return formularioValido;
}

function updateBirthdateAvailability() {
    if (!birthdateInput) return;
    // Step 2: Data de nascimento sempre habilitada; libera a forma de ingresso quando válida.
    // Polo libera o turno (não mais a data de nascimento).
    birthdateInput.removeAttribute('disabled');
    birthdateInput.classList.remove('is-disabled');
}

async function salvarDadosMatricula() {

    const normalizados = normalizarCamposCadastro(dadosMatricula);

    dadosMatricula = Object.assign({}, dadosMatricula, normalizados);
    const valido = dadosCadastroValidos(dadosMatricula);

    let createNewCustomerOnERP = null;

    if (valido) {
        createNewCustomerOnERP = await newCustomer(normalizados);
    }

    try {
        localStorage.setItem('dadosMatricula', JSON.stringify(dadosMatricula));
        localStorage.setItem('checkoutPrefillData', JSON.stringify({
            email: dadosMatricula.email || '',
            nome: dadosMatricula.nome || '',
            celular: dadosMatricula.celular || '',
            updatedAt: Date.now()
        }));
    } catch (error) {
        console.warn('Não foi possível salvar dados de matrícula:', error);
    }

    window.dispatchEvent(new CustomEvent('dadosMatriculaAtualizados', {
        detail: {
            dados: Object.assign({}, dadosMatricula),
            valid: valido
        }
    }));

}

window.addEventListener('dadosMatriculaAtualizados', function(event) {
    const novosDados = event.detail && event.detail.dados;
    if (!novosDados || typeof novosDados !== 'object') return;

    const normalizados = Object.assign({}, novosDados, normalizarCamposCadastro(novosDados));
    dadosMatricula = Object.assign({}, dadosMatricula, normalizados);
    try {
        localStorage.setItem('checkoutPrefillData', JSON.stringify({
            email: dadosMatricula.email || '',
            nome: dadosMatricula.nome || '',
            celular: dadosMatricula.celular || '',
            updatedAt: Date.now()
        }));
    } catch (error) {
        console.warn('Não foi possível sincronizar o e-mail do checkout:', error);
    }
    preencherFormCadastro(dadosMatricula);
    atualizarEstadoStep1();
});

function sincronizarComVariant(variant) {
    if (!variant) return;
        const shouldSyncPdpUi = isProductPageContext();
        if (shouldSyncPdpUi) {
            setPdpPriceTransitioning(true);
        }
        atualizarFormulariosProduto(variant);
        atualizarPrecoNaPagina(variant);
        atualizarUrlVariant(variant);

        // Garante que o preço da PDP não fique invisível caso nenhum outro fluxo
        // finalize o estado de transição após a seleção da variante no modal.
        if (shouldSyncPdpUi && typeof window !== 'undefined' && window.__celsoPdpSyncTransitionTimer) {
            clearTimeout(window.__celsoPdpSyncTransitionTimer);
        }
        if (shouldSyncPdpUi && typeof window !== 'undefined' && typeof window.__celsoSchedulePdpBadgeRefresh === 'function') {
            window.__celsoSchedulePdpBadgeRefresh([80], { mostrarAoCorrigir: true });
        }
        if (shouldSyncPdpUi && typeof window !== 'undefined') {
            window.__celsoPdpSyncTransitionTimer = setTimeout(function () {
                setPdpPriceTransitioning(false);
                window.__celsoPdpSyncTransitionTimer = null;
            }, 220);
        }

        document.dispatchEvent(new CustomEvent('celso:enroll-variant-change', {
        detail: { variant }
    }));
}


const dadosMatriculaSalvos = localStorage.getItem('dadosMatricula');
if (dadosMatriculaSalvos) {
    try {
        const dadosPersistidos = JSON.parse(dadosMatriculaSalvos);
        if (dadosPersistidos && typeof dadosPersistidos === 'object') {
            const dadosPersistidosNormalizados = Object.assign(
                {},
                dadosPersistidos,
                normalizarCamposCadastro(dadosPersistidos)
            );
            dadosMatricula = Object.assign({}, dadosMatricula, dadosPersistidosNormalizados);

            const variantPersistido = todasVariantes.find((variant) => {
                return String(variant.id) === String(dadosPersistidos.variantId);
            });

            if (variantPersistido) {
                sincronizarComVariant(variantPersistido);
                atualizarAvisoPreco(variantPersistido);
            }
            if (dadosPersistidos.dataNascimento) {
                preencherDataNascimentoInput(dadosPersistidos.dataNascimento);
            }
        }
    } catch (error) {
        console.warn('Não foi possível recuperar os dados salvos de matrícula:', error);
    }
}

preencherFormCadastro(dadosMatricula);
preencherDataNascimentoInput(dadosMatricula.dataNascimento);
atualizarEstadoStep1();
atualizarValidacoesCadastro();
updateBirthdateAvailability();

if (formCadastro) {
    formCadastro.addEventListener('input', atualizarEstadoStep1);
    formCadastro.addEventListener('change', atualizarEstadoStep1);
}

[
    nameInputCadastro,
    emailInputCadastro,
    phoneInputCadastro
].forEach((input) => {
    if (!input) return;

    input.addEventListener('input', function() {
        sincronizarCampoCadastro(input);
        if (input.name === 'celular') {
            aplicarMascaraTelefoneBr(input);
        }
        atualizarValidacoesCadastro(false);
    });

    input.addEventListener('blur', function() {
        sincronizarCampoCadastro(input);
        if (input.name === 'celular') {
            aplicarMascaraTelefoneBr(input);
        }
        exibirErroCadastro(input.name);
    });

    input.addEventListener('focus', function() {
        limparErroCadastro(input.name);
    });
});

if (phoneInputCadastro) {
    phoneInputCadastro.maxLength = PHONE_VISIBLE_MAX_LENGTH;
    aplicarMascaraTelefoneBr(phoneInputCadastro);
    phoneInputCadastro.addEventListener('keydown', function(event) {
        tratarBackspaceTelefoneBr(phoneInputCadastro, event);
    });
}

if (birthdateInput) {
    aplicarMascaraDataNascimento(birthdateInput);
    birthdateInput.addEventListener('input', function() {
        aplicarMascaraDataNascimento(birthdateInput);
        dadosMatricula.dataNascimento = birthdateInput.value.trim();
        atualizarValidadeDataNascimento();
        verificarFormularioStep3Completo();
    });
    birthdateInput.addEventListener('blur', function() {
        atualizarValidadeDataNascimento(true);
        verificarFormularioStep3Completo();
    });
}

function abrirPopupInterno(options = {}) {
    if (!options.skipInlineValidation && window.CelsoEnrollDataValidator && typeof window.CelsoEnrollDataValidator.validate === 'function') {
        const dadosInlineValidos = window.CelsoEnrollDataValidator.validate();
        if (!dadosInlineValidos) {
            return;
        }
    }

    const popup = document.querySelector('enroll-popup.product-enroll-popup');
    if (!popup) return;

    preencherFormCadastro(dadosMatricula);
    if (phoneInputCadastro) {
        aplicarMascaraTelefoneBr(phoneInputCadastro);
    }
    atualizarValidacoesCadastro(false);

    popup.open();
    resetModalTrackingState();
    irParaStep(1);
    trackModalStart();

    const possuiDadosPreenchidos = possuiAlgumDadoCadastroPreenchido(dadosMatricula);
    const primeiroCampoInvalido = encontrarPrimeiroCampoCadastroInvalido(dadosMatricula);

    if (possuiDadosPreenchidos && primeiroCampoInvalido) {
        atualizarValidacoesCadastro(true);
        obterInputCadastro(primeiroCampoInvalido)?.focus();
    }

    verificarFormularioCompleto();
}

window.abrirPopupMatricula = function(productId, options = {}) {
    setActivePoloFilter(options);
    if (window.EnrollPopupRegistry && typeof window.EnrollPopupRegistry.open === 'function') {
        window.EnrollPopupRegistry.open(productId || activeProductId, options);
        return;
    }
    abrirPopupInterno(options);
};

function isModalidadeRequired() {
    if (typeof window !== 'undefined' && typeof window.ENROLL_MODALIDADE_REQUIRED === 'boolean') {
        return window.ENROLL_MODALIDADE_REQUIRED;
    }
    const optionIndex = getOptionIndexByName(ENROLL_OPTION_LABELS.modalidade);
    if (optionIndex >= 0) {
        const possuiValoresValidos = todasVariantes.some((variant) => {
            const valor = getVariantOptionValue(variant, ENROLL_OPTION_LABELS.modalidade);
            return typeof valor === 'string' && valor.trim().length > 0;
        });
        if (possuiValoresValidos) {
            return true;
        }
    }
    const hasButtons = document.querySelector('.enroll-variant .btn-variant-option') !== null;
    return hasButtons;
}

function atualizarAvisoPreco(variant) {
    if (!priceNoticeElement || !priceNoticeTextElement) return;

    const precoAtual = Number(variant?.price ?? 0);
    const precoReferencia = Number(precoBase);

    if (!variant || !Number.isFinite(precoReferencia) || Math.abs(precoAtual - precoReferencia) < 1) {
        priceNoticeElement.hidden = true;
        priceNoticeElement.setAttribute('hidden', '');
        return;
    }

    const precoAtualFormatado = envolverSimboloMoeda(formatarDinheiro(precoAtual));
    priceNoticeTextElement.innerHTML = 'Para as opções escolhidas, o valor do curso foi atualizado.';

    priceNoticeElement.hidden = false;
    priceNoticeElement.removeAttribute('hidden');
}

function setAvailabilityMessage(message) {
    if (!availabilityMessageElement || !availabilityMessageTextElement) return;
    if (typeof message === 'string' && message.trim().length) {
        availabilityMessageTextElement.textContent = message.trim();
        availabilityMessageElement.hidden = false;
        availabilityMessageElement.removeAttribute('hidden');
    } else {
        availabilityMessageElement.hidden = true;
        availabilityMessageElement.setAttribute('hidden', '');
        availabilityMessageTextElement.textContent = '';
    }
}

function renderTurnoPlaceholder(message) {
    if (!turnoButtonsElement || !turnoContainerElement) return;
    turnoButtonsElement.innerHTML = '';
    turnoContainerElement.removeAttribute('hidden');
    dadosMatricula.turno = '';
    turnoObrigatorio = true;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn-turno-option is-disabled';
    button.setAttribute('disabled', 'disabled');
    button.textContent = message || 'Selecione a forma de ingresso';
    turnoButtonsElement.appendChild(button);
}

/** Turnos da forma de ingresso, filtrados pelo polo já selecionado. */
function popularTurnosAposForma() {
    if (!turnoButtonsElement || !turnoContainerElement) return;
    turnoButtonsElement.innerHTML = '';
    turnoContainerElement.removeAttribute('hidden');
    turnoObrigatorio = false;
    if (!dadosMatricula.formaIngresso) {
        renderTurnoPlaceholder('Selecione a forma de ingresso');
        return;
    }
    const variants = getLocationVariants({ polo: true, forma: true });
    const turnos = Array.from(new Set(variants.map(getEnrollmentTurno).filter(Boolean)));
    if (!turnos.length) {
        turnoContainerElement.setAttribute('hidden', '');
        dadosMatricula.turno = '';
        verificarFormularioCompleto();
        return;
    }
    turnoObrigatorio = true;
    const selecionar = (turno) => {
        limparOfertaMatricula({ limparForma: false });
        dadosMatricula.turno = turno;
        turnoButtonsElement.querySelectorAll('.btn-turno-option').forEach((btn) => btn.classList.toggle('active', btn.dataset.turno === turno));
        verificarFormularioCompleto();
    };
    turnos.forEach((turno) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'btn-turno-option';
        button.dataset.turno = turno;
        button.textContent = turno;
        button.addEventListener('click', () => selecionar(turno));
        turnoButtonsElement.appendChild(button);
    });
    // Não escolhe um turno arbitrário quando há mais de uma opção.
    if (turnos.includes(dadosMatricula.turno)) selecionar(dadosMatricula.turno);
    else if (turnos.length === 1) selecionar(turnos[0]);
    else { dadosMatricula.turno = ''; verificarFormularioCompleto(); }
}

// ========================================
// RASTREAMENTO MIXPANEL (popup Matricule-se)
// ========================================

const SIGNUP_STEP_NAMES = {
    1: 'Cadastro',
    2: 'Informações',
    3: 'Seus dados',
    4: 'Pagamento'
};

const MODAL_TRACKING_STEP_EVENTS = {
    1: 'modal_step_1_completed',
    2: 'modal_step_2_completed',
    3: 'modal_step_3_completed'
};

function createModalTrackingState() {
    return {
        started: false,
        stepsCompleted: {
            1: false,
            2: false,
            3: false
        },
        checkoutRedirect: false
    };
}

let modalTrackingState = createModalTrackingState();

function resetModalTrackingState() {
    modalTrackingState = createModalTrackingState();
}

function normalizeTrackingValue(value) {
    if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
            const normalized = normalizeTrackingValue(value[i]);
            if (normalized) return normalized;
        }
        return '';
    }

    if (value && typeof value === 'object') {
        if ('value' in value) return normalizeTrackingValue(value.value);
        if ('name' in value) return normalizeTrackingValue(value.name);
        if ('title' in value) return normalizeTrackingValue(value.title);
        if ('label' in value) return normalizeTrackingValue(value.label);
        return '';
    }

    if (value === null || typeof value === 'undefined') return '';
    return String(value).trim();
}

function readModalTrackingCookie(name) {
    try {
        const escapedName = String(name || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const match = document.cookie.match(new RegExp('(^|;\\s*)' + escapedName + '=([^;]*)'));
        return match && match[2] ? decodeURIComponent(match[2]) : '';
    } catch (error) {
        return '';
    }
}

function readModalTrackingStoredValue(key) {
    try {
        const localValue = window.localStorage.getItem(key);
        if (localValue !== null) return localValue;
    } catch (error) {}

    try {
        const sessionValue = window.sessionStorage.getItem(key);
        if (sessionValue !== null) return sessionValue;
    } catch (error) {}

    return readModalTrackingCookie(key);
}

function buildModalUtmPayload() {
    let urlValues = {};
    let acquisitionUtms = {};

    try {
        const currentUrl = new URL(window.location.href);
        urlValues = readModalUtmValuesFromUrl(currentUrl);
        acquisitionUtms = resolveModalAcquisitionUtms(currentUrl);
    } catch (error) {
        acquisitionUtms = resolveModalAcquisitionUtms(null);
    }

    return {
        utm_source: acquisitionUtms.utm_source || '',
        utm_medium: acquisitionUtms.utm_medium || '',
        utm_campaign: acquisitionUtms.utm_campaign || '',
        utm_term: acquisitionUtms.utm_term || '',
        utm_content: urlValues.utm_content || ''
    };
}

function buildModalContextPayload() {
    return {
        conversion_origin: 'modal',
        formacao: normalizeTrackingValue(dadosMatricula.nivelEnsino) || normalizeTrackingValue(activeProductFormacao),
        area: normalizeTrackingValue(activeProductArea),
        curso: normalizeTrackingValue(activeProductTitle) || normalizeTrackingValue(activeProductHandle),
        modalidade: normalizeTrackingValue(dadosMatricula.modalidade) || normalizeTrackingValue(readModalTrackingStoredValue('modalidadeSelecionada')),
        forma_ingresso: normalizeTrackingValue(dadosMatricula.formaIngresso),
        turno: normalizeTrackingValue(dadosMatricula.turno),
        estado: normalizeTrackingValue(dadosMatricula.estado),
        cidade: normalizeTrackingValue(dadosMatricula.cidade),
        polo: normalizeTrackingValue(dadosMatricula.polo)
    };
}

function buildModalTrackingPayload(extraProperties) {
    return Object.assign(
        {},
        buildModalUtmPayload(),
        buildModalContextPayload(),
        extraProperties || {}
    );
}

function trackModalEvent(eventName, extraProperties) {
    if (!eventName) return;
    const payload = buildModalTrackingPayload(extraProperties);

    try {
        window.dataLayer = Array.isArray(window.dataLayer) ? window.dataLayer : [];
        window.dataLayer.push(Object.assign({ event: eventName }, payload));
    } catch (error) {}

    try {
        if (window.CelsoMixpanel && typeof window.CelsoMixpanel.track === 'function') {
            window.CelsoMixpanel.track(eventName, payload);
        }
    } catch (error) {}

    try {
        window.dispatchEvent(new CustomEvent('celso:modal_tracking', {
            detail: Object.assign({ event: eventName }, payload)
        }));
    } catch (error) {}
}

function trackModalStart() {
    if (modalTrackingState.started) return;
    modalTrackingState.started = true;
    trackModalEvent('modal_start', {
        formacao: normalizeTrackingValue(dadosMatricula.nivelEnsino) || normalizeTrackingValue(activeProductFormacao),
        area: normalizeTrackingValue(activeProductArea),
        curso: normalizeTrackingValue(activeProductTitle) || normalizeTrackingValue(activeProductHandle),
        modalidade: normalizeTrackingValue(dadosMatricula.modalidade) || normalizeTrackingValue(readModalTrackingStoredValue('modalidadeSelecionada')),
        forma_ingresso: '',
        turno: '',
        estado: '',
        cidade: '',
        polo: ''
    });
}

function trackModalStepCompleted(stepNumber, extraProperties) {
    const eventName = MODAL_TRACKING_STEP_EVENTS[stepNumber];
    if (!eventName || modalTrackingState.stepsCompleted[stepNumber]) return;
    modalTrackingState.stepsCompleted[stepNumber] = true;
    trackModalEvent(eventName, extraProperties);
}

function trackModalCheckoutRedirect(extraProperties) {
    if (modalTrackingState.checkoutRedirect) return;
    modalTrackingState.checkoutRedirect = true;
    trackModalEvent('modal_checkout_redirect', extraProperties);
}

function trackSignupStep(eventName, stepNumero, extraProperties) {
    if (!window.CelsoMixpanel) return;
    const varianteSelecionada = obterVariantePorId(dadosMatricula.variantId);
    const precoAtual = varianteSelecionada ? Number(varianteSelecionada.price) : Number(precoBase) || undefined;

    window.CelsoMixpanel.track(eventName, Object.assign({
        step_name: SIGNUP_STEP_NAMES[stepNumero] || String(stepNumero),
        step_number: stepNumero,
        email: dadosMatricula.email || undefined,
        course_name: activeProductTitle || '',
        modality: dadosMatricula.modalidade || '',
        campus: dadosMatricula.polo || '',
        price: precoAtual
    }, extraProperties || {}));
}

// ========================================
// FUNÇÕES DE NAVEGAÇÃO
// ========================================

function irParaStep(stepNumero) {
    atualizarUtmContentModalNaUrl(stepNumero);

    const popupRoot = document.querySelector('enroll-popup.product-enroll-popup');
    popupRoot?.goToStep(stepNumero);
    
    // Estado → Cidade → Polo → Forma de ingresso → Turno.
    if (stepNumero === 2) {
        inicializarLocalizacaoMatricula();
    }

    if (stepNumero === 3) {
        agendarVerificacaoStep3Completo();
    }

    trackSignupStep('Signup Step Viewed', stepNumero);
}

function fecharPopup() {
    const popup = document.querySelector('enroll-popup.product-enroll-popup');
    popup?.close();
}

// ========================================
// STEP 1 - CADASTRO
// ========================================

document.querySelector('[data-step="1"] .btn-continuar').addEventListener('click', async function() {
    const form = document.getElementById('form-cadastro');
    const btnContinuar = this;

    if (btnContinuar.dataset.loading === 'true') return;
    
    if (!atualizarValidacoesCadastro(true)) {
        return;
    }

    btnContinuar.disabled = true;
    setContinueButtonLoading(btnContinuar, true);
    
    try {
        const novosDados = {
            nome: form.querySelector('[name="nome"]').value,
            email: form.querySelector('[name="email"]').value,
            celular: formatarTelefoneBr(form.querySelector('[name="celular"]').value),
            consultor: form.querySelector('[name="consultor"]').value || ''
        };
        dadosMatricula = Object.assign({}, dadosMatricula, normalizarCamposCadastro(novosDados));

        await salvarDadosMatricula();

        if (window.CelsoMixpanel) {
            window.CelsoMixpanel.identify(dadosMatricula.email, {
                name: dadosMatricula.nome || '',
                phone: dadosMatricula.celular || ''
            });
        }
        trackSignupStep('Signup Step Completed', 1);
        trackModalStepCompleted(1);

        irParaStep(2);
        verificarFormularioCompleto();
    } finally {
        setContinueButtonLoading(btnContinuar, false);
        atualizarEstadoStep1();
    }
});

// ========================================
// STEP 2 - INFORMAÇÕES (VARIANTES)
// ========================================

function popularEstados() {
    if (usePolosMetafield()) {
        return popularEstadosMetafield();
    }
    const selectEstado = document.querySelector('select[name="estado"]');
    if (!selectEstado) return;

    const variantesBase = getLocationVariants();
    const estados = [...new Set(
        variantesBase
            .map((v) => dividirPolo(getPoloValue(v)).estado)
            .filter(Boolean)
    )].sort();

    selectEstado.innerHTML = '<option value="">Estado</option>';
    estados.forEach((estado) => {
        const option = document.createElement('option');
        option.value = estado;
        option.textContent = estado;
        selectEstado.appendChild(option);
    });
    selectEstado.disabled = estados.length === 0;
}

function popularCidades(estadoSelecionado) {
    if (usePolosMetafield()) {
        return popularCidadesMetafield(estadoSelecionado);
    }
    const selectCidade = document.querySelector('select[name="cidade"]');
    const selectPolo = document.querySelector('select[name="polo"]');
    if (!selectCidade || !selectPolo) return;

    if (!estadoSelecionado) {
        selectCidade.disabled = true;
        selectPolo.disabled = true;
        selectCidade.innerHTML = '<option value="">Cidade</option>';
        selectPolo.innerHTML = '<option value="">Unidade/Polo</option>';
        return;
    }

    const variantesBase = getLocationVariants();
    const variantesEstado = variantesBase.filter((v) => {
        const poloValor = getPoloValue(v);
        return poloValor && poloValor.startsWith(`${estadoSelecionado} - `);
    });
    const cidades = [...new Set(
        variantesEstado
            .map((v) => dividirPolo(getPoloValue(v)).cidade)
            .filter(Boolean)
    )].sort();

    selectCidade.innerHTML = '<option value="">Cidade</option>';
    selectCidade.disabled = false;
    cidades.forEach((cidade) => {
        const option = document.createElement('option');
        option.value = cidade;
        option.textContent = cidade;
        selectCidade.appendChild(option);
    });
    selectPolo.disabled = true;
    selectPolo.innerHTML = '<option value="">Unidade/Polo</option>';
}

function formatarNomeUnidadePolo(nome) {
    const original = String(nome || '');
    const unidade = /\bUNIDADE\b/i.exec(original);
    if (!unidade) return original;
    return original.slice(unidade.index).replace(/\s*[-–—]\s*[A-Z]{2}\s*$/i, '').trim();
}

function popularPolos(estadoSelecionado, cidadeSelecionada) {
    if (usePolosMetafield()) {
        return popularPolosMetafield(estadoSelecionado, cidadeSelecionada);
    }
    const selectPolo = document.querySelector('select[name="polo"]');
    if (!selectPolo) return;
    if (!cidadeSelecionada) {
        selectPolo.disabled = true;
        selectPolo.innerHTML = '<option value="">Unidade/Polo</option>';
        return;
    }

    const variantesBase = getLocationVariants();
    const polosMap = new Map();
    variantesBase.forEach((variant) => {
        const info = dividirPolo(getPoloValue(variant));
        if (!info.estado || !info.cidade || !info.polo) return;
        if (info.estado !== estadoSelecionado || info.cidade !== cidadeSelecionada) return;
        const baseKey = montarPoloBase(info);
        if (!baseKey || polosMap.has(baseKey)) return;
        polosMap.set(baseKey, info.polo);
    });
    const polos = Array.from(polosMap.entries()).sort(([ , a ], [ , b ]) => {
        const normalizedA = a.toLowerCase();
        const normalizedB = b.toLowerCase();
        const aIsUnidade = normalizedA.includes('unidade');
        const bIsUnidade = normalizedB.includes('unidade');

        if (aIsUnidade && !bIsUnidade) return -1;
        if (!aIsUnidade && bIsUnidade) return 1;
        return normalizedA.localeCompare(normalizedB, 'pt', { sensitivity: 'base' });
    });
    selectPolo.innerHTML = '<option value="">Unidade/Polo</option>';
    selectPolo.disabled = polos.length === 0;
    polos.forEach(([poloValue, poloLabel]) => {
        const option = document.createElement('option');
        option.value = poloValue;
        option.textContent = formatarNomeUnidadePolo(poloLabel);
        option.dataset.originalLabel = poloLabel;
        if (poloLabel.toLowerCase().includes('unidade')) {
            option.classList.add('unidade');
        }
        selectPolo.appendChild(option);
    });
}

function popularFormasIngresso() {
    const group = document.querySelector('.product-enroll-popup .forma-ingresso-group');
    if (!group) return;
    group.innerHTML = '';
    const variants = getLocationVariants({ polo: true });
    const forms = Array.from(new Set(variants.map((v) => normalizarFormaIngresso(getVariantOptionValue(v, ENROLL_OPTION_LABELS.formaIngresso))).filter(Boolean)));
    if (!forms.length) {
        const placeholder = document.createElement('button');
        placeholder.type = 'button';
        placeholder.className = 'btn-forma-ingresso is-disabled';
        placeholder.disabled = true;
        placeholder.textContent = (dadosMatricula.poloKey || dadosMatricula.polo) ? 'Nenhuma forma de ingresso disponível' : 'Selecione a unidade/polo';
        group.appendChild(placeholder);
        dadosMatricula.formaIngresso = '';
        return;
    }
    const selected = normalizarFormaIngresso(dadosMatricula.formaIngresso);
    if (!forms.includes(selected)) dadosMatricula.formaIngresso = '';
    forms.forEach((forma) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'btn-forma-ingresso';
        button.dataset.forma = forma;
        button.textContent = forma;
        button.classList.toggle('active', forma === selected);
        button.addEventListener('click', () => {
            limparOfertaMatricula();
            dadosMatricula.formaIngresso = forma;
            group.querySelectorAll('.btn-forma-ingresso').forEach((btn) => btn.classList.toggle('active', btn.dataset.forma === forma));
            popularTurnosAposForma();
            verificarFormularioCompleto();
        });
        group.appendChild(button);
    });
}

function applySelectedPoloValue(value, fallbackLabel = '') {
    dadosMatricula.poloId = '';
    dadosMatricula.poloKey = '';

    if (usePolosMetafield()) {
        dadosMatricula.poloKey = value;
        const entry = getAggregatedPoloEntry(value);
        if (entry) {
            dadosMatricula.polo = entry.display || `${entry.uf} - ${entry.cidade} - ${entry.polo}`;
            dadosMatricula.poloId = entry.ids && entry.ids.size
                ? (Array.from(entry.ids).find((id) => normalizePoloId(id) === getActivePoloId()) || Array.from(entry.ids)[0])
                : '';
            if (entry.uf) dadosMatricula.estado = entry.uf;
            if (entry.cidade) dadosMatricula.cidade = entry.cidade;
        } else {
            dadosMatricula.polo = fallbackLabel || value;
        }
    } else {
        dadosMatricula.polo = value;
    }
    limparOfertaMatricula();
    popularFormasIngresso();
    popularTurnosAposForma();
}

function popularEstadosMetafield() {
    const selectEstado = document.querySelector('select[name="estado"]');
    if (!selectEstado) return;
    const entries = getAggregatedPoloEntriesForFormaETurno(null, null);
    const estados = [...new Set(entries.map((entry) => entry.uf).filter(Boolean))].sort();
    selectEstado.innerHTML = '<option value="">Estado</option>';
    estados.forEach((estado) => {
        const option = document.createElement('option');
        option.value = estado;
        option.textContent = estado;
        selectEstado.appendChild(option);
    });
    selectEstado.disabled = estados.length === 0;
    if (hasActivePoloFilter() && estados.length === 1) {
        dadosMatricula.estado = estados[0];
        selectEstado.value = estados[0];
        popularCidadesMetafield(estados[0]);
    }
}

function popularCidadesMetafield(estadoSelecionado) {
    const selectCidade = document.querySelector('select[name="cidade"]');
    const selectPolo = document.querySelector('select[name="polo"]');
    if (!selectCidade || !selectPolo) return;
    if (!estadoSelecionado) {
        selectCidade.disabled = true;
        selectPolo.disabled = true;
        selectCidade.innerHTML = '<option value="">Cidade</option>';
        selectPolo.innerHTML = '<option value="">Unidade/Polo</option>';
        return;
    }
    const entries = getAggregatedPoloEntriesForFormaETurno(null, null);
    const cidades = [...new Set(
        entries.filter((e) => e.uf === estadoSelecionado).map((entry) => entry.cidade).filter(Boolean)
    )].sort();
    selectCidade.innerHTML = '<option value="">Cidade</option>';
    selectCidade.disabled = cidades.length === 0;
    cidades.forEach((cidade) => {
        const option = document.createElement('option');
        option.value = cidade;
        option.textContent = cidade;
        selectCidade.appendChild(option);
    });
    selectPolo.disabled = true;
    selectPolo.innerHTML = '<option value="">Unidade/Polo</option>';
    if (hasActivePoloFilter() && cidades.length === 1) {
        dadosMatricula.cidade = cidades[0];
        selectCidade.value = cidades[0];
        popularPolosMetafield(estadoSelecionado, cidades[0]);
    }
}

function popularPolosMetafield(estadoSelecionado, cidadeSelecionada) {
    const selectPolo = document.querySelector('select[name="polo"]');
    if (!selectPolo) return;
    if (!cidadeSelecionada) {
        selectPolo.disabled = true;
        selectPolo.innerHTML = '<option value="">Unidade/Polo</option>';
        return;
    }
    const entries = getAggregatedPoloEntriesForFormaETurno(null, null);
    const entradas = entries.filter((e) => e.uf === estadoSelecionado && e.cidade === cidadeSelecionada);
    const polos = entradas
        .map((entry) => ({
            key: getAggregatedPoloKey(entry.uf, entry.cidade, entry.polo),
            label: entry.polo,
            display: entry.display
        }))
        .sort((a, b) => {
            const normalizedA = a.label.toLowerCase();
            const normalizedB = b.label.toLowerCase();
            const aIsUnidade = normalizedA.includes('unidade');
            const bIsUnidade = normalizedB.includes('unidade');

            if (aIsUnidade && !bIsUnidade) return -1;
            if (!aIsUnidade && bIsUnidade) return 1;
            return normalizedA.localeCompare(normalizedB, 'pt', { sensitivity: 'base' });
        });
    selectPolo.innerHTML = '<option value="">Unidade/Polo</option>';
    selectPolo.disabled = polos.length === 0;
    polos.forEach((item) => {
        const option = document.createElement('option');
        option.value = item.key;
        option.textContent = formatarNomeUnidadePolo(item.label);
        option.dataset.originalLabel = item.label;
        option.dataset.display = item.display || item.label;
        if (item.label.toLowerCase().includes('unidade')) {
            option.classList.add('unidade');
        }
        selectPolo.appendChild(option);
    });
    if (hasActivePoloFilter() && polos.length === 1) {
        selectPolo.value = polos[0].key;
        applySelectedPoloValue(polos[0].key, polos[0].label);
        verificarFormularioCompleto();
    }
}

function popularTurnos(poloBaseSelecionado) {
    popularTurnosAposForma();
}

function obterModalidadesDisponiveis() {
    if (!isModalidadeRequired()) return null;
    if (!(dadosMatricula.poloKey || dadosMatricula.polo)) return null;
    return Array.from(new Set(getLocationVariants({ polo: true, forma: Boolean(dadosMatricula.formaIngresso), turno: true, modalidade: false })
        .map((v) => getVariantOptionValue(v, ENROLL_OPTION_LABELS.modalidade)).filter(Boolean)));
}

function notificarModalidadesDisponiveis(modalidades, selecionada) {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent('enroll:modalidades-disponiveis', {
        detail: {
            modalidades: Array.isArray(modalidades) ? modalidades.slice() : null,
            selecionada: selecionada || ''
        }
    }));
}

function limparDependenciasDaModalidade() {
    limparOfertaMatricula();
    dadosMatricula.estado = '';
    dadosMatricula.cidade = '';
    dadosMatricula.poloId = '';
    dadosMatricula.poloKey = '';
    dadosMatricula.polo = '';
    resetSelectOptions(document.querySelector('select[name="cidade"]'), 'Cidade', { disable: true });
    resetSelectOptions(document.querySelector('select[name="polo"]'), 'Unidade/Polo', { disable: true });
    inicializarLocalizacaoMatricula();
    verificarFormularioCompleto();
}

function handleModalidadeSelecionadaNoPopup(event) {
    const source = event?.detail?.source || '';
    const deveResetarDependencias = source === 'click';

    if (deveResetarDependencias) {
        limparDependenciasDaModalidade();
        return;
    }

    popularFormasIngresso();
    if (dadosMatricula.formaIngresso) {
        popularTurnosAposForma();
    }
    verificarFormularioCompleto();
}

// Event Listeners
document.querySelector('select[name="estado"]').addEventListener('change', function() {
    limparOfertaMatricula();
    dadosMatricula.estado = this.value;
    dadosMatricula.cidade = '';
    dadosMatricula.poloId = '';
    dadosMatricula.poloKey = '';
    dadosMatricula.polo = '';
    popularCidades(this.value);
    popularFormasIngresso();
    popularTurnosAposForma();
    verificarFormularioCompleto();
});

document.querySelector('select[name="cidade"]').addEventListener('change', function() {
    limparOfertaMatricula();
    dadosMatricula.cidade = this.value;
    dadosMatricula.poloId = '';
    dadosMatricula.poloKey = '';
    dadosMatricula.polo = '';
    popularPolos(dadosMatricula.estado, this.value);
    popularFormasIngresso();
    popularTurnosAposForma();
    verificarFormularioCompleto();
});

document.querySelector('select[name="polo"]').addEventListener('change', function() {
    const selectedOption = this.options[this.selectedIndex];
    applySelectedPoloValue(this.value, selectedOption?.dataset.originalLabel || selectedOption?.textContent || this.value);
    verificarFormularioCompleto();
});

function verificarFormularioCompleto() {
    const button = document.querySelector('[data-step="2"] .btn-continuar');
    if (!button) return;
    button.disabled = true;
    if (button.dataset.loading === 'true') return;
    setAvailabilityMessage('');
    const hasPolo = usePolosMetafield() ? Boolean(dadosMatricula.poloKey) : Boolean(dadosMatricula.polo);
    if (!dadosMatricula.estado || !dadosMatricula.cidade || !hasPolo || !dadosMatricula.formaIngresso || (turnoObrigatorio && !dadosMatricula.turno)) {
        dadosMatricula.variantId = null;
        dadosMatricula.varianteSku = '';
        dadosMatricula.codCurso = '';
        atualizarAvisoPreco(null);
        return;
    }
    const candidates = getLocationVariants({ polo: true, forma: true, turno: true });
    const variant = escolherVarianteMatricula(candidates);
    if (!variant) {
        limparOfertaMatricula({ limparForma: false });
        setAvailabilityMessage('As opções selecionadas não estão disponíveis para este polo.');
        return;
    }
    dadosMatricula.variantId = variant.id;
    dadosMatricula.varianteSku = String(variant.sku || '');
    dadosMatricula.codCurso = String(variant.codCurso || '');
    dadosMatricula.nivelEnsino = String(activeProductFormacao || '');
    dadosMatricula.formaIngresso = getVariantOptionValue(variant, ENROLL_OPTION_LABELS.formaIngresso);
    dadosMatricula.modalidade = getVariantOptionValue(variant, ENROLL_OPTION_LABELS.modalidade) || '';
    if (isModalidadeRequired() && !lerModalidadeMatricula() && dadosMatricula.modalidade) {
        localStorage.setItem('modalidadeSelecionada', dadosMatricula.modalidade);
    }
    notificarModalidadesDisponiveis(obterModalidadesDisponiveis(), dadosMatricula.modalidade);
    sincronizarComVariant(variant);
    atualizarAvisoPreco(variant);
    button.disabled = false;
}

window.addEventListener('modalidadeSelecionada', handleModalidadeSelecionadaNoPopup);
window.addEventListener('modalidadeRequirementUpdated', verificarFormularioCompleto);

// Botão continuar do Step 2
document.querySelector('[data-step="2"] .btn-continuar').addEventListener('click', async function() {
    const btnContinuar = this;

    if (btnContinuar.dataset.loading === 'true') return;

    if (!dadosMatricula.variantId) {
        alert('Por favor, selecione todas as opções');
        return;
    }

    btnContinuar.disabled = true;
    setContinueButtonLoading(btnContinuar, true);

    try {
        try {
            await newRegisterOrders(buildRegisterOrdersPayload());
        } catch (error) {
            console.error('Erro ao enviar dados para newRegisterOrders:', error);
        }

        trackSignupStep('Signup Step Completed', 2, {
            forma_ingresso: dadosMatricula.formaIngresso || '',
            turno: dadosMatricula.turno || ''
        });
        trackModalStepCompleted(2);

        irParaStep(3);
    } finally {
        setContinueButtonLoading(btnContinuar, false);
        verificarFormularioCompleto();
    }
});

// ========================================
// STEP 3 - SEUS DADOS
// ========================================

if (cpfInput) {
    aplicarMascaraCPF(cpfInput);
    cpfInput.addEventListener('input', function() {
        aplicarMascaraCPF(cpfInput);
        dadosMatricula.cpf = cpfInput.value.trim();
        atualizarValidadeCPF();
        verificarFormularioStep3Completo();
    });
    cpfInput.addEventListener('blur', function() {
        atualizarValidadeCPF(true);
        verificarFormularioStep3Completo();
    });
}

if (cepInput) {
    aplicarMascaraCEP(cepInput);
    cepInput.addEventListener('input', async function() {
        aplicarMascaraCEP(cepInput);
        const digits = cepInput.value.replace(/\D/g, '');
        dadosMatricula.cep = cepInput.value.trim();
        limparErroCEP();
        if (digits.length === 8) {
            cepInput.classList.add('is-loading');
            const data = await buscarEnderecoPorCEP(digits);
            cepInput.classList.remove('is-loading');
            if (data) {
                preencherEnderecoViaCEP(data);
            } else {
                mostrarErroCEP('CEP não encontrado.');
            }
        }
        verificarFormularioStep3Completo();
    });
}

if (estadoEnderecoSelect) {
    estadoEnderecoSelect.addEventListener('change', function() {
        dadosMatricula.estadoEndereco = this.value;
        verificarFormularioStep3Completo();
    });
}

if (cidadeEnderecoInput) {
    cidadeEnderecoInput.addEventListener('input', function() {
        dadosMatricula.cidadeEndereco = this.value.trim();
        verificarFormularioStep3Completo();
    });
}

if (bairroInput) {
    bairroInput.addEventListener('input', function() {
        dadosMatricula.bairro = this.value.trim();
        verificarFormularioStep3Completo();
    });
}

if (ruaInput) {
    ruaInput.addEventListener('input', function() {
        dadosMatricula.rua = this.value.trim();
        verificarFormularioStep3Completo();
    });
}

if (numeroInput) {
    numeroInput.addEventListener('input', function() {
        dadosMatricula.numero = this.value.trim();
        verificarFormularioStep3Completo();
    });
}

if (complementoInput) {
    complementoInput.addEventListener('input', function() {
        dadosMatricula.complemento = this.value.trim();
    });
}

// Botão finalizar do Step 3
const btnFinalizarStep3 = document.getElementById('btn-finalizar-step3');
if (btnFinalizarStep3) {
    btnFinalizarStep3.addEventListener('click', async function() {
        atualizarValidadeCPF(true);
        if (cpfInput && !validarCPF(cpfInput.value)) {
            cpfInput.focus();
            return;
        }

        atualizarValidadeDataNascimento(true);
        if (birthdateInput && !dataNascimentoValida(birthdateInput.value.trim())) {
            birthdateInput.focus();
            return;
        }

        if (!dadosMatricula.variantId) {
            alert('Por favor, volte e selecione todas as opções');
            return;
        }

        const finalizarButton = this;
        if (finalizarButton.dataset.loading === 'true') return;

        finalizarButton.disabled = true;
        setContinueButtonLoading(finalizarButton, true);
        const vaiRedirecionar = shouldRedirectHomeWithOpenCart();
        if (vaiRedirecionar) mostrarRedirecionamentoMatricula();
        trackModalStepCompleted(3, {
            coupon_code: dadosMatricula.cupomCodigo || ''
        });

        try {
            const adicionouComSucesso = await adicionarAoCarrinho();

            if (!adicionouComSucesso) {
                finalizarButton.disabled = false;
                if (vaiRedirecionar) esconderRedirecionamentoMatricula();
            }
        } catch (error) {
            if (vaiRedirecionar) esconderRedirecionamentoMatricula();
            throw error;
        } finally {
            setContinueButtonLoading(finalizarButton, false);
        }
    });
}

// ========================================
// CUPONS / DESCONTOS (usa CelsoCupom em assets/cupom-utils.js)
// ========================================

var CelsoCupom = typeof window !== 'undefined' ? window.CelsoCupom : null;

function obterVariantePorId(variantId) {
    const variantIdStr = variantId === null || typeof variantId === 'undefined'
        ? ''
        : String(variantId);
    if (!variantIdStr) return null;
    return todasVariantes.find(variant => String(variant.id) === variantIdStr) || null;
}

function getCupomFromUrl() {
    return CelsoCupom ? CelsoCupom.getCupomFromUrl() : '';
}

function formatarPrecoParaPDP(valorCentavos) {
    return CelsoCupom ? CelsoCupom.formatarPrecoIntegerDecimals(valorCentavos) : { integer: '0', decimals: '00' };
}

function obterDadosCupomAtivoDaSessao() {
    return CelsoCupom ? CelsoCupom.obterDadosCupomAtivoDaSessao() : null;
}

function resolverValorDemaisMensalidades(variant, couponCode, couponSessionData) {
    return CelsoCupom ? CelsoCupom.resolverValorDemaisMensalidades(variant, couponCode, couponSessionData) : null;
}

function normalizarPercentualCupomMatricula(valor) {
    if (valor === null || typeof valor === 'undefined') return 0;
    const numero = Number(String(valor).replace(',', '.'));
    return Number.isFinite(numero) ? numero : 0;
}

function obterPercentualDoCodigoCupom(codigo) {
    if (!codigo) return 0;
    const parts = String(codigo).split('-');
    return normalizarPercentualCupomMatricula(parts.length > 1 ? parts[1] : 0);
}

function codigoCupomMatriculaEhCompleto(codigo) {
    return Boolean(codigo && String(codigo).includes('-'));
}

function resolverCupomMatriculaAtual() {
    if (shouldHidePdpCouponBadges()) return null;
    if (!CelsoCupom || !dadosMatricula.variantId) return null;

    const variante = obterVariantePorId(dadosMatricula.variantId);
    if (!variante) return null;

    const cupomJson = typeof CelsoCupom.obterCupomJsonVariante === 'function'
        ? CelsoCupom.obterCupomJsonVariante(variante)
        : null;
    const candidatesFromSettings = typeof CelsoCupom.getCouponCandidates === 'function'
        ? (CelsoCupom.getCouponCandidates() || [])
        : [];
    const candidates = candidatesFromSettings.slice();
    const badgeCode = getPdpBadgeCodeElement(document.querySelector('.celso-discount-badge'))?.textContent?.trim() || '';
    const sessionData = obterDadosCupomAtivoDaSessao();
    const sessionCode = sessionData && sessionData.code ? String(sessionData.code).trim() : '';

    if (badgeCode) candidates.push(badgeCode);
    if (sessionCode) candidates.push(sessionCode);

    let best = null;
    let bestPrimeira = -1;
    let bestDemais = -1;

    candidates.forEach((candidate) => {
        if (!candidate || typeof CelsoCupom.localizarCupomNoJson !== 'function') return;
        if (typeof CelsoCupom.cupomEstaExpirado === 'function' && CelsoCupom.cupomEstaExpirado(candidate)) return;

        const cupomAtivo = CelsoCupom.localizarCupomNoJson(cupomJson, candidate);
        if (!cupomAtivo) return;

        const primeira = Math.max(
            normalizarPercentualCupomMatricula(cupomAtivo.porcentagem),
            obterPercentualDoCodigoCupom(candidate)
        );
        const demais = normalizarPercentualCupomMatricula(cupomAtivo.porcentagem_demais);
        const codigo = typeof CelsoCupom.escolherCodigoShopifyPreferido === 'function'
            ? CelsoCupom.escolherCodigoShopifyPreferido(cupomAtivo, candidate)
            : String(cupomAtivo.cupom || candidate || '');

        if (
            !best
            || primeira > bestPrimeira
            || (primeira === bestPrimeira && demais > bestDemais)
            || (
                primeira === bestPrimeira
                && demais === bestDemais
                && codigo.length > String(best.codigo || '').length
            )
        ) {
            best = {
                codigo: codigo,
                id: cupomAtivo.id ? String(cupomAtivo.id) : '',
                nome: cupomAtivo.cupom ? String(cupomAtivo.cupom) : ''
            };
            bestPrimeira = primeira;
            bestDemais = demais;
        }
    });

    return best;
}

function sincronizarCupomMatriculaAtual() {
    if (shouldHidePdpCouponBadges()) {
        clearPdpCouponDataForHiddenBadges();
        return;
    }

    const cupom = resolverCupomMatriculaAtual();
    if (!cupom) return;

    dadosMatricula.cupomCodigo = cupom.codigo || '';
    dadosMatricula.cupomId = cupom.id || '';
    dadosMatricula.cupomNome = cupom.nome || '';
}

function formatPricePartsToDisplay(parts) {
    if (!parts || typeof parts !== 'object') return '';
    var integer = parts.integer == null ? '' : String(parts.integer);
    var decimals = parts.decimals == null ? '00' : String(parts.decimals);
    return integer + ',' + decimals;
}

function formatBadgeDisplayFromDecimalString(value) {
    var num = Number(value);
    if (!Number.isFinite(num) || num < 0) return '';
    var formatted = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);
    return 'R$' + formatted.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

function shouldUsePosGraduacaoBadgeText(variant) {
    if (window.__CELSO_IS_POS_GRADUACAO !== true) return false;
    if (typeof __celsoIsPosEadAtivo === 'function') {
        return __celsoIsPosEadAtivo(variant);
    }
    return false;
}

function getPosGraduacaoParcelasCount() {
    var parcelas = Number(window.__CELSO_PARCELAS_POS_EAD);
    return Number.isFinite(parcelas) && parcelas > 0 ? parcelas : 12;
}

function getPosGraduacaoBadgeHtml() {
    var parcelas = getPosGraduacaoParcelasCount();
    return '<span class="celso-discount-badge__mid"><strong>APROVEITE:</strong> Parcele em até <strong>' + parcelas + 'x sem juros</strong></span>';
}

function getPosGraduacaoBadgePlainText() {
    var parcelas = getPosGraduacaoParcelasCount();
    return 'APROVEITE: Parcele em até ' + parcelas + 'x sem juros';
}

function getPdpBadgeMidElement(badge) {
    if (!badge || !badge.querySelector) return null;
    return badge.querySelector('.celso-discount-badge__mid');
}

function getExpectedBadgeContentDisplay(badge) {
    if (shouldUsePosGraduacaoBadgeText()) return getPosGraduacaoBadgePlainText();
    if (!badge || !badge.getAttribute) return '';
    return formatBadgeDisplayFromDecimalString(badge.getAttribute('data-celso-discounted-price'));
}

function getPdpBadgeCurrentDisplay(badge) {
    if (!badge) return '';
    if (shouldUsePosGraduacaoBadgeText()) {
        var midEl = getPdpBadgeMidElement(badge);
        return midEl && midEl.textContent ? midEl.textContent.trim() : '';
    }
    var priceEl = getPdpBadgePriceElement(badge);
    return priceEl && priceEl.textContent ? priceEl.textContent.trim() : '';
}

var CELSO_PDP_BADGE_PRICE_SELECTOR = '.celso-discount-badge-price--pdp';
var CELSO_PDP_BADGE_CODE_SELECTOR = '.celso-discount-badge-code--pdp';

function getPdpBadgeElements() {
    var list = [];
    var seen = typeof Set !== 'undefined' ? new Set() : null;
    var selectors = [
        '.celso-discount-badge[data-celso-badge="pdp"]',
        '.product-enroll-popup .celso-discount-badge',
        '.product-details .celso-discount-badge'
    ];
    selectors.forEach(function(sel) {
        var nodes = document.querySelectorAll(sel);
        nodes.forEach(function(el) {
            if (!el) return;
            if (seen) {
                if (seen.has(el)) return;
                seen.add(el);
            }
            list.push(el);
        });
    });
    return list;
}

function getPdpBadgePriceElement(badge) {
    if (!badge || !badge.querySelector) return null;
    return badge.querySelector(CELSO_PDP_BADGE_PRICE_SELECTOR) || badge.querySelector('.celso-discount-badge-price');
}

function getPdpBadgeCodeElement(badge) {
    if (!badge || !badge.querySelector) return null;
    return badge.querySelector(CELSO_PDP_BADGE_CODE_SELECTOR) || badge.querySelector('.celso-discount-badge-code');
}

function isPdpBadgePriceNode(node) {
    if (!node) return false;
    if (node.classList && (node.classList.contains('celso-discount-badge-price') || node.classList.contains('celso-discount-badge-price--pdp'))) {
        return true;
    }
    if (node.querySelector && (node.querySelector(CELSO_PDP_BADGE_PRICE_SELECTOR) || node.querySelector('.celso-discount-badge-price'))) {
        return true;
    }
    return false;
}

function ensurePdpBadgeMarkup(badge) {
    if (!badge) return { priceEl: null, codeEl: null, midEl: null };
    if (shouldUsePosGraduacaoBadgeText()) {
        var posMidEl = getPdpBadgeMidElement(badge);
        if (!posMidEl || getPdpBadgePriceElement(badge) || getPdpBadgeCodeElement(badge)) {
            badge.innerHTML = getPosGraduacaoBadgeHtml();
            posMidEl = getPdpBadgeMidElement(badge);
        }
        return { priceEl: null, codeEl: null, midEl: posMidEl };
    }
    var priceEl = getPdpBadgePriceElement(badge);
    var codeEl = getPdpBadgeCodeElement(badge);
    var midEl = badge.querySelector ? badge.querySelector('.celso-discount-badge__mid') : null;
    if (!priceEl || !codeEl || !midEl) {
        badge.innerHTML = '<span class="celso-discount-badge-price--pdp"></span><span class="celso-discount-badge__mid"> no 1º mês com o cupom </span><span class="celso-discount-badge-code--pdp"></span>';
        priceEl = getPdpBadgePriceElement(badge);
        codeEl = getPdpBadgeCodeElement(badge);
    }
    return { priceEl: priceEl, codeEl: codeEl, midEl: midEl };
}

function isPdpCupomContext() {
    var pageType = enrollPopupLiquidConfig.pageType || '';
    if (pageType === 'product') return true;
    try {
        var pathname = window.location && window.location.pathname ? String(window.location.pathname) : '';
        if (pathname.indexOf('/products/') !== -1) return true;
    } catch (e) {}
    return false;
}

function shouldHidePdpCouponBadges() {
    if (!isPdpCupomContext()) return false;
    if (typeof window !== 'undefined' && window.__CELSO_HIDE_PDP_COUPON_BADGES === true) return true;
    if (typeof document === 'undefined' || !document.querySelector) return false;
    return Boolean(document.querySelector(
        '[data-product-information-section][data-hide-coupon-badges="true"], [data-celso-pdp-hide-coupon-badges="true"]'
    ));
}

function clearPdpCouponDataForHiddenBadges() {
    try {
        if (typeof dadosMatricula !== 'undefined' && dadosMatricula) {
            dadosMatricula.cupomCodigo = '';
            dadosMatricula.cupomId = '';
            dadosMatricula.cupomNome = '';
        }
    } catch (e) {}
}

function hidePdpCouponBadges(reason) {
    clearPdpCouponDataForHiddenBadges();
    getPdpBadgeElements().forEach(function(badge) {
        if (!badge) return;
        if (badge.__celsoBadgePriceObserver) {
            try { badge.__celsoBadgePriceObserver.disconnect(); } catch (e) {}
            badge.__celsoBadgePriceObserver = null;
        }
        badge.setAttribute('data-celso-badge-ready', 'false');
        badge.removeAttribute('data-celso-variant');
        badge.removeAttribute('data-celso-original-price');
        badge.removeAttribute('data-celso-discounted-price');
        badge.style.display = 'none';
        badge.style.visibility = 'hidden';
        badge.setAttribute('aria-hidden', 'true');
        badge.setAttribute('hidden', '');
    });
    if (typeof window !== 'undefined') {
        window.__celsoPdpBadgeRefreshPendingUntil = 0;
    }
    setPdpPriceTransitioning(false);
}

function isPdpBadgeRefreshPending() {
    if (typeof window === 'undefined') return false;
    return Date.now() < Number(window.__celsoPdpBadgeRefreshPendingUntil || 0);
}

function setExpectedPdpPriceState(state) {
    if (typeof window === 'undefined') return;
    window.__celsoExpectedPdpPriceState = state || null;
}

function setPdpPriceTransitioning(active) {
    if (typeof document === 'undefined') return;
    var shouldActivate = active === true;
    document.querySelectorAll('product-price [ref="priceContainer"], .product-details .price-fee, .price-stack--pdp').forEach(function(node) {
        if (!node || !node.classList) return;
        node.classList.toggle('is-pdp-price-transitioning', shouldActivate);
    });
}

function esconderTarjaRosaPreco(reason, options) {
    var opts = options || {};
    opts.reason = reason || opts.reason || 'hide';
    setPdpBadgeVisibility(false, opts);
}
function mostrarTarjaRosaPreco(reason, options) {
    var opts = options || {};
    opts.reason = reason || opts.reason || 'show';
    setPdpBadgeVisibility(true, opts);
}
if (typeof window !== 'undefined') {
    window.esconderTarjaRosaPreco = esconderTarjaRosaPreco;
    window.mostrarTarjaRosaPreco = mostrarTarjaRosaPreco;
}

function setPdpBadgeVisibility(visible, options) {
    var opts = options || {};
    var reason = opts.reason || (visible ? 'show' : 'hide');
    var force = opts.force === true;
    if (visible && shouldHidePdpCouponBadges()) {
        hidePdpCouponBadges(reason);
        return;
    }
    var badges = getPdpBadgeElements();
    if (!visible && !force && isPdpBadgeRefreshPending()) {
        return;
    }
    badges.forEach(function(badge) {
        if (!badge) return;
        if (visible) {
            if (badge.getAttribute('data-celso-badge-ready') !== 'true') return;
            var expectedDisplay = getExpectedBadgeContentDisplay(badge);
            var currentDisplay = getPdpBadgeCurrentDisplay(badge);
            if (expectedDisplay && currentDisplay && currentDisplay !== expectedDisplay) {
                badge.setAttribute('data-celso-badge-ready', 'false');
                badge.style.display = 'none';
                badge.style.visibility = 'hidden';
                badge.setAttribute('aria-hidden', 'true');
                if (typeof window !== 'undefined' && typeof window.__celsoSchedulePdpBadgeRefresh === 'function' && !isPdpBadgeRefreshPending()) {
                    window.__celsoSchedulePdpBadgeRefresh([0], { mostrarAoCorrigir: true });
                }
                return;
            }
        }
        badge.style.display = visible ? '' : 'none';
        badge.style.visibility = visible ? '' : 'hidden';
        badge.setAttribute('aria-hidden', visible ? 'false' : 'true');
    });
}

function resetPdpBadgePriceContent(reason) {
    var badges = getPdpBadgeElements();
    badges.forEach(function(badge) {
        if (!badge || !badge.querySelector) return;
        var priceEl = getPdpBadgePriceElement(badge);
        if (priceEl) priceEl.textContent = '';
        badge.setAttribute('data-celso-badge-ready', 'false');
        badge.removeAttribute('data-celso-variant');
        badge.removeAttribute('data-celso-original-price');
        badge.removeAttribute('data-celso-discounted-price');
    });
}

function finalizePdpBadgeDisplayAfterSettle(reason) {
    if (typeof window === 'undefined') return;
    if (shouldHidePdpCouponBadges()) {
        hidePdpCouponBadges(reason || 'badge-finalize');
        return;
    }
    if (window.__celsoPdpBadgeFinalizeTimer) {
        clearTimeout(window.__celsoPdpBadgeFinalizeTimer);
    }
    window.__celsoPdpBadgeFinalizeTimer = setTimeout(function() {
        window.__celsoPdpBadgeFinalizeTimer = null;
        var badges = getPdpBadgeElements();
        var allReadyAndMatching = badges.length > 0;
        for (var i = 0; i < badges.length; i++) {
            var badge = badges[i];
            if (!badge) continue;
            if (badge.getAttribute('data-celso-badge-ready') !== 'true') {
                allReadyAndMatching = false;
                break;
            }
            var expectedDisplay = getExpectedBadgeContentDisplay(badge);
            var currentDisplay = getPdpBadgeCurrentDisplay(badge);
            if (expectedDisplay && currentDisplay !== expectedDisplay) {
                allReadyAndMatching = false;
                break;
            }
        }
        if (!allReadyAndMatching) return;
        mostrarTarjaRosaPreco(reason || 'badge-finalize');
        window.__celsoPdpBadgeRefreshPendingUntil = 0;
        setPdpPriceTransitioning(false);
    }, 220);
}

function lockPdpBadgePrice(badge, expectedDisplay, expectedCode) {
    if (!badge || !badge.querySelector || !expectedDisplay || typeof MutationObserver === 'undefined') return;
    var ensured = ensurePdpBadgeMarkup(badge);
    if (shouldUsePosGraduacaoBadgeText()) {
        var expectedHtml = getPosGraduacaoBadgeHtml();
        if (badge.__celsoBadgePriceObserver) {
            try { badge.__celsoBadgePriceObserver.disconnect(); } catch (e) {}
        }
        var posObserver = new MutationObserver(function() {
            if (badge.__celsoLockingPrice) return;
            var parts = ensurePdpBadgeMarkup(badge);
            var currentMidEl = parts.midEl;
            var currentDisplay = currentMidEl && currentMidEl.textContent ? currentMidEl.textContent.trim() : '';
            if (currentDisplay === expectedDisplay) return;
            badge.__celsoLockingPrice = true;
            if (currentMidEl) currentMidEl.innerHTML = expectedHtml;
            badge.__celsoLockingPrice = false;
        });
        posObserver.observe(badge, { childList: true, characterData: true, subtree: true });
        badge.__celsoBadgePriceObserver = posObserver;
        return;
    }
    var priceEl = ensured.priceEl;
    if (!priceEl) return;
    if (badge.__celsoBadgePriceObserver) {
        try { badge.__celsoBadgePriceObserver.disconnect(); } catch (e) {}
    }
    var observer = new MutationObserver(function() {
        if (badge.__celsoLockingPrice) return;
        var parts = ensurePdpBadgeMarkup(badge);
        var currentPriceEl = parts.priceEl;
        var currentCodeEl = parts.codeEl;
        var currentDisplay = currentPriceEl && currentPriceEl.textContent ? currentPriceEl.textContent.trim() : '';
        var currentCode = currentCodeEl && currentCodeEl.textContent ? currentCodeEl.textContent.trim() : '';
        if (currentDisplay === expectedDisplay && (!expectedCode || currentCode === expectedCode)) return;
        badge.__celsoLockingPrice = true;
        if (currentPriceEl) currentPriceEl.textContent = expectedDisplay;
        if (currentCodeEl && expectedCode) currentCodeEl.textContent = expectedCode;
        badge.__celsoLockingPrice = false;
    });
    observer.observe(badge, { childList: true, characterData: true, subtree: true });
    badge.__celsoBadgePriceObserver = observer;
}

/** Resolve cupom da variante na PDP (URL/settings, badge, sessão ou cupom_json do curso). */
function resolverCupomParaVariantePDP(variant, extraCandidates) {
    if (!variant || !CelsoCupom || typeof CelsoCupom.resolveEffectiveCouponForVariant !== 'function') {
        return null;
    }
    return CelsoCupom.resolveEffectiveCouponForVariant(variant, {
        extraCandidates: Array.isArray(extraCandidates) ? extraCandidates : [],
        allowImplicit: true
    });
}

/** PDP: controla visibilidade da tarja conforme cupom válido na variante ativa. */
function aplicarVisibilidadeTarjaConformeCupomNaUrlPDP() {
    if (!isPdpCupomContext()) return;
    if (shouldHidePdpCouponBadges()) {
        hidePdpCouponBadges('aplicarVisibilidade:hide-coupon-badges');
        return;
    }
    if (!CelsoCupom) {
        esconderTarjaRosaPreco('aplicarVisibilidade:sem-celso-cupom', { force: true });
        return;
    }

    var variantesParaCupom = (typeof window !== 'undefined' && Array.isArray(window.PDP_CUPOM_VARIANTES) && window.PDP_CUPOM_VARIANTES.length > 0)
        ? window.PDP_CUPOM_VARIANTES
        : (typeof todasVariantes !== 'undefined' && Array.isArray(todasVariantes) ? todasVariantes : []);
    if (!variantesParaCupom.length) {
        esconderTarjaRosaPreco('aplicarVisibilidade:sem-variantes', { force: true });
        return;
    }

    var variant = typeof obterVarianteAtivaPDP === 'function' ? obterVarianteAtivaPDP(variantesParaCupom) : null;
    if (!variant) {
        esconderTarjaRosaPreco('aplicarVisibilidade:sem-variante-ativa', { force: true });
        return;
    }

    var candidates = (typeof CelsoCupom.getCouponCandidates === 'function') ? (CelsoCupom.getCouponCandidates() || []) : [];
    var urlCupom = (typeof CelsoCupom.getCupomFromUrl === 'function') ? (CelsoCupom.getCupomFromUrl() || '') : '';
    var badgeCode = '';
    try {
        var firstBadge = getPdpBadgeElements()[0] || null;
        var codeEl = getPdpBadgeCodeElement(firstBadge);
        badgeCode = codeEl && codeEl.textContent ? codeEl.textContent.trim() : '';
    } catch (e) {}
    var extraCandidates = [];
    if (badgeCode) extraCandidates.push(badgeCode);
    var sessionCode = '';
    try {
        var sessionData = typeof CelsoCupom.obterDadosCupomAtivoDaSessao === 'function'
            ? CelsoCupom.obterDadosCupomAtivoDaSessao()
            : null;
        sessionCode = sessionData && sessionData.code ? String(sessionData.code).trim() : '';
    } catch (e) {}
    if (sessionCode) extraCandidates.push(sessionCode);
    var resolved = resolverCupomParaVariantePDP(variant, extraCandidates);
    var cupomAtivo = resolved && resolved.entry ? resolved.entry : null;

    var visCodeRaw = (resolved && resolved.code) || (cupomAtivo && cupomAtivo.cupom) || '';
    var visCodeDisplay = visCodeRaw;
    if (typeof CelsoCupom.getCupomBase === 'function' && visCodeRaw) {
        visCodeDisplay = CelsoCupom.getCupomBase(visCodeRaw);
    }
    if (!cupomAtivo) {
        esconderTarjaRosaPreco('aplicarVisibilidade:sem-cupom-ativo', { force: true });
        return;
    }

    var badges = getPdpBadgeElements();
    badges.forEach(function(b) {
        if (!b) return;
        b.style.display = '';
        b.style.visibility = '';
        b.setAttribute('aria-hidden', 'false');
        if (!shouldUsePosGraduacaoBadgeText()) {
            var codeSpan = getPdpBadgeCodeElement(b);
            if (codeSpan && visCodeDisplay) {
                codeSpan.textContent = visCodeDisplay;
            }
        }
    });
}

function garantirBadgeCupomNaPDP() {
    if (shouldHidePdpCouponBadges()) {
        hidePdpCouponBadges('garantirBadge:hide-coupon-badges');
        return [];
    }

    var existentes = getPdpBadgeElements();
    if (existentes && existentes.length > 0) return Array.from(existentes);

    var target =
        document.querySelector('product-price [ref="priceContainer"]')
        || document.querySelector('.price-fee[ref="priceContainer"]')
        || document.querySelector('product-price .price-fee')
        || document.querySelector('.product-details product-price')
        || document.querySelector('.product-details');

    if (!target) {
        return [];
    }

    var badge = document.createElement('div');
    badge.className = 'celso-discount-badge celso-discount-badge--pdp';
    badge.setAttribute('data-celso-badge', 'pdp');
    badge.setAttribute('aria-hidden', 'true');
    badge.style.display = 'none';
    badge.style.visibility = 'hidden';
    badge.innerHTML = shouldUsePosGraduacaoBadgeText()
        ? getPosGraduacaoBadgeHtml()
        : '<span class="celso-discount-badge-price--pdp"></span><span class="celso-discount-badge__mid"> no 1º mês com o cupom </span><span class="celso-discount-badge-code--pdp"></span>';

    if (target.firstChild) {
        target.insertBefore(badge, target.firstChild);
    } else {
        target.appendChild(badge);
    }

    return [badge];
}

function obterVarianteAtivaPDP(variantesParaCupom) {
    if (!variantesParaCupom || !variantesParaCupom.length) return null;
    function findVariantById(rawId, source) {
        if (!rawId) return null;
        var variant = variantesParaCupom.find(function (x) { return String(x.id) === String(rawId); });
        return variant;
    }
    function findVariantByModalidade(modalidade, source) {
        if (!modalidade) return null;
        var variant = variantesParaCupom.find(function (x) {
            return String(getVariantOptionValue(x, ENROLL_OPTION_LABELS.modalidade) || '') === String(modalidade);
        });
        return variant;
    }
    function getActiveModalidadeValue() {
        var activeBtn = document.querySelector('.enroll-variant .btn-variant-option.active');
        if (activeBtn && activeBtn.dataset && activeBtn.dataset.optionValue) {
            return String(activeBtn.dataset.optionValue).trim();
        }
        try {
            var stored = localStorage.getItem('modalidadeSelecionada');
            return stored ? String(stored).trim() : '';
        } catch (e) {
            return '';
        }
    }
    var activeModalidadeValue = getActiveModalidadeValue();
    var fromModalidade = findVariantByModalidade(activeModalidadeValue, 'activeModalidade');
    if (fromModalidade) return fromModalidade;

    var c = document.querySelector('product-price [ref="priceContainer"]');
    var vid = c && c.getAttribute && c.getAttribute('data-variant-id');
    var fromPriceContainer = findVariantById(vid, 'priceContainer');
    if (fromPriceContainer) return fromPriceContainer;

    var selectedInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var fromFormInput = findVariantById(selectedInput && selectedInput.value, 'productFormInput');
    if (fromFormInput) return fromFormInput;

    var activeBtn = document.querySelector('.enroll-variant .btn-variant-option.active');
    var fromActiveButton = findVariantById(activeBtn && activeBtn.dataset ? activeBtn.dataset.variantId : '', 'activeButton');
    if (fromActiveButton) return fromActiveButton;

    var urlVariantId = typeof window !== 'undefined' && window.location && window.location.search
        ? new URLSearchParams(window.location.search).get('variant') : null;
    var fromUrl = findVariantById(urlVariantId, 'url');
    if (fromUrl) return fromUrl;
    return variantesParaCupom[0];
}
if (typeof window !== 'undefined') {
    window.aplicarVisibilidadeTarjaConformeCupomNaUrlPDP = aplicarVisibilidadeTarjaConformeCupomNaUrlPDP;
    window.obterVarianteAtivaPDP = obterVarianteAtivaPDP;
}

// Corrige a tarja rosa na PDP: usa a variante ativa (ex. EAD) e cupom.porcentagem para calcular
// o valor correto da 1ª mensalidade. Assim o valor exibido fica menor que o preço das demais (ex. 162,40).
function corrigirTarjaRosaPrimeiraMensalidade(opcoes) {
    if (!isPdpCupomContext()) return;
    if (shouldHidePdpCouponBadges()) {
        hidePdpCouponBadges('corrigirTarja:hide-coupon-badges');
        var hiddenVariants = (typeof window !== 'undefined' && Array.isArray(window.PDP_CUPOM_VARIANTES) && window.PDP_CUPOM_VARIANTES.length > 0)
            ? window.PDP_CUPOM_VARIANTES
            : (typeof todasVariantes !== 'undefined' && Array.isArray(todasVariantes) ? todasVariantes : []);
        var hiddenVariant = typeof obterVarianteAtivaPDP === 'function' ? obterVarianteAtivaPDP(hiddenVariants) : null;
        if (hiddenVariant && typeof restaurarPrecoCheioPDP === 'function') restaurarPrecoCheioPDP(hiddenVariant);
        return;
    }
    if (!CelsoCupom) return;
    var mostrarAoCorrigir = opcoes && opcoes.mostrarAoCorrigir === true;
    var skipBadgeWrite = opcoes && opcoes.skipBadgeWrite === true;
    var badgeEl = opcoes && opcoes.badgeEl;
    var badges = badgeEl ? [badgeEl] : getPdpBadgeElements();
    if (!badges.length) {
        badges = garantirBadgeCupomNaPDP();
    }
    if (!badges.length) {
        return;
    }

    var candidates = (typeof CelsoCupom.getCouponCandidates === 'function') ? (CelsoCupom.getCouponCandidates() || []) : [];
    var urlCupom = (typeof CelsoCupom.getCupomFromUrl === 'function') ? (CelsoCupom.getCupomFromUrl() || '') : '';
    var badgeCode = '';
    try {
        var codeEl = getPdpBadgeCodeElement(badges[0]);
        badgeCode = codeEl && codeEl.textContent ? codeEl.textContent.trim() : '';
    } catch (e) {}
    var resolveCandidates = Array.isArray(candidates) ? candidates.slice() : [];
    if (badgeCode && resolveCandidates.indexOf(badgeCode) === -1) {
        resolveCandidates.push(badgeCode);
    }

    var variantesParaCupom = (typeof window !== 'undefined' && Array.isArray(window.PDP_CUPOM_VARIANTES) && window.PDP_CUPOM_VARIANTES.length > 0)
        ? window.PDP_CUPOM_VARIANTES
        : (typeof todasVariantes !== 'undefined' && Array.isArray(todasVariantes) ? todasVariantes : []);
    if (!variantesParaCupom.length) return;

    let variant = typeof obterVarianteAtivaPDP === 'function' ? obterVarianteAtivaPDP(variantesParaCupom) : null;
    if (!variant) {
        var dataVariant = document.querySelector('.celso-discount-badge[data-celso-variant]');
        if (dataVariant && dataVariant.getAttribute('data-celso-variant')) {
            var vidAttr = dataVariant.getAttribute('data-celso-variant');
            variant = variantesParaCupom.find(function (v) { return String(v.id) === String(vidAttr); });
        }
    }
    if (!variant) variant = variantesParaCupom[0];
    if (!variant) return;

    var resolved = resolverCupomParaVariantePDP(variant, resolveCandidates);
    var cupomAtivo = resolved && resolved.entry ? resolved.entry : null;
    // Sem cupom válido para a variante ativa: esconder tarja para evitar falso positivo na PDP.
    if (!cupomAtivo) {
        if (typeof esconderTarjaRosaPreco === 'function') esconderTarjaRosaPreco('corrigirTarja:sem-cupom-ativo');
        return;
    }
    var cupomCodeRaw = (resolved && resolved.code) || (cupomAtivo && cupomAtivo.cupom) || '';
    var cupomCodeDisplay = cupomCodeRaw;
    if (typeof CelsoCupom.getCupomBase === 'function' && cupomCodeRaw) {
        cupomCodeDisplay = CelsoCupom.getCupomBase(cupomCodeRaw);
    }

    function parseMoneyPtBrToCents(text) {
        if (!text) return 0;
        var raw = String(text).replace(/\s/g, '').replace(/R\$/i, '').replace(/\./g, '').replace(',', '.').replace(/[^\d.]/g, '');
        var n = parseFloat(raw);
        if (!Number.isFinite(n) || n <= 0) return 0;
        return Math.round(n * 100);
    }

    // 1) Calcular valor correto da 1ª mensalidade pela variante ativa (EAD/Presencial) e cupom.porcentagem
    // usando a MESMA função central da shelf/carrinho.
    var valorCorretoPrimeira = null;
    var precoBaseCentavos = CelsoCupom.obterPrecoBaseDaVariante(variant);
    if (typeof CelsoCupom.resolverValorPrimeiraMensalidade === 'function') {
        var primeiraMensalidade = CelsoCupom.resolverValorPrimeiraMensalidade(variant, cupomAtivo);
        if (primeiraMensalidade && Number.isFinite(primeiraMensalidade.valorCentavos) && primeiraMensalidade.valorCentavos >= 0) {
            valorCorretoPrimeira = primeiraMensalidade.valorCentavos / 100;
            precoBaseCentavos = CelsoCupom.obterPrecoBaseDaVariante(variant);
        }
    }
    if (shouldUsePosGraduacaoBadgeText()) {
        var posDisplay = getPosGraduacaoBadgePlainText();
        if (skipBadgeWrite) {
            return;
        }
        var posBadgeSignature = [
            String(variant && variant.id ? variant.id : ''),
            String(posDisplay || '')
        ].join('|');
        var posBadgesAlreadySynced = true;
        for (var posSb = 0; posSb < badges.length; posSb++) {
            var posSyncBadge = badges[posSb];
            if (!posSyncBadge) continue;
            var posSyncVariantId = posSyncBadge.getAttribute && posSyncBadge.getAttribute('data-celso-variant');
            var posCurrentSignature = [
                String(posSyncVariantId || ''),
                String(getPdpBadgeCurrentDisplay(posSyncBadge) || '')
            ].join('|');
            if (posCurrentSignature !== posBadgeSignature) {
                posBadgesAlreadySynced = false;
                break;
            }
        }
        if (!posBadgesAlreadySynced) {
            for (var posB = 0; posB < badges.length; posB++) {
                var posParts = ensurePdpBadgeMarkup(badges[posB]);
                if (!posParts.midEl) continue;
                if (typeof window !== 'undefined') {
                    window.__celsoInternalBadgeWriteUntil = Date.now() + 400;
                }
                posParts.midEl.innerHTML = getPosGraduacaoBadgeHtml();
                badges[posB].setAttribute('data-celso-badge-ready', 'true');
                badges[posB].setAttribute('data-celso-variant', String(variant.id || ''));
                badges[posB].setAttribute('data-celso-badge-mode', 'pos-graduacao');
                lockPdpBadgePrice(badges[posB], posDisplay, '');
                if (mostrarAoCorrigir) finalizePdpBadgeDisplayAfterSettle('corrigirTarja:mostrar');
            }
        }
        return;
    }

    // Cupom de 100% na 1ª mensalidade é válido e deve exibir "R$0,00" na tarja.
    if (valorCorretoPrimeira != null && Number.isFinite(valorCorretoPrimeira) && valorCorretoPrimeira >= 0) {
        var formatted = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valorCorretoPrimeira);
        var display = 'R$' + formatted.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        if (skipBadgeWrite) {
            return;
        }
        var badgeSignature = [
            String(variant && variant.id ? variant.id : ''),
            String(cupomCodeDisplay || ''),
            String(display || '')
        ].join('|');
        var allBadgesAlreadySynced = true;
        for (var sb = 0; sb < badges.length; sb++) {
            var syncBadge = badges[sb];
            if (!syncBadge) continue;
            var syncPrice = getPdpBadgePriceElement(syncBadge);
            var syncCode = getPdpBadgeCodeElement(syncBadge);
            var syncVariantId = syncBadge.getAttribute && syncBadge.getAttribute('data-celso-variant');
            var currentSignature = [
                String(syncVariantId || ''),
                String(syncCode && syncCode.textContent ? syncCode.textContent.trim() : ''),
                String(syncPrice && syncPrice.textContent ? syncPrice.textContent.trim() : '')
            ].join('|');
            if (currentSignature !== badgeSignature) {
                allBadgesAlreadySynced = false;
                break;
            }
        }
        if (allBadgesAlreadySynced) {
            return;
        }
        for (var b = 0; b < badges.length; b++) {
            var priceSpan = getPdpBadgePriceElement(badges[b]);
            var codeSpan = getPdpBadgeCodeElement(badges[b]);
            if (priceSpan) {
                if (typeof window !== 'undefined') {
                    window.__celsoInternalBadgeWriteUntil = Date.now() + 400;
                }
                priceSpan.textContent = display;
                if (codeSpan) codeSpan.textContent = cupomCodeDisplay || '';
                badges[b].setAttribute('data-celso-badge-ready', 'true');
                badges[b].setAttribute('data-celso-variant', String(variant.id || ''));
                badges[b].setAttribute('data-celso-original-price', String((precoBaseCentavos / 100).toFixed(2)));
                badges[b].setAttribute('data-celso-discounted-price', String(valorCorretoPrimeira.toFixed(2)));
                lockPdpBadgePrice(badges[b], display, cupomCodeDisplay || '');
                if (mostrarAoCorrigir) finalizePdpBadgeDisplayAfterSettle('corrigirTarja:mostrar');
            }
        }
        return;
    }
}

/** Restaura o preço principal da PDP para o valor cheio da variante (quando cupom não aplica na modalidade). */
function restaurarPrecoCheioPDP(variant) {
    if (!variant || !Number.isFinite(variant.price)) return;
    var precoCentavosOriginal = Number(variant.price);
    var compareCentavosOriginal = (variant.compare_at_price != null && variant.compare_at_price !== '') ? parseInt(variant.compare_at_price, 10) : 0;
    var hasCompare = Number.isFinite(compareCentavosOriginal) && compareCentavosOriginal > precoCentavosOriginal;

    var posEad = (typeof __celsoIsPosEadAtivo === 'function') && __celsoIsPosEadAtivo(variant) && window.__CELSO_PARCELAS_POS_EAD > 0;
    var parcelas = window.__CELSO_PARCELAS_POS_EAD;
    var precoCentavos = posEad ? Math.round(precoCentavosOriginal / parcelas) : precoCentavosOriginal;
    var compareCentavos = compareCentavosOriginal;

    var priceFormatted = formatarPrecoParaPDP(precoCentavos);
    var compareFormatted = hasCompare ? formatarPrecoParaPDP(compareCentavos) : null;
    setExpectedPdpPriceState({
        mode: 'full',
        amountText: formatPricePartsToDisplay(priceFormatted),
        compareText: hasCompare && compareFormatted ? formatPricePartsToDisplay(compareFormatted) : ''
    });

    document.querySelectorAll('product-price [ref="priceContainer"]').forEach(function (container) {
        if (container.querySelector && container.querySelector('.celso-discount-badge')) return;
        if (container.closest && container.closest('.celso-discount-badge')) return;
        if (typeof __celsoEnsureInstallmentsSpanPDP === 'function') {
            __celsoEnsureInstallmentsSpanPDP(container, parcelas, posEad);
        }
    });

    var allPdpAmounts = document.querySelectorAll('product-price .price-amount.price-amount--pdp');
    if (!allPdpAmounts.length) allPdpAmounts = document.querySelectorAll('.price-stack--pdp .price-amount--pdp');
    allPdpAmounts.forEach(function (el) {
        if (el.closest && el.closest('.celso-discount-badge')) return;
        var decimalSpan = el.querySelector('.decimal');
        if (decimalSpan) {
            el.innerHTML = priceFormatted.integer + ',<span class="decimal">' + priceFormatted.decimals + '</span>';
        } else {
            el.textContent = priceFormatted.integer + ',' + priceFormatted.decimals;
        }
        el.removeAttribute('data-celso-pdp-discount-applied');
    });

    var allComparePdp = document.querySelectorAll('product-price .compare-at-price--pdp');
    if (!allComparePdp.length) allComparePdp = document.querySelectorAll('.price-stack--pdp .compare-at-price--pdp');
    allComparePdp.forEach(function (compareEl) {
        if (compareEl.closest && compareEl.closest('.celso-discount-badge')) return;
        var compareValue = compareEl.querySelector('.compare-at-price-value');
        if (hasCompare && compareFormatted && compareValue) {
            compareValue.textContent = compareFormatted.integer + ',' + compareFormatted.decimals;
            compareEl.style.display = '';
            compareEl.removeAttribute('hidden');
        } else {
            compareEl.style.display = 'none';
            compareEl.setAttribute('hidden', '');
        }
    });
    if (!isPdpBadgeRefreshPending()) {
        setPdpPriceTransitioning(false);
    }
}

function aplicarDescontoCupomUrlNaPDP() {
    if (!isPdpCupomContext()) return;
    if (shouldHidePdpCouponBadges()) {
        hidePdpCouponBadges('aplicarDescontoPDP:hide-coupon-badges');
        var hiddenVariants = (typeof window !== 'undefined' && Array.isArray(window.PDP_CUPOM_VARIANTES) && window.PDP_CUPOM_VARIANTES.length > 0)
            ? window.PDP_CUPOM_VARIANTES
            : (typeof todasVariantes !== 'undefined' && Array.isArray(todasVariantes) ? todasVariantes : []);
        var hiddenVariant = typeof obterVarianteAtivaPDP === 'function' ? obterVarianteAtivaPDP(hiddenVariants) : null;
        if (hiddenVariant && typeof restaurarPrecoCheioPDP === 'function') restaurarPrecoCheioPDP(hiddenVariant);
        return;
    }
    if (!CelsoCupom) return;
    var variantesParaCupom = (typeof window !== 'undefined' && Array.isArray(window.PDP_CUPOM_VARIANTES) && window.PDP_CUPOM_VARIANTES.length > 0)
        ? window.PDP_CUPOM_VARIANTES
        : (todasVariantes || []);
    if (!variantesParaCupom.length) return;

    var candidates = (typeof CelsoCupom.getCouponCandidates === 'function') ? (CelsoCupom.getCouponCandidates() || []) : [];
    var urlCupom = (typeof CelsoCupom.getCupomFromUrl === 'function') ? (CelsoCupom.getCupomFromUrl() || '') : '';
    var badgeCode = '';
    try {
        var badge = document.querySelector('.celso-discount-badge');
        var codeEl = getPdpBadgeCodeElement(badge);
        badgeCode = codeEl && codeEl.textContent ? codeEl.textContent.trim() : '';
    } catch (e) {}

    var variant = typeof obterVarianteAtivaPDP === 'function' ? obterVarianteAtivaPDP(variantesParaCupom) : null;
    if (!variant) {
        return;
    }

    var extraCandidates = [];
    if (badgeCode) extraCandidates.push(badgeCode);
    try {
        var sessionData = typeof CelsoCupom.obterDadosCupomAtivoDaSessao === 'function'
            ? CelsoCupom.obterDadosCupomAtivoDaSessao()
            : null;
        var sessionCode = sessionData && sessionData.code ? String(sessionData.code).trim() : '';
        if (sessionCode) extraCandidates.push(sessionCode);
    } catch (e) {}

    var resolved = resolverCupomParaVariantePDP(variant, extraCandidates);
    var cupomAtivo = resolved && resolved.entry ? resolved.entry : null;
    // Cupom só aplica no preço da PDP se a modalidade selecionada tiver esse cupom (ex.: EAD only não em Presencial).
    if (!cupomAtivo) {
        if (typeof esconderTarjaRosaPreco === 'function') esconderTarjaRosaPreco('aplicarDescontoPDP:cupom-invalido-para-variante');
        restaurarPrecoCheioPDP(variant);
        return;
    }

    const percentualNormalizado = typeof CelsoCupom.resolverRatioPrecoExibicaoCupom === 'function'
        ? CelsoCupom.resolverRatioPrecoExibicaoCupom(cupomAtivo)
        : CelsoCupom.normalizarPorcentagemDemais(cupomAtivo.porcentagem_demais);
    if (!percentualNormalizado || percentualNormalizado.ratio >= 1) {
        restaurarPrecoCheioPDP(variant);
        return;
    }

    const precoBaseCentavosOriginal = CelsoCupom.obterPrecoBaseDaVariante(variant);
    if (!Number.isFinite(precoBaseCentavosOriginal) || precoBaseCentavosOriginal <= 0) return;

    const valorComDescontoCentavosOriginal = Math.round(precoBaseCentavosOriginal * percentualNormalizado.ratio);
    if (!Number.isFinite(valorComDescontoCentavosOriginal) || valorComDescontoCentavosOriginal < 0) return;

    const compareAtCentavosOriginal = (variant.compare_at_price != null && variant.compare_at_price !== '')
        ? parseInt(variant.compare_at_price, 10) : 0;
    const strikethroughCentavosOriginal = (Number.isFinite(compareAtCentavosOriginal) && compareAtCentavosOriginal > precoBaseCentavosOriginal)
        ? compareAtCentavosOriginal
        : precoBaseCentavosOriginal;
    const hasCompareDisplay = strikethroughCentavosOriginal > valorComDescontoCentavosOriginal;

    var posEad = (typeof __celsoIsPosEadAtivo === 'function') && __celsoIsPosEadAtivo(variant) && window.__CELSO_PARCELAS_POS_EAD > 0;
    var parcelas = window.__CELSO_PARCELAS_POS_EAD;
    const strikethroughCentavos = strikethroughCentavosOriginal;
    const valorComDescontoCentavos = posEad ? Math.round(valorComDescontoCentavosOriginal / parcelas) : valorComDescontoCentavosOriginal;

    const discountedFormatted = formatarPrecoParaPDP(valorComDescontoCentavos);
    const compareFormatted = hasCompareDisplay ? formatarPrecoParaPDP(strikethroughCentavos) : null;
    setExpectedPdpPriceState({
        mode: 'discounted',
        amountText: formatPricePartsToDisplay(discountedFormatted),
        compareText: hasCompareDisplay && compareFormatted ? formatPricePartsToDisplay(compareFormatted) : ''
    });

    document.querySelectorAll('product-price [ref="priceContainer"]').forEach(function (container) {
        if (container.querySelector && container.querySelector('.celso-discount-badge')) return;
        if (container.closest && container.closest('.celso-discount-badge')) return;
        if (typeof __celsoEnsureInstallmentsSpanPDP === 'function') {
            __celsoEnsureInstallmentsSpanPDP(container, parcelas, posEad);
        }
    });

    var allPdpAmounts = document.querySelectorAll('product-price .price-amount.price-amount--pdp');
    if (!allPdpAmounts.length) {
        allPdpAmounts = document.querySelectorAll('.price-stack--pdp .price-amount--pdp');
    }
    allPdpAmounts.forEach(function (priceAmountPDP) {
        if (priceAmountPDP.closest && priceAmountPDP.closest('.celso-discount-badge')) return;
        if (isPdpBadgePriceNode(priceAmountPDP)) return;

        const decimalSpan = priceAmountPDP.querySelector('.decimal');
        if (decimalSpan) {
            priceAmountPDP.innerHTML = discountedFormatted.integer + ',<span class="decimal">' + discountedFormatted.decimals + '</span>';
        } else {
            priceAmountPDP.textContent = discountedFormatted.integer + ',' + discountedFormatted.decimals;
        }
        priceAmountPDP.setAttribute('data-celso-pdp-discount-applied', 'true');
    });

    var allComparePdp = document.querySelectorAll('product-price .compare-at-price--pdp');
    if (!allComparePdp.length) {
        allComparePdp = document.querySelectorAll('.price-stack--pdp .compare-at-price--pdp');
    }
    allComparePdp.forEach(function (comparePricePDP) {
        if (comparePricePDP.closest && comparePricePDP.closest('.celso-discount-badge')) return;
        if (isPdpBadgePriceNode(comparePricePDP)) return;
        const compareValue = comparePricePDP.querySelector('.compare-at-price-value');
        if (hasCompareDisplay && compareFormatted && compareValue) {
            compareValue.textContent = compareFormatted.integer + ',' + compareFormatted.decimals;
            comparePricePDP.style.display = '';
            comparePricePDP.removeAttribute('hidden');
        } else {
            comparePricePDP.style.display = 'none';
            comparePricePDP.setAttribute('hidden', '');
        }
    });

    if (typeof window !== 'undefined' && typeof window.__celsoForceRefreshFloatingCta === 'function') {
        try {
            window.__celsoForceRefreshFloatingCta();
        } catch (e) {}
    }
}

// ========================================
// ADICIONAR AO CARRINHO
// ========================================

const OPEN_CART_DRAWER_SESSION_KEY = 'celso:open-cart-drawer';
const THEME_PREVIEW_QUERY_PARAMS = ['preview_theme_id', 'preview_script_id', '_ab', '_fd', '_sc', 'pb', 'oseid'];
let enrollmentHomeRedirectScheduled = false;

function normalizeStorefrontPath(pathname) {
    const path = String(pathname || '/');
    if (path.length > 1 && path.endsWith('/')) return path.slice(0, -1);
    return path || '/';
}

function isCurrentPageHome() {
    try {
        const homeUrl = new URL(enrollPopupLiquidConfig.homeUrl || '/', window.location.origin);
        return normalizeStorefrontPath(window.location.pathname) === normalizeStorefrontPath(homeUrl.pathname);
    } catch (error) {
        return false;
    }
}

function shouldRedirectHomeWithOpenCart() {
    if (enrollPopupLiquidConfig.redirectHomeWithCartOnComplete !== true) return false;
    if (window.Shopify && window.Shopify.designMode) return false;
    if (isCurrentPageHome()) return false;
    return true;
}

function buildEnrollmentHomeUrl() {
    const homeUrl = new URL(enrollPopupLiquidConfig.homeUrl || '/', window.location.origin);

    try {
        const currentParams = new URLSearchParams(window.location.search);
        THEME_PREVIEW_QUERY_PARAMS.forEach((key) => {
            const value = currentParams.get(key);
            if (value) homeUrl.searchParams.set(key, value);
        });
    } catch (error) {}

    return homeUrl;
}

function scheduleEnrollmentHomeRedirect() {
    if (enrollmentHomeRedirectScheduled) return;
    enrollmentHomeRedirectScheduled = true;

    const homeUrl = buildEnrollmentHomeUrl();
    let persisted = false;

    try {
        sessionStorage.setItem(OPEN_CART_DRAWER_SESSION_KEY, '1');
        persisted = true;
    } catch (error) {}

    if (!persisted) {
        homeUrl.searchParams.set('open_cart', '1');
    }

    window.location.replace(homeUrl.toString());
}

function varianteEstaNoCarrinho(cart, variantId) {
    if (!variantId || !cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(item => String(item.variant_id) === String(variantId));
}

function resolverOriginPoloParaRedirecionamento(cart, poloIdAdicionado) {
    const storedOriginPoloId = getStoredOriginPoloId();
    if (!storedOriginPoloId) return '';
    if (normalizePoloId(poloIdAdicionado) === storedOriginPoloId) return storedOriginPoloId;
    if (cartHasOriginPoloItem(cart, storedOriginPoloId)) return storedOriginPoloId;
    return '';
}

function enviarComplementoCarrinhoMatricula({
    notaAtual,
    dataNascimentoPedido,
    originPoloIdPedido
}) {
    const payload = {};

    if (dataNascimentoPedido) {
        payload.note = montarNotaPedidoComDataNascimento(notaAtual, dataNascimentoPedido);
    }
    if (originPoloIdPedido) {
        payload.attributes = { origin_polo_id: originPoloIdPedido };
    }
    if (!payload.note && !payload.attributes) return;

    const cartUpdateUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url) || '/cart/update.js';

    try {
        fetch(cartUpdateUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
            keepalive: true,
            body: JSON.stringify(payload)
        }).catch((error) => {
            console.warn('Falha ao complementar o carrinho antes do redirecionamento:', error);
        });
    } catch (error) {
        console.warn('Falha ao complementar o carrinho antes do redirecionamento:', error);
    }
}

async function adicionarAoCarrinho() {
    try {
        const redirectHomeWithOpenCart = shouldRedirectHomeWithOpenCart();
        const formData = new FormData();
        formData.append('id', dadosMatricula.variantId);
        formData.append('quantity', '1');

        const variantIdStr = dadosMatricula.variantId?.toString() || '';
        const carrinhoAtual = await lerCarrinhoAtual();
        if (varianteEstaNoCarrinho(carrinhoAtual, variantIdStr)) {
            alert('Você já possui este curso no carrinho. Remova o item antes de adicionar novamente.');
            return false;
        }

        const nome = typeof dadosMatricula.nome === 'string' ? dadosMatricula.nome.trim() : '';
        const email = normalizarCampoCadastro(dadosMatricula.email);
        const celular = typeof dadosMatricula.celular === 'string' ? dadosMatricula.celular.trim() : '';
        const poloIdMatricula = getPoloIdDaMatricula();

        if (nome) formData.append('properties[Nome]', nome);
        if (email) formData.append('properties[E-mail]', email);
        if (celular) formData.append('properties[Celular]', celular);

        formData.append('properties[Forma de Ingresso]', dadosMatricula.formaIngresso);

        if (dadosMatricula.polo) formData.append('properties[Polo]', dadosMatricula.polo);
        if (poloIdMatricula) formData.append('properties[ID do Polo]', poloIdMatricula);
        if (dadosMatricula.dataNascimento) formData.append('properties[Data de Nascimento]', dadosMatricula.dataNascimento);
        if (dadosMatricula.cpf) formData.append('properties[CPF]', dadosMatricula.cpf);
        if (dadosMatricula.cep) formData.append('properties[CEP]', dadosMatricula.cep);
        if (dadosMatricula.estadoEndereco) formData.append('properties[Estado (Endereço)]', dadosMatricula.estadoEndereco);
        if (dadosMatricula.cidadeEndereco) formData.append('properties[Cidade (Endereço)]', dadosMatricula.cidadeEndereco);
        if (dadosMatricula.bairro) formData.append('properties[Bairro]', dadosMatricula.bairro);
        if (dadosMatricula.rua) formData.append('properties[Rua]', dadosMatricula.rua);
        if (dadosMatricula.numero) formData.append('properties[Número]', dadosMatricula.numero);
        if (dadosMatricula.complemento) formData.append('properties[Complemento]', dadosMatricula.complemento);

        const consultor = normalizarCampoCadastro(dadosMatricula.consultor || '');
        if (consultor) formData.append('properties[consultor]', consultor);

        if (dadosMatricula.turno) formData.append('properties[Turno]', dadosMatricula.turno);

        const modalidadeProp = dadosMatricula.modalidade || localStorage.getItem('modalidadeSelecionada') || '';
        if (modalidadeProp) formData.append('properties[Modalidade]', modalidadeProp);

        // Resolve cupom exatamente pela variante selecionada (mesma engine da tarja), sem depender de sessão global.
        const pdpOcultaCupons = typeof shouldHidePdpCouponBadges === 'function' && shouldHidePdpCouponBadges();
        if (pdpOcultaCupons) {
            clearPdpCouponDataForHiddenBadges();
        }
        const varianteParaCupom = obterVariantePorId(dadosMatricula.variantId);
        const discountBadge = pdpOcultaCupons ? null : document.querySelector('.celso-discount-badge');
        const couponSessionData = pdpOcultaCupons ? null : obterDadosCupomAtivoDaSessao();
        const couponCodeElement = getPdpBadgeCodeElement(discountBadge);
        const badgeCouponCode = couponCodeElement?.textContent?.trim() || '';

        // ✅ Extrai o parâmetro ?coupon da URL (prioridade máxima)
        let couponFromUrl = '';
        try {
            const urlParams = new URLSearchParams(window.location.search);
            couponFromUrl = urlParams.get('coupon') || '';
            if (couponFromUrl) {
                couponFromUrl = couponFromUrl.trim();
            }
        } catch (e) {}

        let cupomAplicaNaVariante = null;
        let resolvedCouponCode = '';

        // Se houver ?coupon na URL, usa com prioridade máxima
        if (!pdpOcultaCupons && couponFromUrl && varianteParaCupom && CelsoCupom) {
            const cupomJson = CelsoCupom.obterCupomJsonVariante(varianteParaCupom);
            cupomAplicaNaVariante = CelsoCupom.localizarCupomNoJson(cupomJson, couponFromUrl);
            if (cupomAplicaNaVariante) {
                resolvedCouponCode = couponFromUrl;
            }
        }

        // Se não achou pelo ?coupon, tenta resolver pela variante normalmente
        if (!pdpOcultaCupons && !cupomAplicaNaVariante && varianteParaCupom && CelsoCupom && typeof CelsoCupom.resolveBestCouponForVariant === 'function') {
            const candidates = typeof CelsoCupom.getCouponCandidates === 'function'
                ? (CelsoCupom.getCouponCandidates() || [])
                : [];
            const resolvedForVariant = CelsoCupom.resolveBestCouponForVariant(varianteParaCupom, candidates);
            if (resolvedForVariant && resolvedForVariant.entry) {
                cupomAplicaNaVariante = resolvedForVariant.entry;
                resolvedCouponCode = resolvedForVariant.code || (resolvedForVariant.entry.cupom ? String(resolvedForVariant.entry.cupom) : '');
            }
        }

        // Fallbacks defensivos (ordem de prioridade menor que o resolvedor por variante).
        if (!pdpOcultaCupons && !cupomAplicaNaVariante && varianteParaCupom && CelsoCupom) {
            const cupomJson = CelsoCupom.obterCupomJsonVariante(varianteParaCupom);
            const codeFromFallback =
                badgeCouponCode
                || (couponSessionData && couponSessionData.code)
                || '';
            cupomAplicaNaVariante = codeFromFallback
                ? CelsoCupom.localizarCupomNoJson(cupomJson, codeFromFallback)
                : null;
            if (!resolvedCouponCode && codeFromFallback) {
                resolvedCouponCode = codeFromFallback;
            }
        }

        if (!resolvedCouponCode && cupomAplicaNaVariante && cupomAplicaNaVariante.cupom) {
            resolvedCouponCode = String(cupomAplicaNaVariante.cupom);
        }

        const cupomLocalJaCompleto = resolvedCouponCode && String(resolvedCouponCode).includes('-');
        if (!(redirectHomeWithOpenCart && cupomLocalJaCompleto) && !pdpOcultaCupons && varianteParaCupom && CelsoCupom && typeof CelsoCupom.resolveApplicableShopifyCodeForVariant === 'function') {
            const candidatesParaApp = typeof CelsoCupom.getCouponCandidates === 'function'
                ? (CelsoCupom.getCouponCandidates() || [])
                : [];
            const shopifyCode = await CelsoCupom.resolveApplicableShopifyCodeForVariant(
                varianteParaCupom,
                candidatesParaApp,
                { hint: resolvedCouponCode || couponFromUrl || badgeCouponCode || '' }
            );
            if (shopifyCode) {
                resolvedCouponCode = shopifyCode;
            }
        }

        if (discountBadge && cupomAplicaNaVariante) {
            const varianteSelecionada = obterVariantePorId(dadosMatricula.variantId);

            // Fonte única: calcula a 1ª mensalidade pela mesma regra central da tarja (evita divergência 95,83 x 97,43).
            const primeiraMensalidade =
                varianteSelecionada
                && CelsoCupom
                && typeof CelsoCupom.resolverValorPrimeiraMensalidade === 'function'
                    ? CelsoCupom.resolverValorPrimeiraMensalidade(varianteSelecionada, cupomAplicaNaVariante)
                    : null;
            if (primeiraMensalidade && primeiraMensalidade.valorFormatado) {
                formData.append('properties[Primeira mensalidade]', primeiraMensalidade.valorFormatado);
            } else {
                // Fallback legado: mantém compatibilidade quando o resolvedor central não retornar valor.
                const priceSpan = getPdpBadgePriceElement(discountBadge);
                if (priceSpan && priceSpan.textContent.trim()) {
                    const discountPrice = priceSpan.textContent.trim();
                    formData.append('properties[Primeira mensalidade]', discountPrice);
                }
            }

            const demaisMensalidades = resolverValorDemaisMensalidades(
                varianteSelecionada,
                resolvedCouponCode,
                couponSessionData
            );

            if (demaisMensalidades) {
                let valorDemaisMensalidades = demaisMensalidades.valorFormatado;
                if (typeof demaisMensalidades.percentual === 'number') {
                    valorDemaisMensalidades = `${valorDemaisMensalidades}`;
                }

                formData.append('properties[Preço das demais mensalidades]', valorDemaisMensalidades);
            }
        }

        const varianteSelecionada = obterVariantePorId(dadosMatricula.variantId);

        // ✅ Cupom do custom.cupom_json (id + nome) – usa CelsoCupom quando disponível
        let cupomAtivo = null;

        if (!pdpOcultaCupons && varianteSelecionada && CelsoCupom) {
            const cupomJson = CelsoCupom.obterCupomJsonVariante(varianteSelecionada);
            cupomAtivo = CelsoCupom.localizarCupomNoJson(cupomJson, resolvedCouponCode);
        }

        sincronizarCupomMatriculaAtual();
        if (resolvedCouponCode) {
            dadosMatricula.cupomCodigo = resolvedCouponCode;
        }
        if (!dadosMatricula.cupomId && cupomAtivo && cupomAtivo.id) {
            dadosMatricula.cupomId = String(cupomAtivo.id);
        }
        if (!dadosMatricula.cupomNome && cupomAtivo && cupomAtivo.cupom) {
            dadosMatricula.cupomNome = String(cupomAtivo.cupom);
        }

        if (dadosMatricula.cupomNome) {
            formData.append('properties[Cupom aplicado]', dadosMatricula.cupomNome);
        }
        if (dadosMatricula.cupomCodigo) {
            formData.append('properties[Codigo do cupom]', dadosMatricula.cupomCodigo);
        }
        const dataNascimentoPedido = formatarDataNascimentoParaPedido(dadosMatricula.dataNascimento);
        const tipoCursoPedido = (dadosMatricula.nivelEnsino || activeProductFormacao || '').trim();
        const skuPoloPedido = resolveSkuPoloSelecionado();
        const matriculaAttributeIdentifier = getMatriculaAttributeIdentifier({
            codCurso: dadosMatricula.codCurso,
            varianteSku: dadosMatricula.varianteSku,
            variantId: dadosMatricula.variantId
        });
        const atributosMatriculaPedido = buildMatriculaCartAttributes({
            nomeCurso: activeProductTitle,
            estado: dadosMatricula.estado,
            cidade: dadosMatricula.cidade,
            polo: dadosMatricula.polo,
            poloId: poloIdMatricula,
            codCurso: dadosMatricula.codCurso,
            varianteSku: dadosMatricula.varianteSku,
            variantId: dadosMatricula.variantId,
            skuPolo: skuPoloPedido
        });
        if (matriculaAttributeIdentifier) {
            formData.append('properties[_matricula_attribute_identifier]', matriculaAttributeIdentifier);
        }
        if (dataNascimentoPedido) {
            formData.append('attributes[Data de Nascimento]', dataNascimentoPedido);
        }
        if (tipoCursoPedido) {
            formData.append('attributes[Tipo do Curso]', tipoCursoPedido);
        }
        Object.entries(atributosMatriculaPedido).forEach(([key, value]) => {
            formData.append(`attributes[${key}]`, value);
        });
        const sectionIds = [];
        if (!redirectHomeWithOpenCart) {
            document.querySelectorAll('cart-items-component').forEach(item => {
                if (item instanceof HTMLElement && item.dataset.sectionId) {
                    sectionIds.push(item.dataset.sectionId);
                }
            });
        }

        if (sectionIds.length > 0) {
            formData.append('sections', sectionIds.join(','));
            formData.append('sections_url', window.location.pathname);
        }

        const cartAddUrl =
            (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

        const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Accept': 'text/html' },
            body: formData,
            credentials: 'same-origin'
        });

        if (!response.ok) {
            alert('Erro ao adicionar ao carrinho. Tente novamente.');
            return false;
        }

        const data = await response.json();

        if (data.status) {
            alert(data.message || 'Erro ao adicionar ao carrinho.');
            return false;
        }

        let originPoloIdPedido = '';

        if (redirectHomeWithOpenCart) {
            const notaAtual = carrinhoAtual && typeof carrinhoAtual.note === 'string' ? carrinhoAtual.note : '';
            originPoloIdPedido = resolverOriginPoloParaRedirecionamento(carrinhoAtual, poloIdMatricula);
            enviarComplementoCarrinhoMatricula({
                notaAtual,
                dataNascimentoPedido,
                originPoloIdPedido
            });
        } else {
            if (dataNascimentoPedido || tipoCursoPedido || Object.keys(atributosMatriculaPedido).length) {
                try {
                    await atualizarAtributosPedidoMatricula({
                        dataNascimento: dataNascimentoPedido,
                        tipoCurso: tipoCursoPedido,
                        nomeCurso: activeProductTitle,
                        estado: dadosMatricula.estado,
                        cidade: dadosMatricula.cidade,
                        polo: dadosMatricula.polo,
                        poloId: poloIdMatricula,
                        codCurso: dadosMatricula.codCurso,
                        varianteSku: dadosMatricula.varianteSku,
                        variantId: dadosMatricula.variantId,
                        skuPolo: skuPoloPedido
                    });
                } catch (error) {
                    console.warn('Falha ao atualizar atributos da matricula no carrinho:', error);
                }
            }

            try {
                originPoloIdPedido = await sincronizarOriginPoloIdNoCarrinho();
            } catch (error) {
                console.warn('Falha ao sincronizar origin_polo_id no carrinho:', error);
            }
        }

        const enderecoCompleto = [
            dadosMatricula.rua,
            dadosMatricula.numero,
            dadosMatricula.complemento || null,
            dadosMatricula.bairro,
            dadosMatricula.cidadeEndereco,
            dadosMatricula.estadoEndereco,
            dadosMatricula.cep
        ].filter(Boolean).join(', ');

        sincronizarCupomMatriculaAtual();

        const stepUtmContent = getModalStepUtmContent(3);
        const modalTrackingPayload = buildModalTrackingPayload({
            utm_content: stepUtmContent
        });
        const payloadSnowlink = Object.assign({}, modalTrackingPayload, {
            email: dadosMatricula.email,
            vendedor_origem: resolvePoloIdSelecionado(),
            vendedor_origem_url: getVendedorOrigemUrl(stepUtmContent),
            nascimento: dadosMatricula.dataNascimento,
            variante_sku: dadosMatricula.varianteSku || '',
            sku_polo: skuPoloPedido,
            codCurso: dadosMatricula.codCurso || '',
            nome: dadosMatricula.nome || '',
            celular: normalizarTelefoneParaEnvio(dadosMatricula.celular || ''),
            telefone: normalizarTelefoneParaEnvio(dadosMatricula.celular || ''),
            forma_ingresso: dadosMatricula.formaIngresso || '',
            nivel_ensino: dadosMatricula.nivelEnsino || '',
            consultor: consultor || '',
            cupom_id: dadosMatricula.cupomId || '',
            cupom_nome: dadosMatricula.cupomNome || '',
            codPolo: poloIdMatricula || '',
            formacao: modalTrackingPayload.formacao || '',
            area: modalTrackingPayload.area || '',
            curso: modalTrackingPayload.curso || '',
            modalidade: modalTrackingPayload.modalidade || '',
            polo_estado: dadosMatricula.estado || '',
            polo_cidade: dadosMatricula.cidade || '',
            polo: dadosMatricula.polo || '',
            cpf: dadosMatricula.cpf || '',
            cep: dadosMatricula.cep || '',
            estado: dadosMatricula.estadoEndereco || '',
            cidade: dadosMatricula.cidadeEndereco || '',
            bairro: dadosMatricula.bairro || '',
            rua: dadosMatricula.rua || '',
            numero: dadosMatricula.numero || '',
            ...(dadosMatricula.complemento ? { complemento: dadosMatricula.complemento } : {}),
            endereco_completo: enderecoCompleto
        });

        if (redirectHomeWithOpenCart) {
            void newRegisterRaw(payloadSnowlink, { keepalive: true });
        } else {
            await newRegisterRaw(payloadSnowlink);
        }



        const checkoutPrefillData = {
            email: dadosMatricula.email || '',
            nome: dadosMatricula.nome || '',
            celular: dadosMatricula.celular || '',
            updatedAt: Date.now()
        };
        localStorage.setItem('checkoutPrefillData', JSON.stringify(checkoutPrefillData));
        localStorage.removeItem('dadosMatricula');

        if (!redirectHomeWithOpenCart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                    resource: data,
                    sourceId: dadosMatricula.variantId?.toString() || '',
                    data: {
                        didError: false,
                        source: 'product-form-component',
                        itemCount: 1,
                        variantId: dadosMatricula.variantId?.toString(),
                        sections: data.sections
                    },
                },
            }));
        }

        // Salvar dados de endereço para pré-preenchimento no checkout
        const nomeCompleto = (dadosMatricula.nome || '').trim();
        const nomeParts = nomeCompleto.split(' ');
        const firstName = nomeParts[0] || '';
        const lastName = nomeParts.slice(1).join(' ') || '';
        const address1 = [dadosMatricula.rua, dadosMatricula.numero].filter(Boolean).join(', ');

        const checkoutBillingPrefill = {
            email:     dadosMatricula.email || '',
            firstName: firstName,
            lastName:  lastName,
            address1:  address1,
            phone:     normalizarTelefoneParaEnvio(dadosMatricula.celular || ''),

            city:      dadosMatricula.cidadeEndereco || '',
            province:  dadosMatricula.estadoEndereco || '',
            zip:       dadosMatricula.cep || '',
            country:   'BR',
            savedAt:   Date.now()
        };
        localStorage.setItem('checkoutBillingPrefill', JSON.stringify(checkoutBillingPrefill));

        // Pré-montar URL direta do checkout para evitar requisição extra ao clicar em "Finalizar compra"
        try {
            const variantId = dadosMatricula.variantId;
            if (variantId) {
                const prefillParts = [];
                if (checkoutBillingPrefill.email)     prefillParts.push(`checkout[email]=${encodeURIComponent(checkoutBillingPrefill.email)}`);
                if (checkoutBillingPrefill.firstName) prefillParts.push(`checkout[billing_address][first_name]=${encodeURIComponent(checkoutBillingPrefill.firstName)}`);
                if (checkoutBillingPrefill.lastName)  prefillParts.push(`checkout[billing_address][last_name]=${encodeURIComponent(checkoutBillingPrefill.lastName)}`);
                if (checkoutBillingPrefill.address1)  prefillParts.push(`checkout[billing_address][address1]=${encodeURIComponent(checkoutBillingPrefill.address1)}`);
                if (checkoutBillingPrefill.phone)     prefillParts.push(`checkout[billing_address][phone]=${encodeURIComponent(checkoutBillingPrefill.phone)}`);

                if (checkoutBillingPrefill.city)      prefillParts.push(`checkout[billing_address][city]=${encodeURIComponent(checkoutBillingPrefill.city)}`);
                if (checkoutBillingPrefill.province)  prefillParts.push(`checkout[billing_address][province]=${encodeURIComponent(checkoutBillingPrefill.province)}`);
                if (checkoutBillingPrefill.zip)       prefillParts.push(`checkout[billing_address][zip]=${encodeURIComponent(checkoutBillingPrefill.zip)}`);
                prefillParts.push('checkout[billing_address][country]=BR');
                if (dataNascimentoPedido) {
                    prefillParts.push(`note=${encodeURIComponent(`data_de_nascimento:${dataNascimentoPedido}`)}`);
                    prefillParts.push(`attributes[Data de Nascimento]=${encodeURIComponent(dataNascimentoPedido)}`);
                }
                if (tipoCursoPedido) {
                    prefillParts.push(`attributes[Tipo do Curso]=${encodeURIComponent(tipoCursoPedido)}`);
                }
                Object.entries(atributosMatriculaPedido).forEach(([key, value]) => {
                    prefillParts.push(`attributes[${encodeURIComponent(key)}]=${encodeURIComponent(value)}`);
                });
                if (originPoloIdPedido) {
                    prefillParts.push(`attributes[origin_polo_id]=${encodeURIComponent(originPoloIdPedido)}`);
                }
                const shopPermanentDomain = enrollPopupLiquidConfig.shopPermanentDomain || window.location.host;
                localStorage.setItem('checkoutDirectUrl', `https://${shopPermanentDomain}/cart/${variantId}:1?${prefillParts.join('&')}`);
            }
        } catch (e) {}

        atualizarUtmContentModalNaUrl(4);

        if (redirectHomeWithOpenCart) {
            try {
                if (typeof mixpanel !== 'undefined' && typeof mixpanel.set_config === 'function') {
                    mixpanel.set_config({ api_transport: 'sendBeacon' });
                }
            } catch (error) {}
        }

        const cartDrawer = document.querySelector('cart-drawer-component');
        trackModalCheckoutRedirect({
            coupon_code: dadosMatricula.cupomCodigo || '',
            utm_content: getModalStepUtmContent(4),
            vendedor_origem: poloIdMatricula,
            vendedor_origem_url: getVendedorOrigemUrl(4)
        });
        if (!redirectHomeWithOpenCart) {
            cartDrawer?.open?.();
        }

        trackSignupStep('Signup Step Completed', 3, {
            coupon_code: dadosMatricula.cupomCodigo || ''
        });
        // Não há uma etapa 4 renderizada dentro do popup: ao fechar aqui o
        // usuário segue para o carrinho/checkout nativo do Shopify, então
        // "Pagamento" é considerado visto neste ponto de handoff.
        trackSignupStep('Signup Step Viewed', 4);

        fecharPopup();

        if (redirectHomeWithOpenCart) {
            scheduleEnrollmentHomeRedirect();
            return true;
        }

        setTimeout(function () {
            if (typeof corrigirTarjaRosaPrimeiraMensalidade === 'function') {
                corrigirTarjaRosaPrimeiraMensalidade({ mostrarAoCorrigir: true });
            }
            if (typeof window.aplicarVisibilidadeTarjaConformeCupomNaUrlPDP === 'function') {
                window.aplicarVisibilidadeTarjaConformeCupomNaUrlPDP();
            }
        }, 150);

        return true;

    } catch (error) {
        console.error('Erro:', error);
        alert('Erro ao processar. Tente novamente.');
        return false;
    }
}

async function lerCarrinhoAtual() {
    try {
        const cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
        const endpoint = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl}.js`;
        const response = await fetch(endpoint, { credentials: 'same-origin', cache: 'no-store' });

        if (!response.ok) return null;
        return await response.json();
    } catch (error) {
        console.warn('Não foi possível verificar o carrinho antes de adicionar:', error);
        return null;
    }
}

async function verificarVarianteJaNoCarrinho(variantId) {
    const cart = await lerCarrinhoAtual();
    return varianteEstaNoCarrinho(cart, variantId);
}



// ========================================
// BOTÕES
// ========================================

// Não fecha ao clicar no overlay (background).
// O fechamento deve acontecer somente via botão "X" ou tecla ESC.

document.addEventListener('keydown', function(e) {
    const key = e.key || e.code;
    if (key !== 'Escape' && key !== 'Esc') return;

    const popup = document.querySelector('.product-enroll-popup');
    if (!popup) return;

    if (popup.classList.contains('click-button-active')) {
        fecharPopup();
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const btnMatricular = document.querySelector('.btn-matricular');
    if (btnMatricular) {
        btnMatricular.addEventListener('click', function() {
            window.abrirPopupMatricula?.();
        });
    }
});

function createEnrollPopupRegistry() {
    const configs = new Map();
    const productJsonRequests = new Map();
    const productPageRequests = new Map();
    let activeId = null;

    function variantHasDateMetadata(variant) {
        if (!variant || typeof variant !== 'object') return false;
        const startRaw = coerceDateString(variant.start_date);
        const endRaw = coerceDateString(variant.end_date);
        return Boolean(startRaw || endRaw || typeof variant.startDateMs === 'number' || typeof variant.endDateMs === 'number');
    }

    function mergeVariantDateMetadata(nextVariant, previousVariant) {
        if (!nextVariant || typeof nextVariant !== 'object') return nextVariant;
        if (!previousVariant || typeof previousVariant !== 'object') return nextVariant;
        if (variantHasDateMetadata(nextVariant) || !variantHasDateMetadata(previousVariant)) {
            return nextVariant;
        }
        return Object.assign({}, nextVariant, {
            start_date: nextVariant.start_date ?? previousVariant.start_date ?? null,
            end_date: nextVariant.end_date ?? previousVariant.end_date ?? null,
            startDateMs: (typeof nextVariant.startDateMs === 'number') ? nextVariant.startDateMs : previousVariant.startDateMs,
            endDateMs: (typeof nextVariant.endDateMs === 'number') ? nextVariant.endDateMs : previousVariant.endDateMs
        });
    }

    function mergeConfigDateMetadata(nextConfig, previousConfig) {
        if (!nextConfig || typeof nextConfig !== 'object') return nextConfig;
        const nextVariants = Array.isArray(nextConfig.variants) ? nextConfig.variants : null;
        const prevVariants = Array.isArray(previousConfig?.variants) ? previousConfig.variants : null;
        if (!nextVariants || !prevVariants || !prevVariants.length) {
            return nextConfig;
        }
        const previousById = new Map(
            prevVariants
                .filter((variant) => variant && variant.id !== undefined && variant.id !== null)
                .map((variant) => [String(variant.id), variant])
        );
        const mergedVariants = nextVariants.map((variant) => {
            if (!variant || variant.id === undefined || variant.id === null) return variant;
            const previousVariant = previousById.get(String(variant.id));
            return mergeVariantDateMetadata(variant, previousVariant);
        });
        return Object.assign({}, nextConfig, { variants: mergedVariants });
    }

    function mergeConfigCompleteness(nextConfig, previousConfig) {
        if (!nextConfig || typeof nextConfig !== 'object') return nextConfig;
        if (!previousConfig || typeof previousConfig !== 'object') return nextConfig;

        const mergedConfig = mergeConfigDateMetadata(nextConfig, previousConfig);
        const nextOptionNames = Array.isArray(mergedConfig.optionNames) ? mergedConfig.optionNames : [];
        const prevOptionNames = Array.isArray(previousConfig.optionNames) ? previousConfig.optionNames : [];
        const nextVariants = Array.isArray(mergedConfig.variants) ? mergedConfig.variants : [];
        const prevVariants = Array.isArray(previousConfig.variants) ? previousConfig.variants : [];

        if (!nextOptionNames.length && prevOptionNames.length) {
            mergedConfig.optionNames = prevOptionNames.slice();
        }

        if (prevVariants.length > nextVariants.length && (!nextOptionNames.length || nextVariants.length <= 1)) {
            mergedConfig.variants = prevVariants.slice();
        }

        return mergedConfig;
    }

    function getResolvedConfig(id) {
        let config = configs.get(id);
        const shelfConfig = window.CelsoShelfConfigs && window.CelsoShelfConfigs[id];
        if (shelfConfig) {
            config = config ? mergeConfigCompleteness(shelfConfig, config) : shelfConfig;
            configs.set(id, config);
        }
        return config;
    }

    function configNeedsProductJsonHydration(config) {
        if (!config || !config.productHandle) return false;
        const optionNames = Array.isArray(config.optionNames) ? config.optionNames : [];
        const variants = Array.isArray(config.variants) ? config.variants : [];
        // Produtos com uma única variante já podem ter sido serializados por completo no card.
        return !optionNames.length || !variants.length;
    }

    function configNeedsProductPageHydration(config) {
        return configNeedsProductJsonHydration(config);
    }

    function getProductJsonUrl(handle) {
        const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
        return `${normalizedRoot}products/${encodeURIComponent(handle)}.js`;
    }

    function getProductPageUrl(handle) {
        const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
        return `${normalizedRoot}products/${encodeURIComponent(handle)}`;
    }

    function extractBalancedObjectLiteral(source, startIndex) {
        const openIndex = source.indexOf('{', startIndex);
        if (openIndex < 0) return '';

        let depth = 0;
        let quote = '';
        let escaped = false;

        for (let i = openIndex; i < source.length; i++) {
            const char = source[i];

            if (quote) {
                if (escaped) {
                    escaped = false;
                } else if (char === '\\') {
                    escaped = true;
                } else if (char === quote) {
                    quote = '';
                }
                continue;
            }

            if (char === '"' || char === "'" || char === '`') {
                quote = char;
                continue;
            }

            if (char === '{') {
                depth += 1;
            } else if (char === '}') {
                depth -= 1;
                if (depth === 0) {
                    return source.slice(openIndex, i + 1);
                }
            }
        }

        return '';
    }

    function parseInitialProductConfigFromHtml(html) {
        if (typeof html !== 'string') return null;
        try {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const configElement = doc.querySelector('[data-enroll-popup-config]');
            if (configElement) {
                const config = JSON.parse(configElement.textContent || '{}');
                return config && config.product ? config.product : null;
            }
        } catch (error) {
            console.warn('Não foi possível parsear a configuração JSON da página do produto:', error);
        }

        const marker = 'const initialProductConfig';
        const markerIndex = html.indexOf(marker);
        if (markerIndex < 0) return null;

        const objectLiteral = extractBalancedObjectLiteral(html, markerIndex);
        if (!objectLiteral) return null;

        try {
            return Function(`"use strict"; return (${objectLiteral});`)();
        } catch (error) {
            console.warn('Não foi possível parsear initialProductConfig da página do produto:', error);
            return null;
        }
    }

    function normalizeProductJsonConfig(productJson, previousConfig) {
        if (!productJson || typeof productJson !== 'object') return previousConfig;

        const optionNames = Array.isArray(productJson.options)
            ? productJson.options.map((option) => {
                if (typeof option === 'string') return option;
                return option && option.name ? option.name : '';
            }).filter(Boolean)
            : [];

        const previousVariants = Array.isArray(previousConfig?.variants) ? previousConfig.variants : [];
        const previousById = new Map(
            previousVariants
                .filter((variant) => variant && variant.id !== undefined && variant.id !== null)
                .map((variant) => [String(variant.id), variant])
        );

        const variants = Array.isArray(productJson.variants)
            ? productJson.variants.map((variant) => {
                const previousVariant = previousById.get(String(variant.id)) || {};
                return Object.assign({}, previousVariant, {
                    id: variant.id,
                    sku: variant.sku || previousVariant.sku || '',
                    title: variant.title || previousVariant.title || '',
                    price: Number(variant.price || previousVariant.price || 0),
                    compare_at_price: Number(variant.compare_at_price || previousVariant.compare_at_price || 0),
                    option1: variant.option1 ?? previousVariant.option1 ?? null,
                    option2: variant.option2 ?? previousVariant.option2 ?? null,
                    option3: variant.option3 ?? previousVariant.option3 ?? null,
                    options: Array.isArray(variant.options) ? variant.options : previousVariant.options,
                    available: typeof variant.available === 'boolean' ? variant.available : previousVariant.available
                });
            })
            : previousVariants;

        return mergeConfigCompleteness(Object.assign({}, previousConfig, {
            productId: String(productJson.id || previousConfig?.productId || ''),
            optionNames: optionNames.length ? optionNames : previousConfig?.optionNames,
            variants: variants.length ? variants : previousVariants,
            precoBase: Number(productJson.price || previousConfig?.precoBase || 0),
            productTitle: productJson.title || previousConfig?.productTitle || '',
            productHandle: productJson.handle || previousConfig?.productHandle || ''
        }), previousConfig);
    }

    function hydrateConfigFromProductJson(config) {
        if (!configNeedsProductJsonHydration(config)) return Promise.resolve(config);
        const handle = String(config.productHandle || '').trim();
        if (!handle) return Promise.resolve(config);

        if (!productJsonRequests.has(handle)) {
            productJsonRequests.set(handle, fetch(getProductJsonUrl(handle), { credentials: 'same-origin' })
                .then((response) => {
                    if (!response.ok) throw new Error(`HTTP ${response.status}`);
                    return response.json();
                }));
        }

        return productJsonRequests.get(handle)
            .then((productJson) => normalizeProductJsonConfig(productJson, config))
            .catch((error) => {
                console.warn('Não foi possível hidratar config do produto pelo JSON:', handle, error);
                return config;
            });
    }

    function hydrateConfigFromProductPage(config) {
        if (!configNeedsProductPageHydration(config)) return Promise.resolve(config);
        const handle = String(config.productHandle || '').trim();
        if (!handle) return Promise.resolve(config);

        if (!productPageRequests.has(handle)) {
            productPageRequests.set(handle, fetch(getProductPageUrl(handle), { credentials: 'same-origin' })
                .then((response) => {
                    if (!response.ok) throw new Error(`HTTP ${response.status}`);
                    return response.text();
                }));
        }

        return productPageRequests.get(handle)
            .then((html) => {
                const productPageConfig = parseInitialProductConfigFromHtml(html);
                if (!productPageConfig) return config;
                return mergeConfigCompleteness(productPageConfig, config);
            })
            .catch((error) => {
                console.warn('Não foi possível hidratar config pela página do produto:', handle, error);
                return config;
            });
    }

    function setActive(productId, options = {}) {
        if (!productId) return null;
        setActivePoloFilter(options);
        const id = String(productId);
        const config = getResolvedConfig(id);
        if (!config) {
            console.warn('Configuração de matrícula não encontrada para o produto', productId);
            return null;
        }
        // Sempre resetar Step 2 quando abrir o modal (open), para não carregar polo/turno/variante da seleção anterior (ex.: EAD → Presencial).
        const shouldReset = options.resetSelections !== false;
        applyProductConfig(config, { resetSelections: shouldReset });
        activeId = id;
        return config;
    }

    return {
        register(config, { activate = false } = {}) {
            if (!config || !config.productId) return;
            const id = String(config.productId);
            const existingConfig = configs.get(id);
            const mergedConfig = mergeConfigCompleteness(config, existingConfig);
            configs.set(id, mergedConfig);
            if (activate || !activeId) {
                setActive(id, { resetSelections: true });
            }
        },
        open(productId, options = {}) {
            setActivePoloFilter(options);
            const targetId = productId ? String(productId) : activeId;
            const config = getResolvedConfig(targetId);
            if (!config) {
                setActive(targetId, Object.assign({}, options, { resetSelections: true }));
                return;
            }

            const openWithConfig = (resolvedConfig) => {
                if (resolvedConfig && resolvedConfig.productId) {
                    configs.set(String(resolvedConfig.productId), resolvedConfig);
                }
                const activeConfig = setActive(targetId, Object.assign({}, options, { resetSelections: true }));
                if (!activeConfig) return;
                abrirPopupInterno(options);
            };

            if (configNeedsProductJsonHydration(config)) {
                hydrateConfigFromProductPage(config)
                    .then((pageConfig) => hydrateConfigFromProductJson(pageConfig))
                    .then(openWithConfig);
                return;
            }

            openWithConfig(config);
        },
        setActive(productId, options) {
            return setActive(productId, options);
        },
        getConfig(productId) {
            const id = productId ? String(productId) : activeId;
            return getResolvedConfig(id);
        },
        getActiveProductId() {
            return activeId;
        }
    };
}

(function initializeEnrollRegistry() {
    const existing = window.EnrollPopupRegistry;
    if (!existing || typeof existing.register !== 'function') {
        window.EnrollPopupRegistry = createEnrollPopupRegistry();
    }

    window.EnrollPopupRegistry.register(initialProductConfig, { activate: true });

    if (Array.isArray(window.EnrollPopupPreConfigs) && window.EnrollPopupPreConfigs.length) {
        window.EnrollPopupPreConfigs.forEach((cfg) => {
            window.EnrollPopupRegistry.register(cfg);
        });
    }
    window.EnrollPopupPreConfigs = [];
})();

// PDP: tarja e desconto quando houver cupom (URL ou settings.descontos_json).
(function initPDPCupomUrlDesconto() {
    /** Aplica visibilidade da tarja conforme cupom na URL (igual aos cards). Sem cupom = tarja escondida. */
    function applyTarjaVisibility() {
        if (typeof window.aplicarVisibilidadeTarjaConformeCupomNaUrlPDP === 'function') {
            window.aplicarVisibilidadeTarjaConformeCupomNaUrlPDP();
        }
    }

    var pdpBadgeRefreshTimer = null;

    function run() {
        if (typeof shouldHidePdpCouponBadges === 'function' && shouldHidePdpCouponBadges()) {
            hidePdpCouponBadges('pdp-run:hide-coupon-badges');
            if (typeof aplicarDescontoCupomUrlNaPDP === 'function') {
                aplicarDescontoCupomUrlNaPDP();
            }
            return;
        }
        if (typeof aplicarDescontoCupomUrlNaPDP === 'function') {
            aplicarDescontoCupomUrlNaPDP();
        }
        if (typeof corrigirTarjaRosaPrimeiraMensalidade === 'function') {
            corrigirTarjaRosaPrimeiraMensalidade({ mostrarAoCorrigir: true });
        }
        applyTarjaVisibility();
        if (typeof window !== 'undefined' && typeof window.__celsoForceRefreshFloatingCta === 'function') {
            try {
                window.__celsoForceRefreshFloatingCta();
            } catch (e) {}
        }
    }
    function installPdpBadgeGuard() {
        return;
    }
    function runTarjaCorrection(opcoes) {
        if (typeof corrigirTarjaRosaPrimeiraMensalidade === 'function') {
            corrigirTarjaRosaPrimeiraMensalidade(opcoes || {});
        }
    }
    function hasActiveCouponCandidate() {
        try {
            // Priority: URL (se existir) continua sendo a fonte principal (CelsoCupom já aplica essa prioridade).
            if (typeof CelsoCupom !== 'undefined' && CelsoCupom && typeof CelsoCupom.getCouponCandidates === 'function') {
                var candidates = CelsoCupom.getCouponCandidates() || [];
                if (Array.isArray(candidates) && candidates.length > 0) {
                    if (typeof CelsoCupom.cupomEstaExpirado !== 'function') return true;
                    var ativos = candidates.filter(function (code) { return !CelsoCupom.cupomEstaExpirado(code); });
                    if (ativos.length > 0) return true;
                }
            }
        } catch (e) {}
        // Fallback: se o app já escreveu o código na tarja, consideramos que há cupom ativo.
        try {
            var badge = document.querySelector('.celso-discount-badge');
            var codeEl = badge && badge.querySelector ? badge.querySelector('.celso-discount-badge-code') : null;
            var badgeCode = codeEl && codeEl.textContent ? codeEl.textContent.trim() : '';
            if (!badgeCode) return false;
            if (typeof CelsoCupom !== 'undefined' && CelsoCupom && typeof CelsoCupom.cupomEstaExpirado === 'function') {
                return !CelsoCupom.cupomEstaExpirado(badgeCode);
            }
            return true;
        } catch (e2) {
            return false;
        }
    }

    // Sempre aplicar visibilidade da tarja (com ou sem cupom): sem cupom = esconder, com cupom = mostrar
    applyTarjaVisibility();
    installPdpBadgeGuard();

    function scheduleUnifiedPdpBadgeRefresh(delays, options) {
        if (!isPdpCupomContext()) return;
        if (typeof shouldHidePdpCouponBadges === 'function' && shouldHidePdpCouponBadges()) {
            hidePdpCouponBadges('badge-refresh:hide-coupon-badges');
            if (typeof aplicarDescontoCupomUrlNaPDP === 'function') {
                aplicarDescontoCupomUrlNaPDP();
            }
            return;
        }
        var runDelays = Array.isArray(delays) && delays.length ? delays : [260];
        var finalDelay = Math.max.apply(null, runDelays);
        if (pdpBadgeRefreshTimer) {
            clearTimeout(pdpBadgeRefreshTimer);
            pdpBadgeRefreshTimer = null;
        }
        if (typeof esconderTarjaRosaPreco === 'function') {
            esconderTarjaRosaPreco('badge-refresh:start', { force: true });
        }
        if (typeof window !== 'undefined') {
            window.__celsoPdpBadgeRefreshPendingUntil = Date.now() + finalDelay + 110;
            if (window.__celsoPdpPriceTransitionTimer) {
                clearTimeout(window.__celsoPdpPriceTransitionTimer);
            }
            window.__celsoPdpPriceTransitionTimer = setTimeout(function () {
                setPdpPriceTransitioning(false);
                window.__celsoPdpPriceTransitionTimer = null;
            }, finalDelay + 70);
        }
        setPdpPriceTransitioning(true);
        resetPdpBadgePriceContent('badge-refresh:start');
        pdpBadgeRefreshTimer = setTimeout(function () {
            pdpBadgeRefreshTimer = null;
            run(options || {});
        }, finalDelay);
    }

    if (typeof window !== 'undefined') {
        window.__celsoSchedulePdpBadgeRefresh = scheduleUnifiedPdpBadgeRefresh;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            scheduleUnifiedPdpBadgeRefresh([260], { mostrarAoCorrigir: true });
        });
    } else {
        scheduleUnifiedPdpBadgeRefresh([260], { mostrarAoCorrigir: true });
    }

    window.addEventListener('modalidadeSelecionada', function () {
        if (!document.body.classList.contains('body-product')) return;
        scheduleUnifiedPdpBadgeRefresh([260], { mostrarAoCorrigir: true });
    });

    document.addEventListener('variant:update', function () {
        if (!document.body.classList.contains('body-product')) return;
        scheduleUnifiedPdpBadgeRefresh([80], { mostrarAoCorrigir: true });
    });

    return;

    function scheduleRuns(delays) {
        (delays || [0, 150]).forEach(function (ms) {
            setTimeout(run, ms);
        });
    }
    function scheduleTarjaCorrection() {
        [150].forEach(function (ms) {
            setTimeout(runTarjaCorrection, ms);
        });
    }
    // Ao trocar variante: corrigir tarja e reaplicar visibilidade conforme variante (sem esconder antes para evitar flicker).
    function scheduleTarjaCorrectionOnVariantChange() {
        setTimeout(function () {
            runTarjaCorrection({ mostrarAoCorrigir: true });
            applyTarjaVisibility();
        }, 150);
    }
    // Após F5/carregamento: corrigir e aplicar visibilidade da variante ativa sem esconder previamente.
    function scheduleTarjaOnPageLoad() {
        setTimeout(function () {
            runTarjaCorrection({ mostrarAoCorrigir: true });
            applyTarjaVisibility();
        }, 150);
    }

    // Alguns templates da PDP hidratam blocos após o DOMContentLoaded.
    // Reexecuta a correção após o primeiro paint para evitar estado visual "sem tarja" na entrada.
    function scheduleAfterFirstPaint() {
        if (typeof window === 'undefined' || typeof window.requestAnimationFrame !== 'function') {
            setTimeout(function () {
                run();
                runTarjaCorrection({ mostrarAoCorrigir: true });
                applyTarjaVisibility();
            }, 0);
            return;
        }
        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                run();
                runTarjaCorrection({ mostrarAoCorrigir: true });
                applyTarjaVisibility();
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            scheduleRuns([0, 150]);
            scheduleTarjaCorrection();
            scheduleTarjaOnPageLoad();
            scheduleAfterFirstPaint();
        });
    } else {
        scheduleRuns([0, 150]);
        scheduleTarjaCorrection();
        scheduleTarjaOnPageLoad();
        scheduleAfterFirstPaint();
    }

    window.addEventListener('modalidadeSelecionada', function () {
        if (!document.body.classList.contains('body-product')) return;
        run();
        setTimeout(run, 150);
        scheduleTarjaCorrection();
        scheduleTarjaCorrectionOnVariantChange();
    });

    document.addEventListener('variant:update', function () {
        if (!document.body.classList.contains('body-product')) return;
        run();
        setTimeout(run, 150);
        scheduleTarjaCorrection();
        scheduleTarjaCorrectionOnVariantChange();
    });
})();
